export default {
  en: {
    // Migrated from <i18n> SFC blocks (#6500)
    'print': 'Print',
    'calendar-view': 'Calendar',
    'list-view': 'List',
    'calendar-list-all-day': 'All Day',
    'no-events': 'No events in this period',
    'show-more': 'Show More',
    'show-less': 'Show Less',
    'close-filters': 'Close Filters',
    'open-filters': 'Open Filters',
    'add-subscriptions': 'Add Subscriptions',
    'show': 'Show',
    'more': 'More',
    'subscribe-premium-banner-header': 'Share Calendars is a premium feature',
    'subscribe-premium-banner-description': 'To share calendars, you need to be a premium user.',
    'all-day-label': 'All Day Events',
    'events-title': 'Events',
    'calendar-desktop-view-locations': 'Locations',
    'calendar-desktop-view-create': 'Create Event',
    'calendar-desktop-view-share-calendars': 'Share Calendars',
    'calendar-desktop-view-create-event-premium-banner-header': 'Create Event is a premium feature',
    'calendar-desktop-view-create-event-premium-banner-description': 'To create events, you need to be a premium user.',
    'calendar-desktop-view-manage-calendars-premium-banner-description': 'To add or manage calendars, you need to be a premium user.',
    'calendar-desktop-view-manage-calendars': 'Manage Calendars',
    'calendar-desktop-view-manage-calendars-premium-banner-header': 'Manage Calendars is a premium feature',
    'three-day': '3-Day',
    'calendar-mobile-view-locations': 'Locations',
    'calendar-mobile-view-create': 'Create Event',
    'calendar-mobile-view-share-calendars': 'Share Calendars',
    'calendar-mobile-view-no-events': 'No events',
    'calendar-mobile-view-create-event-premium-banner-header': 'Create Event is a premium feature',
    'calendar-mobile-view-create-event-premium-banner-description': 'To create events, you need to be a premium user.',
    'calendar-mobile-view-manage-calendars-premium-banner-description': 'To add or manage calendars, you need to be a premium user.',
    'calendar-mobile-view-manage-calendars': 'Manage Calendars',
    'calendar-mobile-view-manage-calendars-premium-banner-header': 'Manage Calendars is a premium feature',
    // Migrated from <i18n> SFC blocks (#6500)
    'custom-range': 'Custom Date Range',
    'apply': 'Apply',
    'quick-date-filter-last-week': 'Last Week',
    'quick-date-filter-this-week': 'This Week',
    'quick-date-filter-week-to-date': 'Week to Date',
    'quick-date-filter-this-month': 'This Month',
    'quick-date-filter-month-to-date': 'Month to Date',
    'quick-date-filter-year-to-date': 'Year to Date',
    'quick-date-filter-last-month': 'Last Month',
    'quick-date-filter-last-year': 'Last Year',
    'quick-date-filter-start-date': 'Start Date',
    'quick-date-filter-end-date': 'End Date',
    'quick-date-filter-select-date': 'Select Date',
    // Migrated from <i18n> SFC blocks (#6500)
    'are-you-sure-you-want-to-delete': 'Are you sure you want to delete this calendar? All events assigned to this calendar will be deleted.',
    'basic_settings': 'Basic Settings',
    'subscriptions': 'Subscriptions',
    'add_subscription': 'Add Subscription',
    'subscription_url': 'Subscription URL',
    'subscription_name': 'Subscription Name',
    'subscription_name_hint': 'Name that will appear in your calendar',
    'existing_subscriptions': 'Existing Subscriptions',
    'no_subscriptions_yet': 'No subscriptions added yet',
    'url_required': 'URL is required',
    'invalid_url': 'Please enter a valid URL',
    'ok': 'OK',
    'error_loading_subscriptions': 'Failed to load calendar subscriptions',
    'error_adding_subscription': 'Failed to add calendar subscription',
    'error_removing_subscription': 'Failed to remove calendar subscription',
    'error_syncing_subscription': 'Failed to sync calendar subscription',
    'sync_subscription': 'Sync Subscription',
    'remove_subscription': 'Remove Subscription',
    'subscription': 'Subscription',
    'are_you_sure_you_want_to_delete_subscription': 'Are you sure you want to delete this subscription? This will remove the subscription from your calendar.',
    'edit_subscription_name': 'Edit subscription name',
    'name_required': 'Name is required',
    'error_updating_subscription_name': 'Failed to update subscription name',
    'subscription_already_exists': 'Subscription already exists',
    'subscription_already_added': 'Subscription already added',
    'not_authorized': 'Not authorized',
    'network_offline': 'Network offline',
    'manage_subscriptions': 'Manage Subscriptions',
    'role-required': 'At least one role is required',
    'location-required': 'At least one location is required',
    'unknown_error': 'Unknown error',
    'shift_manager': 'Shift Manager',
    'general_manager': 'General Manager',
    'mid_manager': 'Mid Manager',
    'owner_operator': 'Owner Operator',
    'color_primary_blue': 'Primary Blue',
    'color_lavender': 'Lavender',
    'color_grape': 'Grape',
    'color_blush': 'Blush',
    'color_magenta': 'Magenta',
    'color_violet': 'Violet',
    'color_indigo': 'Indigo',
    'color_sky_blue': 'Sky Blue',
    'color_navy': 'Navy',
    'color_mint': 'Mint',
    'color_teal': 'Teal',
    'color_ice_blue': 'Ice Blue',
    'color_ocean': 'Ocean',
    'color_latte': 'Latte',
    'color_chocolate': 'Chocolate',
    'color_sage': 'Sage',
    'color_olive': 'Olive',
    'color_butter': 'Butter',
    'color_amber': 'Amber',
    'color_peach': 'Peach',
    'color_coral': 'Coral',
    'create-edit-calendar-locations': 'Locations',
    'create-edit-calendar-edit_subscription': 'Edit Subscription',
    'attachment-of': '{current} of {total}',
    'preview-not-available': 'Preview not available for this file type',
    'video-not-supported': 'Your browser does not support video playback',
    'swipe-to-navigate': 'Swipe to navigate',
    'pdf-mobile-hint': 'Tap below to view the PDF in your browser',
    'open-pdf': 'Open PDF',
    'go-to-attachment': 'Go to attachment {number}',
    'attachment-media-viewer-previous': 'Previous attachment',
    'attachment-media-viewer-next': 'Next attachment',
    'insert-link': 'Insert Link',
    'link': 'Link',
    'title': 'Title',
    'link-address-http-help': 'Enter a valid website address.',
    'summary-all-day': 'All day',
    'no-occurrence-before-end': 'No occurrence before {date}. Adjust the repeat settings or the end date.',
    'description-max-length': 'Description must be 1000 characters or less',
    'existing-attachments': 'Current Attachments',
    'remove-attachment': 'Remove attachment',
    'undo-remove': 'Undo removal',
    'audience': 'Audience',
    'content': 'Content',
    'news-feed': 'News Feed',
    'feed-post': 'Show in News Feed',
    'post-to-feed': 'Post to feed',
    'days-before-event': 'days before',
    'lead-days-locked': 'The event starts today or earlier, so it can\'t be posted to the feed ahead of time.',
    'days-before-event-label': 'days before Event',
    'days-before-event-lower': 'days before event',
    'news-feed-settings': 'News Feed Settings',
    'event-name': 'Event Name',
    'calendar-name': 'Calendar Name',
    'event-start': 'Event Start',
    'event-end': 'Event End',
    'show-in-news-feed': 'Show in News Feed',
    'repeat': 'Repeat',
    'subscription-edit-info': 'Some event details can only be edited from the location where the event was originally created.',
    'pin-to-top': 'Pin to top',
    'event-form-name': 'Event Name',
    'event-form-locations': 'Locations',
    'event-form-save': 'SAVE',
    'event-form-not-available': 'Not Available',
    'event-form-start-date': 'Start Date',
    'event-form-start-time': 'Start Time',
    'event-form-end-date': 'End Date',
    'event-form-end-time': 'End Time',
    'event-form-all': 'All',
    'event-form-all-locations': 'All Locations',
    'event-form-mid_manager': 'Mid Manager',
    'event-form-owner_operator': 'Owner Operator',
    'stores': 'stores',
    'missing-at-least-one-business-day-close': 'missing at least one business day close',
    'seven-days-insight-text': 'within the last 7 days',
    'highlighted-cells-represent': 'Highlighted cells represent',
    'service-sales-labor-negative-variance': 'Service, Sales and Labor = negative variance to recent same day of week trends.',
    'gc-proj-sales-proj': 'GC - Proj, Sales - Proj = +/- 10 hourly difference to projections',
    'projected-product-sales': 'Projected Product Sales',
    'my-metrics': 'My Metrics',
    'qtr': 'Qtr',
    'dar-widget-daypart': 'Daypart',
    // Migrated from <i18n> SFC blocks (#6500)
    'allow-users-to-create-their-own-dashboard': 'Allow users to create their own dashboard',
    'no-shift-leader-scheduled': 'No Shift Leader Scheduled',
    'current-shift-runner-thru': 'thru',
    'current-shift-runner-shift-leader': 'Shift Leader',
    'dashboard-settings': 'Dashboard Settings',
    'delete-dashboard': 'Delete Dashboard',
    'you-are-about-to-delete-this-dashboard': 'You are about to delete this dashboard. This action cannot be undone.',
    'global-settings': 'Global Settings',
    'qsr-admin-only-settings': 'QSR Admin Only Settings',
    'copy-widgets': 'Copy Widgets',
    'reset-org': 'Reset Org',
    'this-will-reset-the-entire-organization-dashboard': 'This will reset the entire organization\'s dashboard settings. This action cannot be undone.',
    'yes-nuke-em': 'Yes, Nuke em',
    'reset-this-user': 'Reset This User',
    'this-will-reset-this-users-dashboard-settings-this-action-cannot-be-undone': 'This will reset this user\'s dashboard settings. This action cannot be undone.',
    'dashboard-name': 'Dashboard Name',
    'assigned-roles': 'Assigned Roles',
    'error-loading-events': 'Error Loading Events',
    'nothing-here': 'Nothing Here',
    'yest': 'Yest',
    'tmw': 'Tmw',
    'create-event': 'Create Event',
    'share-calendars': 'Shared Calendar Links',
    'share-calendars-premium-banner-header': 'Share Calendars is a premium feature',
    'share-calendars-premium-banner-description': 'To share calendars, you need to be a premium user.',
    'create-event-premium-banner-header': 'Creating Events is a premium feature',
    'create-event-premium-banner-description': 'To create or edit events, you need to be a premium user.',
    'all-day': 'All Day',
    'calendars': 'Included Calendars',
    'select-all': 'Select All',
    'all-calendars': 'All Calendars',
    'others': 'others',
    'manage-calendars': 'Manage Calendars',
    'manage-calendars-premium-banner-header': 'Manage Calendars is a premium feature',
    'manage-calendars-premium-banner-description': 'To manage calendars, you need to be a premium user.',
    'calendar-selector-home': 'Home',
    'create-calendar': 'Create Calendar',
    'manage-calendars-modal-manage-calendars': 'Manage Calendars',
    'calendar-is-premium-feature': 'Calendar is a premium feature',
    'calendar-premium-description': 'To Access the organization calendar and create or edit events and calendars,',
    'ask-system-admin-upgrade': 'Ask your system admin to upgrade your organization to Premium.',
    'subscribe-to-premium': 'Upgrade to Premium',
    'date-text-field-ok': 'OK',
    'your-time': 'Your time',
    'event': 'Event',
    'edit-this-and-future-occurrences': 'Edit this and future occurrences',
    'edit-this-occurrence': 'Edit this occurrence',
    'calendar-is-required': 'Calendar is required',
    'start': 'Start',
    'end': 'End',
    'timezone': 'Timezone',
    'end-recurring-event-on': 'End Recurring Event On',
    'delete-event': 'Delete Event',
    'are-you-sure-you-want-to-delete-this-event': 'Are you sure you want to delete this event? This will delete all related recurring events.',
    'start-date-must-be-before-end-date': 'Start date must be before end date',
    'event-details': 'Event Details',
    'edit-event': 'Edit Event',
    'edit-event-form-update': 'Save',
    'attachments': 'Attachments',
    'files-selected': '{count} files selected',
    'drag-files-here': 'Drag files here or click to browse',
    'accepted-file-types': 'Images, videos, or PDFs',
    'drop-zone-label': 'Drop zone for file attachments. Click or press Enter to browse files.',
    'remove-file': 'Remove {name}',
    'add-more-files': 'Click or drag to add more files',
    'file-too-large': 'File(s) too large: {names}. Maximum size is {limit}MB.',
    'loading-attachments': 'Loading files...',
    'error-loading': 'Failed to load files',
    'view-attachment': 'View {name}',
    'event-attachment-list-attachments': '{count} File | {count} Files',
    'does-not-repeat': 'Does Not Repeat',
    'none': 'None',
    'no-description': 'No description',
    'all-locations': 'All Locations',
    'all-roles': 'All Roles',
    'search-locations': 'Search locations',
    'external-org': 'External — {org}',
    'internal-calendar': 'Internal — {calendar}',
    'repeats-every': 'Repeat every',
    'repeats': 'Repeats',
    'days': 'Day(s)',
    'weeks': 'Week(s)',
    'months': 'Month(s)',
    'years': 'Year(s)',
    'frequency-settings-does-not-repeat': 'Does not repeat',
    'on-day': 'on day',
    'on-the': 'on the',
    'monthly-frequency-first': 'First',
    'monthly-frequency-second': 'Second',
    'monthly-frequency-third': 'Third',
    'monthly-frequency-fourth': 'Fourth',
    'monthly-frequency-last': 'Last',
    'm': 'MO',
    'tu': 'TU',
    'w': 'WE',
    'th': 'TH',
    'f': 'FR',
    'sa': 'SA',
    'su': 'SU',
    'january': 'January',
    'february': 'February',
    'march': 'March',
    'april': 'April',
    'may': 'May',
    'june': 'June',
    'july': 'July',
    'august': 'August',
    'september': 'September',
    'october': 'October',
    'november': 'November',
    'december': 'December',
    'yearly-frequency-on': 'in',
    'yearly-frequency-sunday': 'Sunday',
    'yearly-frequency-first': 'First',
    'yearly-frequency-second': 'Second',
    'yearly-frequency-third': 'Third',
    'yearly-frequency-fourth': 'Fourth',
    'yearly-frequency-last': 'Last',
    'edit_subscription': 'Edit Shared Calendar Link',
    'subscribe_to_myq_calendar': 'Shared Calendar Links',
    'add_to_calendar': 'Add a MyQ Calendar to one of the following calendars:',
    'calendar_link_copied': 'Calendar link copied to clipboard!',
    'icalendar_instructions': 'You can use the iCalendar link to add a MyQ Calendar to any calendar application that supports iCalendar format. Simply copy the link and paste it into your calendar application, or click on one of the buttons above to add it directly to your preferred calendar.',
    'learn_google': 'Learn more about adding iCalendar links to Google Calendar',
    'learn_outlook': 'Learn more about adding iCalendar links to Outlook',
    'learn_apple': 'Learn more about adding iCalendar links to Apple Calendar',
    'icalendar_panel_title': 'How to use an iCalendar link:',
    'confirm_deletion': 'Confirm Deletion',
    'confirm_deletion_message': 'Are you sure you want to remove the calendar subscription',
    'confirm_deletion_message_strong': '? This action cannot be undone.',
    'delete_2': 'After deleting this calendar, the connection will be lost and it \nwill no longer receive updates from the QSRSoft calendar. If you want to completely remove the shared calendar, please \ndo so from the corresponding app (Google, Outlook, or Apple).',
    'calendar_name': 'Calendar Name',
    'create_shareable_calendar': 'Create Shareable Calendar Link',
    'create_shareable_calendar_2': ' + Add New link',
    'choose_calendar': 'Choose Calendar',
    'this_will_appear_as_the_title_in_your_external_app': 'This will appear as the title in external app',
    'choose_one_or_more_calendars_to_share': 'Choose one or more Calendars to share',
    'your_calendar_name': 'Your Calendar Name',
    'calendar_name_must_be_at_least_1_character': 'Calendar name must be at least 1 character',
    'please_select_at_least_one_calendar': 'Please select at least one calendar',
    'shared_calendars_header': 'Shared Calendar Links',
    'no_shared_calendars': 'You don\'t have any Shared Calendar Links.',
    'start_adding_shared_calendars': 'Start adding them in "New Shared Calendar Link" section',
    'or_add_your_calendar': 'Or add your calendar to one of the following calendar apps:',
    'new_shared_calendar_link': 'New Shared Calendar Link',
    'shared_calendar_links': 'Shared Calendar Links',
    'continue': 'Continue',
    'confirm_google_dialog_title': 'Continue to Google Calendar',
    'confirm_google_dialog_message': 'Google has recently updated how calendar subscriptions work. To add this calendar to Google, you will need to manually paste the subscription link into Google Calendar.',
    'confirm_google_dialog_message_strong': 'We\'ve already copied the link for your convenience. Please click the Continue button below to proceed. Once redirected, paste the link into the URL text field and click Add Calendar.',
    'confirm_google_dialog_message_strong_mobile': 'We\'ve already copied the link for your convenience. Please click the Continue button below to proceed. Once redirected, click the \'+\' icon next to Other calendars in the left sidebar, select From URL, paste the link into the URL field, and click Add calendar',
    'failed_to_get_subscriptions': 'Failed to get calendar subscriptions',
    'failed_to_add_subscription': 'Failed to add calendar subscription',
    'failed_to_edit_subscription': 'Failed to edit calendar subscription',
    'failed_to_delete_subscription': 'Failed to delete calendar subscription',
    'failed_to_copy_link': 'Failed to copy calendar link',
    'calendar_name_required': 'Calendar name is required',
    'create-ticket': 'Create Ticket',
    'you-do-not-have-permissions-to-view-this-widget': 'You do not have permissions to view this widget',
    'my-planned-maintenance': 'My Planned Maintenance',
    'error-loading-tasks': 'Error loading tasks',
    'tasks-due-by': 'Task(s) due by',
    'all-tasks-completed': 'All Tasks Completed!',
    'assigned': 'Assigned',
    'time-left': 'Time Left',
    'my-planned-maintenance-hours': 'hrs',
    'my-planned-maintenance-past-due': 'Past Due',
    'my-planned-maintenance-completed': 'Completed',
    'my-planned-maintenance-none': 'None',
    'tickets': 'Tickets',
    'error-loading-tickets': 'Error Loading Forms',
    'in-progress': 'In Progress',
    'on-hold': 'On Hold',
    'resolved': 'Resolved',
    'my-tickets-none': 'None',
    'planned-maintenance-overview': 'Planned Maintenance Overview',
    'unassigned': 'Unassigned',
    'planned-maintenance-error-loading-tasks': 'Error Loading Tasks',
    'planned-maintenance-assigned': 'Assigned',
    'planned-maintenance-completed': 'Completed',
    'tickets-overview': 'Tickets Overview',
    'reported': 'Reported',
    'accepted': 'Accepted',
    'tickets-overview-error-loading-tickets': 'Error Loading Tickets',
    'favorite-forms': 'Favorites Forms',
    'error-loading-forms': 'Error Loading Forms',
    'forms-favorites-title': 'Form Favorites',
    'forms-favorites-your-favorites': 'Your Favorites',
    'forms-favorites-org-favorites': 'Org Favorites',
    'forms-favorites-available-forms': 'Available forms',
    'forms-favorites-current-favorites': 'Current Favorites',
    'forms-favorites-no-favorites-yet': 'No favorites yet',
    'forms-favorites-add-form-hint': 'Select a form above to get started.',
    'forms-favorites-uncategorized': 'Uncategorized',
    'forms-favorites-unknown-form': 'Unknown form',
    'forms-favorites-load-error': 'Unable to load favorites right now. Please try again.',
    'forms-favorites-save-error': 'Unable to save changes. Please try again.',
    'shift-forms': 'Shift Forms',
    'forms-all': 'All',
    'forms-in-progress-2': 'In Progress',
    'in-progress-forms': 'In Progress Forms',
    'workflow-forms': 'Workflow Forms',
    'too-many-locations-selected': 'Too many locations selected. Please select one location.',
    'no-tasks-with-forms': 'No tasks with Forms',
    'workflow-forms-error-loading-forms': 'Error loading forms',
    'task-row-expired': 'Expired',
    'org-error-message-a': 'Your organization does not currently subscribe to QSRSoft Premium. Click ',
    'org-error-message-b': ' for more information.',
    'select-one_location': 'Please select only one location',
    'no-tasks-available': 'No tasks available - please talk to your system admin',
    'store-time-zone': 'Store Time Zone',
    'store-hours-gathered': 'Store Hours are gathered from your RFM settings',
    'user-error-message': 'You do not have permission to access forms. Please contact your system administrator.',
    'work-flow-here': 'HERE',
    'work-flow-missing-permissions': 'Missing Permissions',
    'Recurrence': 'Recurrence',
    'How often a new instance of a task is due': 'How often a new instance of a task is due',
    'Every': 'Every',
    'Date': 'Date',
    'Next 10 Recurrences': 'Next 10 Recurrences',
    'Starting at': 'Starting at',
    'Due': 'Due',
    'Ending at': 'Ending at',
    'Timezone': 'Timezone',
    'On day': 'On day',
    'Day of month': 'Day of month',
    'On the': 'On the',
    'Week': 'Week',
    'Day': 'Day',
    'Once': 'Once',
    'Minute': 'Minute',
    'Hour': 'Hour',
    'Month': 'Month',
    'Mon': 'Mon',
    'Tue': 'Tue',
    'Wed': 'Wed',
    'Thu': 'Thu',
    'Fri': 'Fri',
    'Sat': 'Sat',
    'Sun': 'Sun',
    'First': 'First',
    'Second': 'Second',
    'Third': 'Third',
    'Fourth': 'Fourth',
    'Last': 'Last',
    'Invalid RRULE': 'Invalid RRULE',
    'Does not repeat': 'Does not repeat',
    'AM': 'AM',
    'PM': 'PM',
    'oepe-trends': 'OEPE Trends',
    'kvs-projections': 'KVS Projections',
    'gc-projections': 'GC Projections',
    'insights-container-open-late-close-early': 'Open Late/Close Early',
    'stores-with-alerts': '{count} restaurant(s) with active alerts',
    'stores-with-alerts-suffix': 'restaurant(s) with active alerts',
    'total-errors': '{count} total active error(s)',
    'total-errors-suffix': 'total active error(s)',
    'bdc-stores-missing-prefix': 'store missing at least one | stores missing at least one',
    'instore-events-insight-old-missing-bdc': 'store missing at least one | stores missing at least one',
    'message': 'Message',
    'severity': 'Severity',
    'timestamp': 'Timestamp',
    'error': 'Error',
    'warning': 'Warning',
    'instore-events-more-info-info': 'Info',
    'number-of-bdc-missing': '# of BDC missing',
    'merged-alerts-more-info-business-date': 'Business Date(s)',
    'merged-alerts-more-info-info': 'Info',
    'merged-alerts-more-info-more-info': 'More Info',
    'guest-counts-are': 'Guest Counts are',
    'or-more-above': 'or more above projections for the past 2 hours',
    'or-more-below': 'or more below projections for the past 2 hours',
    'consider-reviewing': 'Consider reviewing staffing and positioning',
    'gc-projections-threshold': 'GC - Projections Threshold',
    'lower-limit': 'Lower Limit',
    'upper-limit': 'Upper Limit',
    'bdc-grid-business-date': 'Business Date(s)',
    'upcoming-kvs-projected-items': 'Upcoming, KVS projected items are above',
    'in-next-15-minutes': 'in next 15 minutes with one side open.',
    'kvs-stores-projected-items-are-above': '{count} stores\' KVS projected items are above',
    'kvs-store-projected-items-are-above': '{store} KVS projected items are above',
    'consider-2nd-side-opening': 'Consider 2nd side opening',
    'breakfast-threshold': 'Breakfast Threshold',
    'threshold': 'Threshold',
    'kvs-threshold-settings-items': 'Items',
    'labor-date': 'Labor Date',
    'act-start': 'Act Start',
    'act-end': 'Act End',
    'sch-start': 'Sch Start',
    'sch-end': 'Sch End',
    'act-shift-length': 'Act Shift Length',
    'exception': 'Exception',
    'exception-time': 'Exception Time',
    'is-manager-authorized': 'Is Manager Authorized',
    'punches-1': 'Punches 1',
    'punches-2': 'Punches 2',
    'punches-3': 'Punches 3',
    'punches-4': 'Punches 4',
    'punches-5': 'Punches 5',
    'punches-6': 'Punches 6',
    'there-were': 'There were',
    'exceptions-on-minor-employees': 'exceptions on minor employees',
    'minutes': 'Minutes',
    'days-missed-limit': 'Days Missed Limit can be adjusted in the insights settings.',
    'filter-open-late-msg': '** Displaying stores that have opened late more than the Days Missed Limit ({days} days) in the last 7 opens.',
    'filter-close-early-msg': '** Displaying stores that have closed early more than the Days Missed Limit ({days} days) in the last 7 closes.',
    'olce-grid-open-late-close-early': 'Open Late/Close Early',
    'olce-grid-filter': 'Filter',
    'olce-grid-open-late': 'Open Late',
    'olce-grid-close-early': 'Close Early',
    'may-have': 'may have',
    'late-opens': 'or more late opens in the last 7 days.',
    'early-closes': 'or more early closes in the last 7 days.',
    'olce-insight-open-late-close-early': 'Open Late/Close Early',
    'olce-insight-store': 'store',
    'days-missed': 'Days Missed',
    'ot-threshold-setting-hours': 'Hours',
    'employees-on-track': 'employees are on track to work over',
    'hours-this-week': 'hours this week.',
    'you-currently-have': 'You currently have',
    'items-out': 'items out in the last',
    'product-outage-insight-days': 'days.',
    'product-outage-insight-product-outage': 'Product Outage',
    'active-product-outages': 'Active Product Outages',
    'thirty-day-terms': '30 Day Terms',
    'ninety-day-terms': '90 Day Terms',
    'crew-type': 'Crew Type',
    'hire': 'Hire',
    'termination': 'Termination',
    'merged-terms-more-info-more-info': 'More Info',
    'crew-termed-in-the-first': 'crew termed in the first',
    'days-since-hire': 'days since hire',
    'no-30-day-terms': 'No crew termed in the first 30 days since hire.',
    'your-ninety-day-turnover-is-over': 'Turnover is over',
    'with': 'with',
    'crew-terminated-within': 'crew terminated within',
    'you-have': 'You have',
    's': 's',
    'with-90-day-turnover-above': 'with 90 day turnover above',
    'no-90-day-terms': 'No locations above the 90 day turnover threshold.',
    'people-terms-insight-thirty-day-terms': '30 Day',
    'people-terms-insight-ninety-day-terms': '90 Day',
    'people-terms-insight-location': 'location',
    'seconds': 'Seconds',
    'your-oepe-no-park': 'Your OEPE No Park is up by',
    'seconds-from-the-weekly-trend': 'seconds from the weekly trend.',
    'consider-parking-cars': 'Consider parking cars',
    'drawers-with-suspicious-activities': 'cases',
    'please-subscribe': 'Please Subscribe',
    'please-subscribe-verbiage': 'Subscribe to Security to view all instances of suspicious activity',
    'learn-more': 'Learn More',
    'suspicious-activity-insight-suspicious-activity': 'Suspicious Activity',
    'shared-link-settings': 'Shared Links Settings',
    'add-link': 'Add Link',
    'there-are-currently-no-third-party-links': 'There are currently no third party links',
    'label-cannot-be-blank': 'Label cannot be blank',
    'url-cannot-be-blank': 'URL cannot be blank',
    'links-settings-label': 'Label',
    'loading': 'Loading...',
    'no-shared-links-have-been-added': 'No shared links have been added for your organization.',
    'daily-activity': 'Daily Activity',
    'the-three-week-trend-is-calculated': 'The 3 week trend is calculated based on the average of the last 3 weeks of the same day of the week.',
    'three-week-trend': '3 Week Trend',
    'pivot-table': 'Pivot Table',
    'show-all-qtr-hrs': 'Show All Qtr Hrs',
    'dar-settings-row-settings': 'Row Settings',
    'goal-settings': 'Goal Settings',
    'percent-to-improve': '% to improve',
    'driveThruHME': 'Drive Thru HME',
    'numbers-indicate-employee-hours-this-week': 'Numbers indicate Employee Hours This Week - hours worked plus remaining scheduled. Highlighted rows denote minors.',
    'please-select-only-one-location': 'Please select only one location',
    'no-data-available': 'No data available',
    'not-scheduled': 'Not Scheduled',
    'employee-roster-error-loading': 'Error loading',
    'expandable-search-search': 'Search...',
    'roster-filter-job-title-code': 'Job Title Code',
    'working-today': 'Working Today',
    'working': 'WORKING',
    'scheduled-employees-error-loading': 'Error loading',
    'scheduled-employees-upcoming': 'UPCOMING',
    'select-locations': 'Select one or more locations',
    'at-least-one-location-required': 'At least one location is required',
    'location-selector-locations': 'Locations',
    'task-list': 'Task List',
    'failed-to-load-tasks': 'Failed to load tasks',
    'new-task': 'New Task',
    'description-required': 'Description required',
    'max-140-characters': 'Max 140 characters',
    'complete-task': 'Complete Task?',
    'this-task-will-be-archived-and-removed': 'This task will be archived and removed from the restaurant\'s list. Continue?',
    'Today': 'Today',
    'All': 'All',
    'task-list-no-tasks-available': 'No tasks available',
    'task-list-complete': 'Complete',
    // Migrated from <i18n> SFC blocks (#6500)
    'trading-day': 'Trading Day',
    'calendar-day': 'Calendar Day',
    'create-scorecard': 'Create Scorecard',
    'max-scorecards': 'Maximum number of scorecards reached',
    'name-assign': 'Name & Assign',
    'select-metrics': 'Select Metrics',
    'set-goals': 'Set Goals',
    'qsr-defaults': 'QSR Defaults',
    'defaults': 'Defaults',
    'click-cells-to-edit': 'Click on the cells to edit like Excel',
    'scorecard-settings': 'Scorecard Settings',
    'goals': 'Goals',
    'score-card-container-settings-scorecards': 'Scorecards',
    'score-card-settings-are-you-sure': 'Are you sure you want to delete this scorecard?',
    'score-card-settings-scorecard-settings': 'Scorecard Settings',
    'score-card-settings-settings': 'Settings',
    'score-card-settings-delete-scorecard': 'Delete Scorecard',
    'products-selected': 'products selected',
    'menu-items': 'Menu Items',
    'watchlists': 'Watchlists',
    'pmix-settings': 'PMIX Settings',
    'columns': 'Columns',
    'products': 'Products',
    'today-container-today': 'Today (Legacy)',
    // Migrated from <i18n> SFC blocks (#6500)
    'preview-mode': 'Preview Mode',
    'preview-mode-subtitle': 'Reviewing unsaved changes. Save to keep them or discard to revert.',
    'exit-preview': 'Exit Preview',
    dashboard: 'Dashboard',
    widget: 'Widget',
    shiftRunner: 'Shift Runner',
    insights: 'Insights',
    due: 'Due',
    expired: 'Expired',
    upcoming: 'Upcoming',
    completed: 'Completed',
    learnMore: 'Learn More',
    pleaseSubscribe: 'Please Subscribe',
    // CreateDashboard
    'create-dashboard': 'Create Dashboard',
    name: 'Name',
    roles: 'Roles',
    'starting-point': 'Starting Point',
    'name-description':
      'Select a name for your dashboard. Users will see this name in the selector.',
    'roles-description':
      'Select Roles for your dashboard. Users who are assigned these roles will be able to see and choose this dashboard.',
    'starting-point-description':
      'Choose a starting point. You can choose a QSRSoft dashboard, another dashboard that you created, or a blank canvas.',
    cancel: 'Cancel',
    back: 'Back',
    next: 'Next',
    preview: 'Preview',
    'name-required': 'Name is required',
    'name-exists': 'Dashboard with that name already exists',
    'roles-required': 'Roles are required',
    'blank-canvas': 'Blank Canvas',
    'qsr-presets': 'QSR Presets',
    'your-saved-dashboards': 'Your Saved Dashboards',
    // ResetDashboard
    'reset-dashboard': 'Reset Dashboard',
    'reset-description':
      'Choose a starting point to reset the current selected dashboard to. You can choose a QSRSoft dashboard, or a blank canvas. After selecting a starting point, click the Save button to apply the changes.',
    // Settings
    'widget-settings': 'Widget Settings',
    'row-settings': 'Row Settings',
    'column-settings': 'Column Settings',
    close: 'Close',
    save: 'Save',
    // DashboardContainerSettingsMulti
    customizeDashboardContainers: 'Customize Dashboard Containers',
    unableToSaveSettings: 'Unable to save dashboard settings.',
    unableToResetSettings: 'Unable to reset dashboard settings to default.',
    // no_favorites_card
    noShortcuts: 'You have no folder or file shortcuts.',
    add: 'Add',
    // Shared
    moreInfo: 'More Info',
    noData: 'No Data',
    loadError: "Couldn't load data",
    actual: 'Actual',
    current: 'Current',
    // BudgetWidget
    budget: 'Budget',
    fiscalPeriod: 'Fiscal Period',
    vsBudget: 'Vs Budget',
    // FoodWidget
    food: 'Food',
    week: 'Week',
    // TextSettings
    bulletinBoardSettings: 'Bulletin Board Settings',
    addText: 'Add Text',
    isLink: 'is link',
    url: 'URL',
    text: 'Text',
    // BUSalesRankPopUp
    oneYearComp: '1 Year Comp',
    twoYearComp: '2 Year Comp',
    // VoiceSmiley
    voice: 'VOICE',
    surveys: 'Surveys',
    numSurveys: '# of Surveys',
    voiceInfoText:
      'Data is received 2 days after SMG and grouped by date of customer visit. SMG defaults to date of customer survey. Due to these differences, it should <strong>not</strong> be expected for the sites to match.',
    // SmileySettings
    metric: 'Metric',
    all: 'All',
    metrics: 'Metrics',
    differentThresholds: 'Selected Metrics have different threshold values.',
    orSelectFewer: 'or select fewer metrics.',
    groupedMetrics: 'These are the grouped metrics:',
    group: 'Group',
    happyUpper: 'happy upper',
    happyLower: 'happy lower',
    neutralLower: 'neutral lower',
    // RMHC / Round Up
    roundUp: 'Round Up',
    helpingHands: 'Helping Hands',
    mtdDollar: 'MTD $',
    mtdCount: 'MTD Count',
    progressGoal: 'Progress / Goal',
    pctToGoal: '% to Goal:',
    goalsHit: 'Goals hit:',
    orgSettingsChanging: 'Org Settings Changing',
    orgSettingsConfirm:
      'You are about to change Org level settings. Are you sure?',
    no: 'No',
    donationDollar: 'Donation $',
    donationCount: 'Donation Count',
    goal: 'Goal',
    numOfDonations: '# of Donations',
    donationsDollar: 'Donations $',
    donationsCountGoal: 'Donations Count Goal',
    donationsDollarGoal: 'Donations $ Goal',
    pctOfGoal: '% of Goal',
    // Voice row labels
    voiceOverall: 'Overall',
    beNice: 'Be Nice',
    beFast: 'Be Fast',
    quality: 'Quality',
    clean: 'Clean',
    accuracy: 'Accuracy',
    // VoiceContainer
    customerFeedbackAndDonations: 'Customer Feedback & Donations',
    // BigArch / Incentives
    bigArch: 'Big Arch',
    'hot-honey': 'Hot Honey',
    'snack-wraps': 'Snack Wraps',
    // Shared incentive keys
    'incentive-rank-out-of': 'Rank out of',
    'incentive-restaurants': 'Restaurants',
    'incentive-rank': 'Rank',
    'incentive-rank-compared': 'Rank of the store compared to the whole BU',
    'incentive-units-1k-gc': 'Units/1K GC',
    'incentive-units-1k-rod-gc': 'Units/1K ROD GC',
    // BigArchWidget
    'big-arch-units': 'Big Arch Units',
    'big-arch-sold-related':
      'Number of menu items that are sold related to Big Arch during Rest of Day (ROD) per thousand units.',
    'big-arch-menu-items':
      'The associated menu items are 25442, 25443, and 25444',
    // HotHoneyWidget
    'hot-honey-units': 'Hot Honey Units',
    'hot-honey-sold-related':
      'Number of menu items that are sold related to Hot Honey during Rest of Day (ROD) per thousand units.',
    // SnackWrapsWidget
    'wrap-units': 'Wrap Units',
    'snack-wraps-message':
      'Snack Wraps are now reported as individual items here',
    'snack-wraps-sold-related':
      'Number of menu items that are sold related to Wraps during Rest of Day (ROD) per thousand units.',
    // IncentiveContainer
    leaderboard: 'Leaderboard',
    'mccrispy-strips': 'McCrispy Strips',
    'round-up-pos': 'Round Up POS/Employee',
    '3d-gc-incentive': '3D Guest Count Incentive',
    'default-incentives': 'Default Incentives',
    'new-beverage': 'New Beverages',
    // BUGrid
    org: 'Org',
    orgVs: 'Org vs',
    // BusinessUnitContainer
    comp: 'Comp',
    sales: 'Sales',
    service: 'Service',
    labor: 'Labor',
    'digital-app': 'Digital App',
    'addon-subscribed': 'BU Add-on · Subscribed',
    'addon-upgrade': 'BU Add-on · Upgrade',
    'addon-upgrade-tooltip':
      'Talk to your BU lead about adding the Business Unit Subscription to get visibility to the BU Comparison views',
    'bu-no-visibility':
      'You do not have visibility to the BU Comparison view for one or more of the following reasons:',
    'bu-app-backgrounded':
      'On mobile, the app has been on in the background too long. If so, please quit and restart the app.',
    'bu-no-subscription':
      'Your Business Unit is not subscribed to BU Data & Analytics product',
    'bu-opted-out':
      'You have "opted out" in MyQSRSoft Administration for BU data share.',
    'bu-contact-leadership':
      'Please contact your BU leadership with questions about the BU subscription and associated report views.',
    // BUCompTypeSelector
    'comp-calendar': 'Calendar',
    'comp-trading': 'Trading',
    'comp-same-store': 'Same Store',
    'comp-all-store': 'All Store',
    // BUSales tooltip
    'bu-financial-info':
      'Financial is used for current mid-month or date ranges that span outside completed months. Financial excludes locations that have not been open for a full 13 months. Default for Financial is Trading Day Comparison.',
    'bu-analytic-info':
      'Analytic is used for completed months and date ranges that include completed months. Analytics uses a 5-day rule. If a location is missing sales for 5 or more days (in either Current Year or Prior Year) it is excluded from the calculation. Default for Analytic is Calendar Day Comparison.',
    'bu-financial-info-rank':
      'Financial is used for current mid-month or date ranges that span outside completed months. Financial excludes locations that have not been open for a full 13 months. Defaults to Trading Day Comparison.',
    'bu-analytic-info-rank':
      'Analytic is used for completed months and date ranges that include completed months. Analytics uses a 5-day rule. If a location is missing sales for 5 or more days (in either Current Year or Prior Year) it is excluded from the calculation. Defaults to Calendar Day Comparison.',
    // BUSales rows
    'bu-row-sales': 'Sales',
    'bu-row-gcs': "GC's",
    'bu-row-avg-sales': 'Avg Sales',
    'bu-row-avg-check': 'Average Check',
    'bu-row-avg-check-diff': 'Average Check +/-',
    'bu-row-avg-check-diff-pct': 'Average Check +/- %',
    'bu-row-bfast-gcrd': 'BFast GC/R/D',
    'bu-row-bfast-gcrd-diff': 'BFast GC/R/D +/-',
    'bu-row-bfast-pct-sales': 'BFast % of Sales',
    'bu-row-mcdelivery-avg-check': 'McDelivery Average Check',
    'bu-row-mcdelivery-gcrd': 'McDelivery GC/R/D',
    'bu-row-mcdelivery-gcrd-diff': 'McDelivery GC/R/D +/-',
    'bu-row-gma-del-avg-check': 'GMA Del Average Check',
    'bu-row-gma-del-gcrd-diff': 'GMA Del GC/R/D +/-',
    'bu-row-3po-avg-check': '3P0 Average Check',
    'bu-row-3po-gcrd-diff': '3P0 GC/R/D +/-',
    'bu-row-dt-pct-sales': 'DT % of Total Sales',
    'bu-row-dt-gcrd': 'DT GC/R/D',
    'bu-row-dt-gcrd-diff': 'DT GC/R/D +/-',
    // BUPeaksService format info tooltip
    'bu-peaks-timeslice-label': 'Timeslice',
    'bu-peaks-show-details': 'Show details',
    'bu-peaks-comp-short-same': 'Same',
    'bu-peaks-comp-short-all': 'All',
    'bu-peaks-comp-basis': 'Comparison basis. Same: counts only store-days present in both years. All: counts every store-day.',
    'bu-peaks-format-info-diff': 'Default values display the relative difference vs your BU',
    'bu-peaks-format-info-detail': 'Enable "Show details" to display the BU and Org raw values for each metric',
    // BUService rows
    'bu-row-oepe-no-park': 'OEPE W/O Park',
    'bu-row-oepe-no-park-diff': 'OEPE W/O Park +/-',
    'bu-row-oepe': 'OEPE',
    'bu-row-oepe-diff': 'OEPE +/-',
    'bu-row-r2p': 'R2P',
    'bu-row-r2p-diff': 'R2P +/-',
    'bu-row-avg-ctp': 'Avg CTP',
    'bu-row-avg-ctp-diff': 'Avg CTP +/-',
    'bu-row-kvs-items-gc': 'KVS Items / GC',
    'bu-row-kvs-items-gc-diff': 'KVS Items / GC +/-',
    'bu-row-kvs-time-gc': 'KVS Time / GC',
    'bu-row-kvs-time-gc-diff': 'KVS Time / GC +/-',
    'bu-row-dt-pulled-fwd': 'DT Pulled Fwrd %',
    'bu-row-dt-pulled-fwd-diff': 'DT Pulled Fwrd % +/-',
    'bu-row-healthy-use': 'Healthy Use',
    'bu-row-healthy-use-diff': 'Healthy Use +/-',
    'bu-row-sales-r-d': 'Sales/R/D',
    'bu-row-sales-r-d-diff': 'Sales/R/D +/- %',
    'bu-row-gc-r-d': 'GC/R/D',
    'bu-row-gc-r-d-diff': 'GC/R/D +/- %',
    'bu-row-dt-sales-r-d': 'DT Sales/R/D',
    'bu-row-dt-sales-r-d-diff': 'DT Sales/R/D +/- %',
    'bu-row-fc-sales-r-d': 'FC Sales/R/D',
    'bu-row-fc-sales-r-d-diff': 'FC Sales/R/D +/- %',
    'bu-row-fc-gc-r-d': 'FC GC/R/D',
    'bu-row-fc-gc-r-d-diff': 'FC GC/R/D +/- %',
    'bu-row-kiosk-sales-r-d': 'Kiosk Sales/R/D',
    'bu-row-kiosk-sales-r-d-diff': 'Kiosk Sales/R/D +/- %',
    'bu-row-kiosk-gc-r-d': 'Kiosk GC/R/D',
    'bu-row-kiosk-gc-r-d-diff': 'Kiosk GC/R/D +/- %',
    'bu-row-moa-sales-r-d': 'MOA Sales/R/D',
    'bu-row-moa-sales-r-d-diff': 'MOA Sales/R/D +/- %',
    'bu-row-moa-gc-r-d': 'MOA GC/R/D',
    'bu-row-moa-gc-r-d-diff': 'MOA GC/R/D +/- %',
    'bu-row-delivery-sales-r-d': 'Delivery Sales/R/D',
    'bu-row-delivery-sales-r-d-diff': 'Delivery Sales/R/D +/- %',
    'bu-row-delivery-gc-r-d': 'Delivery GC/R/D',
    'bu-row-delivery-gc-r-d-diff': 'Delivery GC/R/D +/- %',
    'bu-row-dt-avg-check': 'DT Avg Check',
    'bu-row-dt-avg-check-diff': 'DT Avg Check +/-',
    'bu-row-fc-avg-check': 'FC Avg Check',
    'bu-row-fc-avg-check-diff': 'FC Avg Check +/-',
    'bu-row-kiosk-avg-check': 'Kiosk Avg Check',
    'bu-row-kiosk-avg-check-diff': 'Kiosk Avg Check +/-',
    'bu-row-moa-avg-check': 'MOA Avg Check',
    'bu-row-moa-avg-check-diff': 'MOA Avg Check +/-',
    'bu-row-delivery-avg-check': 'Delivery Avg Check',
    'bu-row-delivery-avg-check-diff': 'Delivery Avg Check +/-',
    'bu-digital-customer-count': 'Digital Customer Count',
    'bu-row-dt-gcrd-diff-pct': 'DT GC/R/D +/- %',
    'bu-row-avg-check-short': 'Avg Check',
    'bu-row-avg-check-short-diff': 'Avg Check +/-',
    // BULabor rows
    'bu-row-crew-labor': 'Crew Labor %',
    'bu-row-actual-labor': 'Actual Labor %',
    'bu-row-avg-rate': 'Avg Rate',
    'bu-row-tpph': 'TPPH',
    'bu-row-total-labor': 'Total Labor %',
    // BUFood rows
    'bu-row-base-food': 'Base Food %',
    'bu-row-comp-waste': 'Comp Waste %',
    'bu-row-condiments': 'Condiments %',
    'bu-row-discount': 'Discount %',
    'bu-row-emp-meals': 'Emp Meals %',
    'bu-row-fob': 'FOB %',
    'bu-row-raw-waste': 'Raw Waste %',
    'bu-row-stat-var': 'Stat Var %',
    'bu-row-unexplained': 'Unexplained %',
    'bu-row-pnl-food-cost': 'PNL Food Cost %',
    'bu-row-pnl-paper-cost': 'PNL Paper Cost %',
    // BUDigitalApp rows
    'bu-row-digital-sales': 'Digital Sales %',
    'bu-row-digital-gc': 'Digital GC %',
    'bu-row-digital-avg-check': 'Digital Average Check',
    'bu-row-digital-grd': 'Digital G/R/D',
    'bu-row-scanned-offer-sales': 'Scanned Offer Sales',
    'bu-row-scanned-offer-gcs': "Scanned Offer GC's",
    'bu-row-scanned-offer-avg-check': 'Scanned Offer Average Check',
    'bu-row-scanned-offer-grd': 'Scanned Offer G/R/D',
    'bu-row-gma-delivery-sales': 'GMA Delivery Sales',
    'bu-row-gma-delivery-gcs': "GMA Delivery GC's",
    'bu-row-gma-delivery-avg-check': 'GMA Delivery Average Check',
    'bu-row-gma-delivery-grd': 'GMA Delivery G/R/D',
    'bu-row-loyalty-sales': 'Loyalty Self ID Sales',
    'bu-row-loyalty-gcs': "Loyalty Self ID GC's",
    'bu-row-loyalty-avg-check': 'Loyalty Self ID Average Check',
    'bu-row-loyalty-grd': 'Loyalty Self ID G/R/D',
    'bu-row-mop-offer-sales': 'MOP W/ Offer Sales',
    'bu-row-mop-offer-gcs': "MOP W/ Offer GC's",
    'bu-row-mop-offer-avg-check': 'MOP W/ Offer Average Check',
    'bu-row-mop-offer-grd': 'MOP W/ Offer G/R/D',
    'bu-row-mop-no-offer-sales': 'MOP W/O Offer Sales',
    'bu-row-mop-no-offer-gcs': "MOP W/O Offer GC's",
    'bu-row-mop-no-offer-avg-check': 'MOP W/O Offer Average Check',
    'bu-row-mop-no-offer-grd': 'MOP W/O Offer G/R/D',
    'bu-row-mop-curb-gcs': "MOP Curb GC's %",
    'bu-row-mop-fc-gcs': "MOP FC GC's %",
    'bu-row-mop-table-gcs': "MOP Table GC's %",
    'bu-row-mop-dt-gcs': "MOP DT GC's %",
    // BUVoice rows
    'bu-row-overall': 'Overall %',
    'bu-row-friendliness': 'Friendliness %',
    'bu-row-fast': 'Fast %',
    'bu-row-quality': 'Quality %',
    'bu-row-cleanliness': 'Cleanliness %',
    'bu-row-accuracy': 'Accuracy %',
    'bu-row-dt-overall': 'DT Overall %',
    'bu-row-dt-friendliness': 'DT Friendliness %',
    'bu-row-dt-fast': 'DT Fast %',
    'bu-row-dt-quality': 'DT Quality %',
    'bu-row-dt-cleanliness': 'DT Cleanliness %',
    'bu-row-dt-accuracy': 'DT Accuracy %',
    'bu-row-fc-overall': 'FC Overall %',
    'bu-row-fc-friendliness': 'FC Friendliness %',
    'bu-row-fc-fast': 'FC Fast %',
    'bu-row-fc-quality': 'FC Quality %',
    'bu-row-fc-cleanliness': 'FC Cleanliness %',
    'bu-row-fc-accuracy': 'FC Accuracy %',
    // BUTurnover rows
    'bu-row-crew-mth-ann-turnover': 'Crew Mth Ann Turnover',
    'bu-row-crew-3mo-turnover': 'Crew Three Month Turnover',
    'bu-row-crew-term': 'Crew Term',
    'bu-row-avg-crew-hire': 'Avg Crew Hire',
    'bu-row-crew-roster': 'Crew Roster',
    'bu-row-crew-ttm-turnover': 'Crew TTM Turnover',
    'bu-row-crew-ytd-turnover': 'Crew YTD Turnover',
    'bu-row-shift-mth-ann-turnover': 'Shift Mth Ann Turnover',
    'bu-row-shift-3mo-turnover': 'Shift Three Month Turnover',
    'bu-row-shift-term': 'Shift Term',
    'bu-row-avg-shift-hire': 'Avg Shift Hire',
    'bu-row-shift-roster': 'Shift Roster',
    'bu-row-shift-ttm-turnover': 'Shift TTM Turnover',
    'bu-row-shift-ytd-turnover': 'Shift YTD Turnover',
    // BUDigitalOrderPts rows
    'bu-row-dop-digital-gc': 'Digital GC %',
    'bu-row-dop-digital-sales': 'Digital Sales %',
    'bu-row-dop-digital-grd': 'Digital G/R/D',
    'bu-row-dop-mop-gcs': "MOP GC's %",
    'bu-row-dop-mop-sales': 'MOP Sales %',
    'bu-row-dop-mop-gcrd': 'MOP GC/R/D',
    'bu-row-dop-gma-del-gc': 'GMA Del GC %',
    'bu-row-dop-gma-del-sales': 'GMA Del Sales %',
    'bu-row-dop-gma-del-grd': 'GMA Del G/R/D',
    'bu-row-dop-kiosk-gc': 'Kiosk GC %',
    'bu-row-dop-kiosk-sales': 'Kiosk Sales %',
    'bu-row-dop-kiosk-grd': 'Kiosk G/R/D',
    'bu-row-dop-delivery-gc': 'Delivery GC %',
    'bu-row-dop-delivery-sales': 'Delivery Sales %',
    'bu-row-dop-delivery-grd': 'Delivery G/R/D',
    // BUDateRange
    'start-date': 'Start Date',
    'end-date': 'End Date',
    // BUSalesRankPopUp
    'bu-sales': 'BU Sales',
    rankings: 'Rankings',
    'custom-date-range-bu': 'Custom Date Range',
    thru: 'Thru',
    // BUDigitalApp
    'fo-disclaimer':
      'FO sales results are displayed after McDonalds quarterly sales release.',
    // BUVoice
    'voice-rankings': 'Voice Rankings',
    'bu-comp-type-disclaimer':
      'This widget is only available for Business Unit and Field Office comparison types.',
    'voice-data-behind':
      'Voice data is generally 2 days behind. Please select an earlier date range',
    // BUTurnover
    people: 'People',
    'people-metrics-full-months':
      'People metrics are calculated using full months.',
    'people-multiple-months':
      'If multiple months are selected, the most recent complete month is used.',
    'people-partial-month':
      'If a past month is partially selected, the full month is used.',
    'people-detailed-breakdown':
      'For a detailed breakdown, see the BU Rank report.',
    'people-requires-full-month': 'People data requires full month date range',
    // BUDigitalOrderPts
    'digital-order-pts': 'Digital Order Pts',
    // BUAppTrends
    'bu-loyalty-trend': 'BU Loyalty 90-day Active Trend',
    'bu-loyalty-tooltip':
      'Number of unique customers who placed at least one digital app GC in the 90-day period. Because a customer can visit more than one restaurant in an organization, this number cannot be added across restaurants.',
    // Consulting
    qsrsoftConsultingServices: 'QSRSoft Consulting Services',
    consultingHelpsCapture:
      'QSRSoft Consulting helps capture cashflow opportunity',
    cashflowOpportunity: 'Cashflow Opportunity',
    total: 'Total',
    laborPotentialCF: 'Labor Potential CF',
    fobPotentialCF: 'FOB Potential CF',
    buGCGapPotentialCF: 'BU GC Gap Potential CF',
    // File Manager
    resourceLibrary: 'Resource Library',
    // Calendar
    calendar: 'Calendar',
    all_roles: 'All Roles',
    'cal-role-crew': 'Crew',
    'cal-role-shift-manager': 'Shift Manager',
    'cal-role-department-manager': 'Department Manager',
    'cal-role-general-manager': 'General Manager',
    'cal-role-mid-manager': 'Mid-Manager',
    'cal-role-owner-operator': 'Owner Operator',
    'cal-role-system-administrators': 'System Administrators',
    organization_calendar: 'Organization Calendar',
    'cal-days': 'Days',
    'cal-pick-a-day': 'Pick a day',
    'cal-new-event': 'New event',
    'cal-open-calendar': 'Open calendar',
    'cal-open-day': 'Open day',
    'mc-open-report': 'Open report',
    'mc-updated-at': 'Updated {time}',
    'mc-refresh': 'Refresh',
    'mc-goals-hit': '{hit} of {total} goals',
    'mc-goals-short': '{hit} / {total}',
    'mc-actual': 'Actual',
    'mc-goal': 'Goal',
    'mc-diff': 'Diff',
    'mc-dayparts': 'Dayparts',
    'mc-peaks': 'Peaks',
    'mc-custom-range': 'Custom date range',
    'mc-previous-period': 'Previous period',
    'mc-next-period': 'Next period',
    'mc-rank-stores': 'Rank stores',
    'mc-new-scorecard': 'New scorecard',
    'mc-trend': 'Trend',
    'mc-metric': 'Metric',
    'mc-item': 'Item',
    'cal-options': 'Calendar options',
    'cal-shared-links': 'Shared calendar links',
    'cal-yesterday': 'Yesterday',
    'cal-today': 'Today',
    'cal-tomorrow': 'Tomorrow',
    'cal-all-day': 'All day',
    'cal-upcoming': 'Upcoming',
    'cal-events': 'Events',
    'cal-earlier': 'Earlier',
    'cal-nothing-scheduled': 'Nothing scheduled',
    'cal-add-event': 'Add an event',
    'cal-no-events': 'No events',
    'cal-one-event': '1 event',
    'cal-n-events': '{n} events',
    'cal-n-timed': '{n} timed',
    'cal-n-all-day': '{n} all day',
    'cal-n-celebrations': '{n} celebrations',
    'cal-across-days': 'across these days',
    'cal-dur-minutes': '{n} min',
    'cal-dur-hours': '{n} hr',
    'cal-dur-hours-minutes': '{h} hr {m} min',
    'cal-dur-days': '{n} days',
    'cal-error-loading': 'Error loading events',
    'cal-share-premium-header': 'Share Calendars is a premium feature',
    'cal-share-premium-description': 'To share calendars, you need to be a premium user.',
    'cal-create-premium-header': 'Creating Events is a premium feature',
    'cal-create-premium-description': 'To create or edit events, you need to be a premium user.',
    shared_calendar: 'Shared',
    birthdays: 'Birthdays',
    work_anniversaries: 'Work Anniversaries',
    // ScoreCard
    scorecards: 'Scorecards',
    'please-contact-org-admin':
      'Please contact your Org admin to create a scorecard.',
    mtd: 'MTD',
    'last-month': 'Last Month',
    ytd: 'YTD',
    color: 'Color',
    'scorecard-setting': 'Scorecard Setting',
    settings: 'Settings',
    delete: 'Delete',
    'delete-scorecard': 'Delete Scorecard',
    'are-you-sure':
      'Are you sure you want to delete this scorecard? This action cannot be undone.',
    'avg-goal': 'Avg Goal',
    diff: 'Diff',
    // TH Dashboard - Insights
    'did-you-know': 'Did you know?',
    'employee-requests': 'Employee Requests',
    waste: 'Waste',
    'closing-hours': 'Closing Hours',
    // WasteInsight template
    'waste-insight-text':
      '{dateText}, you have {count} {storeWord} that are missing at least {threshold} {dayWord} of recorded waste',
    'store-singular': 'store',
    'store-plural': 'stores',
    'day-singular': 'day',
    'day-plural': 'days',
    // ClosingHourInsight template
    'closing-hour-insight-text':
      '{dateText}, you have {lobbyCount} lobbies and {dtCount} DTs where the latest transaction is {threshold} minutes or more before the closing time',
    // TH Dashboard - Today
    today: 'Today',
    'current-day-sales': 'Current Day Sales',
    'current-day-service': 'Current Day Service',
    'current-day-updates-around': 'Current day updates around {time}',
    // TH Dashboard - Snapshot
    snapshot: 'Snapshot',
    'dayparts-sales': 'DayParts Sales',
    'dayparts-service': 'DayParts Service',
    'open-11am': 'Open - 11am',
    '11am-close': '11am - Close',
    'service-times': 'Service Times',
    // TH CurrentDaySales / SalesWidget rows
    'th-row-net-sales': 'Net Sales',
    'th-row-transactions': 'Transactions',
    'th-row-refund-transactions': 'Refund Transactions',
    'th-row-eat-in-trans': 'Eat In Trans',
    'th-row-eat-in-refund-trans': 'Eat In Refund Trans',
    'th-row-take-out-trans': 'Take Out Trans',
    'th-row-take-out-refund-trans': 'Take Out Refund Trans',
    'th-row-drive-thru-trans': 'Drive Thru Trans',
    'th-row-drive-thru-refund-trans': 'Drive Thru Refund Trans',
    'th-row-delivery-trans': 'Delivery Trans',
    'th-row-delivery-refund-trans': 'Delivery Refund Trans',
    'th-row-kiosk-trans': 'Kiosk Trans',
    'th-row-kiosk-refund-trans': 'Kiosk Refund Trans',
    'th-row-mobile-take-out-trans': 'Mobile Take Out Trans',
    'th-row-mobile-take-out-refund-trans': 'Mobile Take Out Refund Trans',
    'th-row-mobile-drive-thru-trans': 'Mobile Drive Thru Trans',
    'th-row-mobile-drive-thru-refund-trans': 'Mobile Drive Thru Refund Trans',
    'th-row-refund-sales': 'Refund Sales',
    'th-row-avg-check': 'Avg Check',
    'th-row-eat-in-net-sales': 'Eat In Net Sales',
    'th-row-eat-in-refund-sales': 'Eat In Refund Sales',
    'th-row-eat-in-avg-check': 'Eat In Avg Check',
    'th-row-take-out-net-sales': 'Take Out Net Sales',
    'th-row-take-out-refund-sales': 'Take Out Refund Sales',
    'th-row-take-out-avg-check': 'Take Out Avg Check',
    'th-row-drive-thru-net-sales': 'Drive Thru Net Sales',
    'th-row-drive-thru-refund-sales': 'Drive Thru Refund Sales',
    'th-row-drive-thru-avg-check': 'Drive Thru Avg Check',
    'th-row-delivery-net-sales': 'Delivery Net Sales',
    'th-row-delivery-refund-sales': 'Delivery Refund Sales',
    'th-row-delivery-avg-check': 'Delivery Avg Check',
    'th-row-kiosk-net-sales': 'Kiosk Net Sales',
    'th-row-kiosk-refund-sales': 'Kiosk Refund Sales',
    'th-row-kiosk-avg-check': 'Kiosk Avg Check',
    'th-row-mobile-take-out-net-sales': 'Mobile Take Out Net Sales',
    'th-row-mobile-take-out-refund-sales': 'Mobile Take Out Refund Sales',
    'th-row-mobile-take-out-avg-check': 'Mobile Take Out Avg Check',
    'th-row-mobile-delivery-net-sales': 'Mobile Delivery Net Sales',
    'th-row-mobile-delivery-refund-sales': 'Mobile Delivery Refund Sales',
    'th-row-mobile-delivery-avg-check': 'Mobile Delivery Avg Check',
    // TH Service rows
    'th-row-greet-time': 'Greet Time',
    'th-row-order-time': 'Order Time',
    'th-row-queue-time': 'Queue Time',
    'th-row-window-time': 'Window Time',
    'th-row-total-time': 'Total Time',
    // TH SalesWidget (Snapshot) rows
    'th-row-manager-void-amt': 'Manager Void Amt',
    'th-row-cash-over-short': 'Cash Over/Short',
    'th-row-canceled-item-amt': 'Canceled Item Amt',
    'th-row-canceled-item-cnt': 'Canceled Item Cnt',
    'th-row-canceled-order-amt': 'Canceled Order Amt',
    'th-row-canceled-order-cnt': 'Canceled Order Cnt',
    'th-row-manager-void-cnt': 'Manager Void Cnt',
    'th-row-overring-amt': 'Overring Amt',
    // TH Labor rows
    'th-row-hourly-labor-pct': 'Hourly Labor %',
    'th-row-hourly-labor-hours': 'Hourly Labor Hours',
    'th-row-management-labor-pct': 'Management Labor %',
    'th-row-hourly-labor-dollar': 'Hourly Labor $',
    'th-row-salaried-labor-hours': 'Salaried Labor Hours',
    'th-row-total-labor-pct': 'Total Labor %',
    'th-row-proj-labor-guide': 'Proj Labor Guide',
    'th-row-total-labor-hours': 'Total Labor Hours',
    'th-row-training-hours': 'Training Hours',
    'th-row-labor-cost': 'Labor Cost',
    'th-row-trans-per-labor-hour': 'Trans / Labor Hour',
    'th-row-act-labor-guide-hours': 'Act Labor Guide Hours',
    'th-row-adj-proj-hours': 'Adj Proj +/- Hours',
    'th-row-avg-hourly-rate': 'Avg Hourly Rate',
    // TH Shared headers
    'plus-minus': '+/-',
    // TH Main section titles
    controls: 'Controls',
    'shared-links': 'Shared Links',
    'file-manager': 'File Manager',
    'assumed-role': 'Assumed role',
    forms: 'Forms',
    // MT dashboard Forms section (components/multiClient/dashboard/forms)
    // MT dashboard Equipment section (components/multiClient/dashboard/equipment)
    'equip-tickets': 'Tickets',
    'equip-reported': 'Reported',
    'equip-accepted': 'Accepted',
    'equip-in-progress': 'In progress',
    'equip-assigned': 'Assigned',
    'equip-on-hold': 'On hold',
    'equip-unassigned': 'Unassigned',
    'equip-scheduled': 'Scheduled',
    'equip-past-due': 'Past due',
    'equip-resolution': 'Resolution',
    'equip-completion': 'Completion',
    'equip-next-due': 'Next task due {date}',
    'equip-no-tasks-due': 'No tasks due',
    'equip-time-left-hint': '{time} left',
    'equip-error-loading': 'Error loading equipment data',
    'equip-new-ticket': 'New ticket',
    'equip-refresh': 'Refresh',
    'equip-all-tickets': 'All tickets',
    'equip-my-tickets-link': 'My tickets',
    'equip-maintenance-link': 'Maintenance',
    'equip-my-tasks-link': 'My tasks',
    'equip-selected-locations': 'Selected locations',
    'equip-you': 'You',
    'equip-my-tickets-maintenance': 'My Tickets and Maintenance',
    'equip-all-tickets-maintenance': 'All Tickets and Maintenance',
    'equip-everyone': 'Everyone',
    'equip-maintenance': 'Maintenance',
    'equip-open-count': '{n} open',
    'equip-task-count': '{n} tasks',
    'equip-reported-lc': 'reported',
    'equip-in-progress-lc': 'in progress',
    'equip-unassigned-lc': 'unassigned',
    'equip-past-due-lc': 'past due',
    // Resource Library (File Manager shortcuts) on the MT home dashboard
    'fm-resources': 'Resources',
    'fm-folders': 'Folders',
    'fm-files': 'Files',
    'fm-open-resource-library': 'Open Resource Library',
    'fm-refresh': 'Refresh',
    'fm-download': 'Download',
    'fm-remove-shortcut': 'Remove shortcut',
    'fm-scroll-left': 'Scroll left',
    'fm-scroll-right': 'Scroll right',
    'fm-n-items': '{n} items',
    'fm-added': 'Added {date}',
    'fm-n-shortcuts': '{n} shortcuts',
    'fm-no-folders': 'No folder shortcuts',
    'fm-no-files': 'No file shortcuts',
    'fm-empty': 'No folder or file shortcuts yet. Star items in the File Manager and they show up here.',
    'fm-add-shortcuts': 'Add shortcuts',
    'fm-error': 'Error loading shortcuts',
    'forms-favorites': 'Favorites',
    'forms-in-progress': 'In Progress',
    'forms-error-loading': 'Error loading forms',
    retry: 'Retry',
    'forms-manage-favorites': 'Manage favorites',
    'forms-no-favorites-title': 'No favorites yet',
    'forms-no-favorites-hint':
      'Tap the gear to star the forms you use most.',
    'forms-nothing-in-progress-title': 'Nothing in progress — nice!',
    'forms-nothing-in-progress-hint':
      'Forms you start will show up here so you can pick them back up.',
    'forms-started': 'Started {when}',
    'forms-continue': 'Continue',
    'forms-percent-complete': '{pct}% complete',
    'forms-open-form': 'Open {title}',
    equipment: 'Equipment',
    // Standard main section titles
    'snapshot-month': 'Snapshot Month',
    // Calendar
    'view-calendar': 'View Calendar',
    'calendar-options': 'Calendar Options',
    // TH Budget rows
    'th-row-total-labor-dollars': 'Total Labor Dollars',
    'th-row-food-cost': 'Food Cost',
    'th-row-food-cost-pct': 'Food Cost %',
    'th-row-annual-salary': 'Annual Salary',
    'th-row-crew-dollars': 'Crew Dollars',
    'th-row-crew-labor-pct': 'Crew Labor %',
    'th-row-manager-labor-pct': 'Manager Labor %',
    // TH Food rows
    'th-row-adj-theo-food-cost-pct': 'Adj Theoretical Food Cost %',
    'th-row-food-var-pct': 'Food Var %',
    'th-row-total-waste-pct': 'Total Waste %',
    'th-row-total-cost': 'Total Cost',
    'th-row-paper-cost': 'Paper Cost',
    'th-row-other-cost': 'Other Cost',
    'th-row-total-var-cost': 'Total Var Cost',
    'th-row-food-var-cost': 'Food Var Cost',
    'th-row-paper-var-cost': 'Paper Var Cost',
    'th-row-other-var-cost': 'Other Var Cost',
    'th-row-total-waste-cost': 'Total Waste Cost',
    'th-row-total-cost-pct': 'Total Cost %',
    'th-row-paper-cost-pct': 'Paper Cost %',
    'th-row-other-cost-pct': 'Other Cost %',
    'th-row-total-var-pct': 'Total Var %',
    'th-row-paper-var-pct': 'Paper Var %',
    'th-row-other-var-pct': 'Other Var %',
    'th-row-theo-food-cost-pct': 'Theoretical Food Cost %',
    'th-row-gap-variance-pct': 'Gap Variance %',
    // TH DayPart Sales rows
    'th-row-daypart-sales': 'Sales',
    'th-row-daypart-avg-chk': 'Avg Chk',
    'th-row-daypart-tcs': "TC's",
    'th-row-daypart-dt-sales': 'DT Sales',
    'th-row-daypart-dt-avg-chk': 'DT Avg Chk',
    'th-row-daypart-dt-tcs': "DT TC's",
    'th-row-daypart-lobby-sales': 'Lobby Sales',
    'th-row-daypart-lobby-avg-chk': 'Lobby Avg Chk',
    'th-row-daypart-lobby-tcs': "Lobby TC's",
    // CompTypeSelector
    'trading': 'Trading',
    // Security / Insights
    'error-loading-data': 'Error Loading Data',
    'security-events': 'Events',
    'security-locations': 'Locations',
    'security-employees': 'Employees',
    'security-drill-down': 'Security Analysis',

    // Security Drill Down date tabs. Namespaced because the bare keys collide:
    // domains merge flat and `sales` is merged after `dashboard`, so a plain
    // `wtd` would resolve to sales.js's value, not this one.
    'security-date-today': 'Today',
    'security-date-yest': 'Yest',
    'security-date-wtd': 'WTD',
    'security-date-lw': 'LW',
    'security-date-custom-range': 'Custom Date Range',
    'security-date-exceeds-max-range': 'Exceeds max range of {days} days',

    // Insight Settings dialog (both the old and new dashboard copies).
    // Namespaced: domains merge into one flat namespace and `sales` merges
    // after `dashboard`, so bare keys are not safe here.
    'insight-settings-title': 'Insight Settings',
    'insight-settings-insight': 'Insight',
    'insight-settings-insights': 'Insights',
    // Interpolated, not concatenated -- French puts the noun first, so
    // `{name} settings` cannot be built from a translated `settings` token.
    'insight-settings-for': '{name} settings',
    'insight-settings-watch-lists': 'Watch Lists',
    'insight-settings-threshold': 'Threshold',
    'insight-settings-minutes-threshold': 'Minutes Threshold',
    'insight-settings-waste-threshold': 'Waste Threshold',
    'insight-settings-days-missed-limit': 'Days Missed Limit',
    'insight-settings-modified-punches': 'Modified Punches',
    // Shared ColorSettings.vue: the insight dialog's Color tab and every Card
    // Settings dialog that offers a card color.
    'widget-settings-select-card-color': 'Select Card Color',

    'top-events': 'Top Events',
    'top-locations': 'Top Locations',
    'top-cashiers': 'Top Cashiers',
    'top-managers': 'Top Managers',
    'security-drill-down-title': 'Security Drill Down',
    'security-drill-down-event-selection': 'Event Selection',
    'security-drill-down-max-events': 'Select up to {max} events',
    'security-drill-down-customize-events': 'Customize Events',
    'security-drill-down-search-events': 'Event',
    'security-drill-down-includes': 'Includes:',
    'security-drill-down-coupon-letter': 'Coupon {letter}',
    'security-drill-down-events-auto': 'Top {max} by $',
    'security-drill-down-events-choose': 'Choose events',
    'security-drill-down-order-value': 'Sort by $',
    'security-drill-down-order-custom': 'Custom order',
    // the event names Security Events uses
    'security-drill-down-event-cash_refund': 'Cash Refund',
    'security-drill-down-event-cashless_refund': 'Cashless Refund',
    'security-drill-down-event-pos_overring': 'POS Overring',
    'security-drill-down-event-t_red_before': 'T-Red Before',
    'security-drill-down-event-t_red_after': 'T-Red After',
    'security-drill-down-event-total_order_promo': 'Total Order Promo',
    'security-drill-down-event-other_promo': 'Other Promo',
    'security-drill-down-event-mobile_promo': 'Mobile Promo',
    'security-drill-down-event-delivery_promo': 'Delivery Promo',
    'security-drill-down-event-all_promo': 'All Promos',
    'security-drill-down-event-pos_auto_discount': 'POS Auto Discount',
    'security-drill-down-event-mobile_discount': 'Mobile Discount',
    'security-drill-down-event-other_discount': 'Other Discount',
    'security-drill-down-event-all_discount': 'All Discounts',
    'security-drill-down-event-coupon': 'Coupons',
    'security-drill-down-event-employee_meal': 'Employee Meal',
    'security-drill-down-event-manager_meal': 'Manager Meal',
    'security-drill-down-event-duplicate_card_swipe': 'Duplicate Card Swipe',
    'security-drill-down-event-high_lock_out': 'High Lock Out',
    'security-drill-down-event-high_lock_out_tender': 'High Lock Out Tender',
    'security-drill-down-event-billable_sales': 'Billable Sales',
    'security-drill-down-event-electronic_benefit_transfer': 'Electronic Benefit Transfer (EBT)',
    'cashiers': 'Cashiers',
    'managers': 'Managers',
    // SecurityTable
    'transactions': 'TRANSACTIONS',
    'activity-label': 'Activity',
    'date-header': 'Date',
    'time-header': 'Time',
    'daypart-header': 'Day Part',
    'register-header': 'Register',
    'crew-header': 'Crew',
    'manager-header': 'Manager',
    'mgr-code-header': 'Manager Authorization Type',
    'details-header': 'View Detail',
    'camera-header': 'Camera',
    'event-time-header': 'Event Time',
    'amount-header': 'Amount',
    'remaining-amount-header': 'Remaining Amount',
    'not-applicable-value': 'N/A',
    'unavailable-value': 'Unavailable',
    'tender-type-header': 'Tender Type',
    'loyalty-id-header': 'Loyalty ID',
    'event-type-header': 'Type',
    'activity-type-header': 'Activity Type',
    'promo-type-header': 'Promo Type',
    'discount-type-header': 'Discount Type',
    'billable-org-header': 'Billable Organization',
    'lockout-type-header': 'Lock Out Type',
    'item-count-header': 'Item Count',
    'coupon-type-header': 'Coupon Type',
    'overring-amount-header': 'Overring Amount',
    'reduction-amount-header': 'Reduction Amount',
    'discount-amount-header': 'Discount Amount',
    'promo-amount-header': 'Promo Amount',
    'refund-amount-header': 'Refund Amount',
    'data-failed-to-load': 'The data failed to load. Please try again.',
    'tender-cash': 'Cash',
    'tender-cashless': 'Cashless',
    'tender-us$_cashless': 'US$ Cashless',
    'tender-gift_card': 'Gift Card',
    'tender-no_tender': 'No Tender',
    'tender-billable_sales': 'Billable Sales',
    'tender-other': 'Other',
    'mgr_auth_code': 'manager code',
    'mgr_auth_biometrics': 'biometrics',
    // Security event token labels
    'cash_refund': 'Cash Refund',
    'cashless_refund': 'Cashless Refund',
    'pos_overring': 'POS Overring',
    'other_promo': 'Other Promo',
    'total_order_promo': 'Total Promo',
    'total_promo': 'Total Promo',
    'billable_sales': 'Billable Sales',
    'drawer_open': 'Drawer Open',
    'general_drawer_open': 'General Drawer Open',
    't_red_before': 'Transaction Reduction Before',
    't_red_after': 'Transaction Reduction After',
    'mobile_discount': 'Mobile Discount',
    'mobile_promo': 'Mobile Promo',
    'pos_auto_discount': 'POS Auto Discount',
    'other_discount': 'Other Discount',
    'loyalty_reward_ids': 'Loyalty Reward',
    'employee_meal': 'Employee Meal',
    'manager_meal': 'Manager Meal',
    'duplicate_card_swipe': 'Duplicate Card Swipe',
    'coupon': 'Coupon',
    'all_discount': 'All Discounts',
    'all_promo': 'All Promos',
    'high_lock_out': 'High Lock Out',
    'high_lock_out_tender': 'High Lock Out Tender',
    'high_lock_out_amount': 'High Lock Out Amount',
    'high_lock_out_item': 'High Lock Out Item',
    'electronic_benefit_transfer': 'Electronic Benefit Transfer (EBT)',
    'delivery_promo': 'Delivery Promo',
    'all_events': 'Mixed Activities',
    'event-type-earn': 'Earn',
    'event-type-burn': 'Burn',
    // SecurityTableSlideUp
    'highlight-info': 'Highlighted rows indicate the cashier was changed in C&I after the drawer was changed at the POS during drawer count.',
    // MoreInfo
    'more-info': 'More Info',
    'view-insight': 'View Insight',
    'drawer-open-verbiage': '{cashierName} had {eventQuantity} {eventName} on {date} at {location}',
    'general-drawer-open-verbiage': '{managerName} had {eventQuantity} {eventName} on {date} at {location}',
    'drawer-open-verbiage-burst': '{cashierName} had a burst of {eventQuantity} {eventName} on {date} at {location}',
    'other-verbiage': '{cashierName} had {eventQuantity} {eventName} totaling {eventAmount} on {date} at {location}',
    'other-verbiage-burst': '{cashierName} had a burst of {eventQuantity} {eventName} totaling {eventAmount} on {date} at {location}',
    'loyalty-reward-ids-verbiage': 'A Loyalty Reward Id was used {eventQuantity} times totaling {eventAmount} on {date} at {location}',
    'extended-over-eight-hours-drawer-open-verbiage-for-cashier': 'Cashier {cashierName} averaged {eventQuantity} {eventName}/8 POS hrs over the last {numOfDays} days at {location}',
    'extended-over-eight-hours-drawer-open-verbiage-for-cashier-general': 'Cashier {cashierName} averaged {eventQuantity} {eventName}/8 POS hrs over {dateRange} at {location}',
    'extended-over-eight-hours-other-verbiage-for-cashier': 'Cashier {cashierName} averaged {eventAmount} of {eventName}/8 POS hrs over the last {numOfDays} days at {location}',
    'extended-over-eight-hours-other-verbiage-for-cashier-general': 'Cashier {cashierName} averaged {eventAmount} of {eventName}/8 POS hrs over {dateRange} at {location}',
    'extended-less-than-eight-hours-drawer-open-verbiage-for-cashier': 'Cashier {cashierName} had {eventQuantity} {eventName} in {lessEightHours} POS hrs over the last {numOfDays} days at {location} (less than 8 hrs)',
    'extended-less-than-eight-hours-drawer-open-verbiage-for-cashier-general': 'Cashier {cashierName} had {eventQuantity} {eventName} in {lessEightHours} POS hrs over {dateRange} at {location} (less than 8 hrs)',
    'extended-less-than-eight-hours-other-verbiage-for-cashier': 'Cashier {cashierName} had {eventAmount} of {eventName} in {lessEightHours} POS hrs over the last {numOfDays} days at {location}',
    'extended-less-than-eight-hours-other-verbiage-for-cashier-general': 'Cashier {cashierName} had {eventAmount} of {eventName} in {lessEightHours} POS hrs over {dateRange} at {location}',
    'extended-drawer-open-verbiage-for-manager': 'Manager {managerName} approved a total of {eventQuantity} {eventName} over the last {numOfDays} days at {location}',
    'extended-drawer-open-verbiage-for-manager-general': 'Manager {managerName} approved a total of {eventQuantity} {eventName} over {dateRange} at {location}',
    'extended-other-verbiage-for-manager': 'Manager {managerName} approved a total of {eventAmount} of {eventName} over the last {numOfDays} days at {location}',
    'extended-other-verbiage-for-manager-general': 'Manager {managerName} approved a total of {eventAmount} of {eventName} over {dateRange} at {location}',
    'data-failed-to-load-support': 'The data failed to load. Please try again or contact support if the issue persists.',
    // InsightsContainer
    'all-quiet-here': 'All quiet here',
    'product-outage': 'Product Outage',
    'business-day-close': 'Business Day Close',
    'open-late-close-early': 'Open Late/Close Early',
    'minor-exceptions': 'Minor Exceptions',
    'product-default': 'Default',
    'product-product-and-inventory': 'Prod/Inv',
    'product-people': 'People',
    'product-shift': 'Shift',
    'product-security': 'Security',
    'employee-request': 'Employee Requests',
    'suspicious-activity': 'Suspicious Activity',
    'rbd': 'RBD',
    'rbd-completed': 'RBD Completed',
    'rbd-activation': 'RBD Activation',
    'rbd-completed-threshold': 'RBD Completed Threshold',
    'threshold-hint': 'Alert when stores exceed this number of RBD completions in 30 days (1-10)',
    'potential-ot': 'Potential OT',
    'simplethink': 'Premium',
    '30-day-terms': '30 Day Terms',
    '90-day-terms': '90 Day Terms',
    'people-terms': 'People Terms',
    'last-thirty-days': 'Last 30 Days',
    'trailing-365-days': 'Trailing 365 Days',
    'trailing-thirty-days': 'Trailing 30 Days',
    'yesterday': 'Yesterday',
    'this-week': 'This Week',
    'last-week': 'Last Week',
    'this-month': 'This Month',
    'last-seven-days': 'Last 7 Days',
    'modified-punches': 'Modified Punches',
    'store-alerts': 'Restaurant Alerts',
    'store-notifications': 'Restaurant Notifications',
    'product-candi': 'C&I',
    'waste-entry': 'Waste Entry',
    'stat-inventory': 'Inventory Stat',
    // OLCEInsight
    'open-late-message': `<strong>{count}</strong> store may have <strong>{daysThreshold}</strong> or more late opens in the last 7 days. | <strong>{count}</strong> stores may have <strong>{daysThreshold}</strong> or more late opens in the last 7 days.`,
    'close-early-message': `<strong>{count}</strong> store may have <strong>{daysThreshold}</strong> or more early closes in the last 7 days. | <strong>{count}</strong> stores may have <strong>{daysThreshold}</strong> or more early closes in the last 7 days.`,
    // Shift Runner Scorecard
    'sms-shift-runner-scorecard': 'Shift Runner Scorecard',
    'sms-shift-scorecard': 'Shift Scorecard',
    'sms-no-data': 'No Data',
    'sms-overall': 'Overall',
    'sms-shift-prep': 'Shift Prep',
    'sms-shift-operational-metrics': 'Shift Operational Metrics - vs Goal',
    'sms-shift-runner': 'Shift Runner',
    'sms-shifts': 'Shifts',
    'sms-score': 'Score',
    'sms-pre-shift-checklist': 'Pre Shift Checklist',
    'sms-travel-path': 'Travel Path',
    'sms-oepe-w-o': 'OEPE W/O',
    'sms-r2p': 'R2P',
    'sms-kvs-time-per-gc': 'KVS Time/GC',
    'sms-kvs-healthy-usage': 'KVS Healthy Usage',
    'food-safety-completed': 'Completed',
    'food-safety-passed-failed': '{passed} passed · {failed} failed',
    'food-safety-equipment-issues': 'Equipment Issues',
    'food-safety-completed-forms': 'Completed Forms',
    'food-safety-no-equipment-issues': 'No equipment issues',
    'food-safety-unknown-equipment': 'Unknown equipment',
    'food-safety-no-location': 'No location',
    'food-safety-exceptions': 'Exceptions',
    'food-safety-view-report': 'View Report',
    'food-safety-load-error': 'Error loading food safety data',
    'food-safety-no-forms': 'No food safety forms are set up for this organization',
    'food-safety-thresholds': 'Food Safety Thresholds',
    'food-safety-thresholds-description':
      'Set the pass rate needed for each color. These apply to everyone in your organization.',
    'food-safety-green-at': 'Green at or above',
    'food-safety-yellow-at': 'Yellow at or above',
    'food-safety-legend-green': 'Green: {value}% and up',
    'food-safety-legend-yellow': 'Yellow: {low}% to under {high}%',
    'food-safety-legend-red': 'Red: under {value}%',
    'food-safety-percent-rule': 'Enter a value from 0 to 100',
    'food-safety-yellow-rule': 'Must be at or below the green threshold',
    'food-safety-thresholds-save-error': 'Unable to save thresholds. Please try again.',
    'food-safety-insight-completed':
      '<strong>{count}</strong> food safety form completed {period} | <strong>{count}</strong> food safety forms completed {period}',
    'food-safety-insight-pass-rate': '{rate} passed',
    'food-safety-insight-equipment':
      '<strong>{count}</strong> equipment issue: | <strong>{count}</strong> equipment issues:',
    'food-safety-and-more': '+{count} more',
    'food-safety-equipment': 'Equipment',
    'food-safety-date-time': 'Date/Time',
    'food-safety-store': 'Location',
    'food-safety-form': 'Form',
    'food-safety-completed-at': 'Completed At',
    'food-safety-completed-by': 'Completed By',
    'food-safety-status': 'Status',
    'food-safety-status-passed': 'Passed',
    'food-safety-status-failed': 'Failed',
    'food-safety-type': 'Type',
    'food-safety-type-safety': 'Safety',
    'food-safety-type-quality': 'Quality',
    'food-safety-type-calibration': 'Calibration',
    'food-safety-temperature': 'Temp',
    'food-safety-target': 'Target',
    'food-safety-product': 'Product',
    'food-safety-corrective-action': 'Corrective Action',
  },
  es: {
    // Migrated from <i18n> SFC blocks (#6500)
    'print': 'Imprimir',
    'calendar-view': 'Vista de Calendario',
    'list-view': 'Vista de Lista',
    'calendar-list-all-day': 'Todo el día',
    'no-events': 'No hay eventos en este período',
    'show-more': 'Mostrar Más',
    'show-less': 'Mostrar Menos',
    'close-filters': 'Cerrar Filtros',
    'open-filters': 'Abrir Filtros',
    'add-subscriptions': 'Añadir Suscripciones',
    'show': 'Mostrar',
    'more': 'Más',
    'subscribe-premium-banner-header': 'Compartir Calendarios es una función premium',
    'subscribe-premium-banner-description': 'Para compartir calendarios, necesitas ser un usuario premium.',
    'all-day-label': 'Eventos de Todo el Día',
    'events-title': 'Eventos',
    'calendar-desktop-view-locations': 'Ubicaciones',
    'calendar-desktop-view-create': 'Crear Evento',
    'calendar-desktop-view-share-calendars': 'Compartir Calendarios',
    'calendar-desktop-view-create-event-premium-banner-header': 'Crear Evento es una función premium',
    'calendar-desktop-view-create-event-premium-banner-description': 'Para crear eventos, necesitas ser un usuario premium.',
    'calendar-desktop-view-manage-calendars-premium-banner-description': 'Para añadir o gestionar calendarios, necesitas ser un usuario premium.',
    'calendar-desktop-view-manage-calendars': 'Gestionar Calendarios',
    'calendar-desktop-view-manage-calendars-premium-banner-header': 'Gestionar Calendarios es una función premium',
    'three-day': '3 Días',
    'calendar-mobile-view-locations': 'Ubicaciones',
    'calendar-mobile-view-create': 'Crear Evento',
    'calendar-mobile-view-share-calendars': 'Compartir Calendarios',
    'calendar-mobile-view-no-events': 'No hay eventos',
    'calendar-mobile-view-create-event-premium-banner-header': 'Crear Evento es una función premium',
    'calendar-mobile-view-create-event-premium-banner-description': 'Para crear eventos, necesitas ser un usuario premium.',
    'calendar-mobile-view-manage-calendars-premium-banner-description': 'Para añadir o gestionar calendarios, necesitas ser un usuario premium.',
    'calendar-mobile-view-manage-calendars': 'Gestionar Calendarios',
    'calendar-mobile-view-manage-calendars-premium-banner-header': 'Gestionar Calendarios es una función premium',
    // Migrated from <i18n> SFC blocks (#6500)
    'custom-range': 'Rango personalizado',
    'apply': 'Aplicar',
    'quick-date-filter-last-week': 'Semana pasada',
    'quick-date-filter-this-week': 'Esta semana',
    'quick-date-filter-week-to-date': 'Semana hasta la fecha',
    'quick-date-filter-this-month': 'Este mes',
    'quick-date-filter-month-to-date': 'Mes hasta la fecha',
    'quick-date-filter-year-to-date': 'Año hasta la fecha',
    'quick-date-filter-last-month': 'Mes pasado',
    'quick-date-filter-last-year': 'Año pasado',
    'quick-date-filter-start-date': 'Fecha de inicio',
    'quick-date-filter-end-date': 'Fecha de fin',
    'quick-date-filter-select-date': 'Seleccionar fecha',
    // Migrated from <i18n> SFC blocks (#6500)
    'are-you-sure-you-want-to-delete': '¿Estás seguro de que deseas eliminar este calendario? Todos los eventos asignados a este calendario serán eliminados.',
    'basic_settings': 'Configuración Básica',
    'subscriptions': 'Suscripciones',
    'add_subscription': 'Añadir Suscripción',
    'subscription_url': 'URL de Suscripción',
    'subscription_name': 'Nombre de Suscripción',
    'subscription_name_hint': 'Nombre que aparecerá en tu calendario',
    'existing_subscriptions': 'Suscripciones Existentes',
    'no_subscriptions_yet': 'Aún no se han añadido suscripciones',
    'url_required': 'Se requiere URL',
    'invalid_url': 'Por favor ingresa una URL válida',
    'ok': 'OK',
    'error_loading_subscriptions': 'Error al cargar las suscripciones del calendario',
    'error_adding_subscription': 'Error al añadir la suscripción del calendario',
    'error_removing_subscription': 'Error al eliminar la suscripción del calendario',
    'error_syncing_subscription': 'Error al sincronizar la suscripción del calendario',
    'sync_subscription': 'Sincronizar Suscripción',
    'remove_subscription': 'Eliminar Suscripción',
    'subscription': 'Suscripción',
    'are_you_sure_you_want_to_delete_subscription': '¿Estás seguro de que deseas eliminar esta suscripción? Esto eliminará la suscripción de tu calendario.',
    'edit_subscription_name': 'Editar nombre de suscripción',
    'name_required': 'El nombre es requerido',
    'error_updating_subscription_name': 'Error al actualizar el nombre de la suscripción',
    'subscription_already_exists': 'La suscripción ya existe',
    'subscription_already_added': 'La suscripción ya está añadida',
    'not_authorized': 'No autorizado',
    'network_offline': 'Red sin conexión',
    'manage_subscriptions': 'Gestionar Suscripciones',
    'role-required': 'Se requiere al menos un rol',
    'location-required': 'Se requiere al menos una ubicación',
    'unknown_error': 'Error desconocido',
    'shift_manager': 'Jefe de Turno',
    'general_manager': 'Gerente General',
    'mid_manager': 'Gerente Medio',
    'owner_operator': 'Operador Dueño',
    'color_primary_blue': 'Azul Primario',
    'color_lavender': 'Lavanda',
    'color_grape': 'Uva',
    'color_blush': 'Rubor',
    'color_magenta': 'Magenta',
    'color_violet': 'Violeta',
    'color_indigo': 'Índigo',
    'color_sky_blue': 'Azul Cielo',
    'color_navy': 'Azul Marino',
    'color_mint': 'Menta',
    'color_teal': 'Verde Azulado',
    'color_ice_blue': 'Azul Hielo',
    'color_ocean': 'Océano',
    'color_latte': 'Café con Leche',
    'color_chocolate': 'Chocolate',
    'color_sage': 'Salvia',
    'color_olive': 'Oliva',
    'color_butter': 'Mantequilla',
    'color_amber': 'Ámbar',
    'color_peach': 'Durazno',
    'color_coral': 'Coral',
    'create-edit-calendar-locations': 'Ubicaciones',
    'create-edit-calendar-edit_subscription': 'Editar Suscripción',
    'attachment-of': '{current} de {total}',
    'preview-not-available': 'Vista previa no disponible para este tipo de archivo',
    'video-not-supported': 'Tu navegador no soporta la reproducción de video',
    'swipe-to-navigate': 'Desliza para navegar',
    'pdf-mobile-hint': 'Toca abajo para ver el PDF en tu navegador',
    'open-pdf': 'Abrir PDF',
    'go-to-attachment': 'Ir al adjunto {number}',
    'attachment-media-viewer-previous': 'Archivo adjunto anterior',
    'attachment-media-viewer-next': 'Siguiente archivo adjunto',
    'insert-link': 'Insertar enlace',
    'link': 'Enlace',
    'title': 'Título',
    'link-address-http-help': 'Ingresa una dirección web válida.',
    'summary-all-day': 'Todo el día',
    'no-occurrence-before-end': 'No hay ocurrencias antes del {date}. Ajusta la repetición o la fecha de fin.',
    'description-max-length': 'La descripción debe tener 1000 caracteres o menos',
    'existing-attachments': 'Archivos adjuntos actuales',
    'remove-attachment': 'Eliminar archivo adjunto',
    'undo-remove': 'Deshacer eliminación',
    'audience': 'Audiencia',
    'content': 'Contenido',
    'news-feed': 'Feed de Noticias',
    'feed-post': 'Mostrar en Feed de Noticias',
    'post-to-feed': 'Publicar en el feed',
    'days-before-event': 'días antes',
    'lead-days-locked': 'El evento comienza hoy o antes, por lo que no se puede publicar en el feed con anticipación.',
    'days-before-event-label': 'días antes del Evento',
    'days-before-event-lower': 'días antes del evento',
    'news-feed-settings': 'Configuración de Feed de Noticias',
    'event-name': 'Nombre del Evento',
    'calendar-name': 'Nombre del Calendario',
    'event-start': 'Inicio del Evento',
    'event-end': 'Fin del Evento',
    'show-in-news-feed': 'Mostrar en Feed de Noticias',
    'repeat': 'Repetir',
    'subscription-edit-info': 'Algunos detalles del evento solo pueden ser editados desde la ubicación donde el evento fue creado originalmente.',
    'pin-to-top': 'Fijar en la parte superior',
    'event-form-name': 'Nombre del evento',
    'event-form-locations': 'Ubicaciones',
    'event-form-save': 'GUARDAR',
    'event-form-not-available': 'No disponible',
    'event-form-start-date': 'Fecha de inicio',
    'event-form-start-time': 'Hora de inicio',
    'event-form-end-date': 'Fecha de fin',
    'event-form-end-time': 'Hora de fin',
    'event-form-all': 'Todos',
    'event-form-all-locations': 'Todas las ubicaciones',
    'event-form-mid_manager': 'Gerente Intermedio',
    'event-form-owner_operator': 'Dueño Operador',
    'stores': 'tiendas',
    'missing-at-least-one-business-day-close': 'falta al menos un cierre del día hábil',
    'seven-days-insight-text': 'dentro de los últimos 7 días',
    'highlighted-cells-represent': 'Las celdas resaltadas representan',
    'service-sales-labor-negative-variance': 'Servicio, Ventas y Mano de Obra = variación negativa con respecto a las tendencias recientes del mismo día de la semana.',
    'gc-proj-sales-proj': 'GC - Proj, Ventas - Proj = +/- 10 diferencia horaria con respecto a las proyecciones',
    'projected-product-sales': 'Ventas de Productos Proyectadas',
    'my-metrics': 'Mis Métricas',
    'qtr': 'Trimestre',
    'dar-widget-daypart': 'Parte del Día',
    // Migrated from <i18n> SFC blocks (#6500)
    'allow-users-to-create-their-own-dashboard': 'Permitir a los usuarios crear su propio panel',
    'no-shift-leader-scheduled': 'No hay líder de turno programado',
    'current-shift-runner-thru': 'hasta',
    'current-shift-runner-shift-leader': 'Líder de turno',
    'dashboard-settings': 'Configuración del Tablero',
    'delete-dashboard': 'Eliminar Tablero',
    'you-are-about-to-delete-this-dashboard': 'Está a punto de eliminar este tablero. Esta acción no se puede deshacer.',
    'global-settings': 'Configuraciones Globales',
    'qsr-admin-only-settings': 'Configuraciones Solo para Administradores QSR',
    'copy-widgets': 'Copiar Widgets',
    'reset-org': 'Restablecer Organización',
    'this-will-reset-the-entire-organization-dashboard': 'Esto reiniciará la configuración del tablero de toda la organización. Esta acción no se puede deshacer.',
    'yes-nuke-em': 'Sí, Destruirlos',
    'reset-this-user': 'Restablecer Este Usuario',
    'this-will-reset-this-users-dashboard-settings-this-action-cannot-be-undone': 'Esto reiniciará la configuración del tablero de este usuario. Esta acción no se puede deshacer.',
    'dashboard-name': 'Nombre del Tablero',
    'assigned-roles': 'Roles Asignados',
    'error-loading-events': 'Error Cargando Eventos',
    'nothing-here': 'No Hay Nada Aquí',
    'yest': 'Ayer',
    'tmw': 'Mañana',
    'create-event': 'Crear Evento',
    'share-calendars': 'Enlaces de Calendario Compartidos',
    'share-calendars-premium-banner-header': 'Compartir Calendarios es una función premium',
    'share-calendars-premium-banner-description': 'Para compartir calendarios, necesitas ser un usuario premium.',
    'create-event-premium-banner-header': 'Crear Evento es una función premium',
    'create-event-premium-banner-description': 'Para crear eventos, necesitas ser un usuario premium.',
    'all-day': 'Todo el Día',
    'calendars': 'Calendarios Incluidos',
    'select-all': 'Seleccionar Todo',
    'all-calendars': 'Todos los Calendarios',
    'others': 'otros',
    'manage-calendars': 'Administrar Calendarios',
    'manage-calendars-premium-banner-header': 'Administrar Calendarios es una función premium',
    'manage-calendars-premium-banner-description': 'Para administrar calendarios, necesitas ser un usuario premium.',
    'calendar-selector-home': 'Principal',
    'create-calendar': 'Crear Calendario',
    'manage-calendars-modal-manage-calendars': 'Gestionar Calendarios',
    'calendar-is-premium-feature': 'El calendario es una función premium',
    'calendar-premium-description': 'Para acceder al calendario de la organización y crear o editar eventos y calendarios,',
    'ask-system-admin-upgrade': 'Pide a tu administrador del sistema que actualice tu organización a Premium.',
    'subscribe-to-premium': 'Actualizar a Premium',
    'date-text-field-ok': 'Aceptar',
    'your-time': 'Tu hora',
    'event': 'Evento',
    'edit-this-and-future-occurrences': 'Editar esta y futuras ocurrencias',
    'edit-this-occurrence': 'Editar esta ocurrencia',
    'calendar-is-required': 'El calendario es obligatorio',
    'start': 'Inicio',
    'end': 'Fin',
    'timezone': 'Zona horaria',
    'end-recurring-event-on': 'Finalizar evento recurrente en',
    'delete-event': 'Eliminar Evento',
    'are-you-sure-you-want-to-delete-this-event': '¿Estás seguro de que quieres eliminar este evento? Esto eliminará todos los eventos recurrentes relacionados.',
    'start-date-must-be-before-end-date': 'La fecha de inicio debe ser anterior a la fecha de finalización',
    'event-details': 'Detalles del Evento',
    'edit-event': 'Editar Evento',
    'edit-event-form-update': 'Guardar',
    'attachments': 'Archivos adjuntos',
    'files-selected': '{count} archivos seleccionados',
    'drag-files-here': 'Arrastra archivos aquí o haz clic para buscar',
    'accepted-file-types': 'Imágenes, videos o PDFs',
    'drop-zone-label': 'Zona de arrastre para archivos adjuntos. Haz clic o presiona Enter para buscar archivos.',
    'remove-file': 'Eliminar {name}',
    'add-more-files': 'Haz clic o arrastra para agregar más archivos',
    'file-too-large': 'Archivo(s) demasiado grande(s): {names}. El tamaño máximo es {limit}MB.',
    'loading-attachments': 'Cargando archivos...',
    'error-loading': 'Error al cargar archivos',
    'view-attachment': 'Ver {name}',
    'event-attachment-list-attachments': '{count} Archivo | {count} Archivos',
    'does-not-repeat': 'No Se Repite',
    'none': 'Ninguno',
    'no-description': 'No hay descripción',
    'all-locations': 'Todas las Ubicaciones',
    'all-roles': 'Todos los Roles',
    'search-locations': 'Buscar ubicaciones',
    'external-org': 'Externo — {org}',
    'internal-calendar': 'Interno — {calendar}',
    'repeats-every': 'Repite cada',
    'repeats': 'Repite',
    'days': 'Día(s)',
    'weeks': 'Semana(s)',
    'months': 'Mes(es)',
    'years': 'Año(s)',
    'frequency-settings-does-not-repeat': 'No repite',
    'on-day': 'el día',
    'on-the': 'el',
    'monthly-frequency-first': 'primero',
    'monthly-frequency-second': 'segundo',
    'monthly-frequency-third': 'tercero',
    'monthly-frequency-fourth': 'cuarto',
    'monthly-frequency-last': 'último',
    'm': 'LU',
    'tu': 'MA',
    'w': 'MI',
    'th': 'JU',
    'f': 'VI',
    'sa': 'SÁ',
    'su': 'DO',
    'january': 'Enero',
    'february': 'Febrero',
    'march': 'Marzo',
    'april': 'Abril',
    'may': 'Mayo',
    'june': 'Junio',
    'july': 'Julio',
    'august': 'Agosto',
    'september': 'Septiembre',
    'october': 'Octubre',
    'november': 'Noviembre',
    'december': 'Diciembre',
    'yearly-frequency-on': 'de',
    'yearly-frequency-sunday': 'domingo',
    'yearly-frequency-first': 'primero',
    'yearly-frequency-second': 'segundo',
    'yearly-frequency-third': 'tercero',
    'yearly-frequency-fourth': 'cuarto',
    'yearly-frequency-last': 'último',
    'edit_subscription': 'Editar Enlace de Calendario Compartido',
    'subscribe_to_myq_calendar': 'Compartir Tus Calendarios',
    'add_to_calendar': 'Agrega un calendario MyQ a uno de los siguientes calendarios:',
    'calendar_link_copied': '¡Enlace de calendario copiado al portapapeles!',
    'icalendar_instructions': 'Puedes usar el enlace de iCalendar para agregar un calendario MyQ a cualquier aplicación de calendario que admita el formato iCalendar. Simplemente copia el enlace y pégalo en tu aplicación de calendario, o haz clic en uno de los botones de arriba para agregarlo directamente a tu calendario preferido.',
    'learn_google': 'Más información sobre cómo agregar enlaces de iCalendar a Google Calendar',
    'learn_outlook': 'Más información sobre cómo agregar enlaces de iCalendar a Outlook',
    'learn_apple': 'Más información sobre cómo agregar enlaces de iCalendar a Apple Calendar',
    'icalendar_panel_title': 'Cómo usar un enlace de iCalendar:',
    'confirm_deletion': 'Confirmar Eliminación',
    'confirm_deletion_message': '¿Estás seguro de querer eliminar la suscripción del calendario',
    'confirm_deletion_message_strong': '? Esta acción no se puede deshacer.',
    'delete_2': 'Después de eliminar este calendario, la conexión se perderá y ya no recibirá actualizaciones del calendario de QSRSoft. Si quieres eliminar el calendario compartido por completo, hazlo desde la aplicación correspondiente (Google, Outlook, o Apple)',
    'calendar_name': 'Nombre del Calendario',
    'create_shareable_calendar': 'Crear Calendario Compartible',
    'create_shareable_calendar_2': 'Crear Nuevo Calendario Compartible',
    'choose_calendar': 'Elegir Calendario',
    'this_will_appear_as_the_title_in_your_external_app': 'Esto aparecerá como el título en tu aplicación externa',
    'choose_one_or_more_calendars_to_share': 'Elegir uno o más Calendarios para compartir',
    'your_calendar_name': 'Nombre de tu Calendario',
    'calendar_name_must_be_at_least_1_character': 'El nombre del calendario debe tener al menos 1 carácter',
    'please_select_at_least_one_calendar': 'Por favor, seleccione al menos un calendario',
    'shared_calendars_header': 'Calendarios Compartidos',
    'no_shared_calendars': 'No tienes ningún Enlace de Calendario Compartido.',
    'start_adding_shared_calendars': 'Comienza a agregarlos en la sección "Nuevo Enlace de Calendario Compartido"',
    'or_add_your_calendar': 'O agrega tu calendario a uno de los siguientes calendarios:',
    'new_shared_calendar_link': 'Nuevo Enlace de Calendario Compartido',
    'shared_calendar_links': 'Enlaces de Calendarios Compartidos',
    'continue': 'Continuar',
    'confirm_google_dialog_title': 'Continuar a Google Calendar',
    'confirm_google_dialog_message': 'Google ha actualizado recientemente cómo funcionan las suscripciones de calendario. Para agregar este calendario a Google, necesitarás pegar manualmente el enlace de la suscripción en Google Calendar.',
    'confirm_google_dialog_message_strong': 'Ya hemos copiado el enlace para tu conveniencia. Por favor, haz clic en el botón Continuar para continuar. Una vez redirigido, pega el enlace en el campo de texto de la URL y haz clic en Agregar Calendario.',
    'confirm_google_dialog_message_strong_mobile': 'Ya hemos copiado el enlace para tu conveniencia. Por favor, haz clic en el botón Continuar para continuar. Una vez redirigido, haz clic en el icono \'+\' junto a Otros calendarios en la barra lateral izquierda, selecciona Desde URL, pega el enlace en el campo de texto de la URL y haz clic en Agregar calendario',
    'failed_to_get_subscriptions': 'Error al obtener las suscripciones del calendario',
    'failed_to_add_subscription': 'Error al añadir la suscripción del calendario',
    'failed_to_edit_subscription': 'Error al editar la suscripción del calendario',
    'failed_to_delete_subscription': 'Error al eliminar la suscripción del calendario',
    'failed_to_copy_link': 'Error al copiar el enlace del calendario',
    'calendar_name_required': 'El nombre del calendario es obligatorio',
    'create-ticket': 'Crear Ticket',
    'you-do-not-have-permissions-to-view-this-widget': 'No tienes permisos para ver este widget',
    'my-planned-maintenance': 'Mi Mantenimiento Planificado',
    'error-loading-tasks': 'Error al cargar tareas',
    'tasks-due-by': 'Tarea(s) que vencen antes de',
    'all-tasks-completed': '¡Todas las Tareas Están Completadas!',
    'assigned': 'Asignado(s)',
    'time-left': 'Tiempo Restante',
    'my-planned-maintenance-hours': 'horas',
    'my-planned-maintenance-past-due': 'Vencido(s)',
    'my-planned-maintenance-completed': 'Completado(s)',
    'my-planned-maintenance-none': 'Ninguno(s)',
    'tickets': 'Tickets',
    'error-loading-tickets': 'Error al Cargar Tickets',
    'in-progress': 'En Curso',
    'on-hold': 'En Espera',
    'resolved': 'Resuelto(s)',
    'my-tickets-none': 'Ninguno(s)',
    'planned-maintenance-overview': 'Descripción General del Mantenimiento Planificado',
    'unassigned': 'Sin Asignar',
    'planned-maintenance-error-loading-tasks': 'Error al Cargar Tareas',
    'planned-maintenance-assigned': 'Asignado',
    'planned-maintenance-completed': 'Completados',
    'tickets-overview': 'Descripción General de las Entradas',
    'reported': 'Reportado(s)',
    'accepted': 'Aceptado(s)',
    'tickets-overview-error-loading-tickets': 'Error al Cargar Tickets',
    'favorite-forms': 'Formularios Favoritos',
    'error-loading-forms': 'Error al Cargar Formularios',
    'forms-favorites-title': 'Favoritos de Formularios',
    'forms-favorites-your-favorites': 'Tus Favoritos',
    'forms-favorites-org-favorites': 'Favoritos de la Organizacion',
    'forms-favorites-available-forms': 'Formularios disponibles',
    'forms-favorites-current-favorites': 'Favoritos actuales',
    'forms-favorites-no-favorites-yet': 'Aun no hay favoritos',
    'forms-favorites-add-form-hint': 'Selecciona un formulario arriba para comenzar.',
    'forms-favorites-uncategorized': 'Sin categoria',
    'forms-favorites-unknown-form': 'Formulario desconocido',
    'forms-favorites-load-error': 'No se pudieron cargar los favoritos en este momento. Intentalo de nuevo.',
    'forms-favorites-save-error': 'No se pudieron guardar los cambios. Intentalo de nuevo.',
    'shift-forms': 'Formularios de Turno',
    'forms-all': 'Todos',
    'forms-in-progress-2': 'En Progreso',
    'in-progress-forms': 'Formularios en Proceso',
    'workflow-forms': 'Formularios de Flujo de Trabajo',
    'too-many-locations-selected': 'Se han seleccionado demasiadas ubicaciones. Por favor, seleccione una ubicación.',
    'no-tasks-with-forms': 'No hay tareas con formularios',
    'workflow-forms-error-loading-forms': 'Error al cargar los formularios',
    'task-row-expired': 'Vencido',
    'org-error-message-a': 'Su organización no está suscrita a QSRSoft Premium. Haga clic ',
    'org-error-message-b': ' para obtener más información.',
    'select-one_location': 'Por favor seleccione solo una ubicación',
    'no-tasks-available': 'No hay tareas disponibles - por favor hable con su administrador del sistema',
    'store-time-zone': 'Zona horaria de la tienda',
    'store-hours-gathered': 'Las horas de la tienda se recopilan de la configuración de RFM',
    'user-error-message': 'No tiene permiso para acceder a los formularios. Comuníquese con su administrador del sistema.',
    'work-flow-here': 'aquí',
    'work-flow-missing-permissions': 'Faltan permisos',
    'Recurrence': 'Recurrencia',
    'How often a new instance of a task is due': 'Con qué frecuencia vence una nueva instancia de una tarea',
    'Every': 'Cada',
    'Date': 'Fecha',
    'Next 10 Recurrences': 'Próximas 10 Recurrencias',
    'Starting at': 'Comenzando a las',
    'Due': 'Vencimiento',
    'Ending at': 'Terminando a las',
    'Timezone': 'Zona Horaria',
    'On day': 'En el día',
    'Day of month': 'Día del mes',
    'On the': 'En el',
    'Week': 'Semana',
    'Day': 'Día',
    'Once': 'Una vez',
    'Minute': 'Minuto',
    'Hour': 'Hora',
    'Month': 'Mes',
    'Mon': 'Lun',
    'Tue': 'Mar',
    'Wed': 'Mié',
    'Thu': 'Jue',
    'Fri': 'Vie',
    'Sat': 'Sáb',
    'Sun': 'Dom',
    'First': 'Primer',
    'Second': 'Segundo',
    'Third': 'Tercer',
    'Fourth': 'Cuarto',
    'Last': 'Último',
    'Invalid RRULE': 'RRULE Inválida',
    'Does not repeat': 'No repite',
    'AM': 'AM',
    'PM': 'PM',
    'oepe-trends': 'Tendencias OEPE',
    'kvs-projections': 'Proyecciones de KVS',
    'gc-projections': 'Proyecciones de GC',
    'insights-container-open-late-close-early': 'Abrir Tarde/Cerrar Temprano',
    'stores-with-alerts': '{count} restaurante(s) con alertas activas',
    'stores-with-alerts-suffix': 'restaurante(s) con alertas activas',
    'total-errors': '{count} error(es) activo(s) en total',
    'total-errors-suffix': 'error(es) activo(s) en total',
    'bdc-stores-missing-prefix': 'tienda a la que le falta al menos un | tiendas a las que les falta al menos un',
    'instore-events-insight-old-missing-bdc': 'tienda a la que le falta al menos un | tiendas que le faltan al menos un',
    'message': 'Mensaje',
    'severity': 'Gravedad',
    'timestamp': 'Marca de Tiempo',
    'error': 'Error',
    'warning': 'Advertencia',
    'instore-events-more-info-info': 'Información',
    'number-of-bdc-missing': '# de BDC faltantes',
    'merged-alerts-more-info-business-date': 'Fecha(s) de Negocio',
    'merged-alerts-more-info-info': 'Información',
    'merged-alerts-more-info-more-info': 'Más Información',
    'guest-counts-are': 'Conteo de Clientes',
    'or-more-above': 'o más por encima de las proyecciones en las últimas 2 horas',
    'or-more-below': 'o más por debajo de las proyecciones en las últimas 2 horas',
    'consider-reviewing': 'Considere revisar el personal y la asignación de puestos',
    'gc-projections-threshold': 'Umbral de Proyecciones GC',
    'lower-limit': 'Límite Inferior',
    'upper-limit': 'Límite Superior',
    'bdc-grid-business-date': 'Fecha(s) de Negocio',
    'upcoming-kvs-projected-items': 'Próximamente, artículos proyectados de KVS superan',
    'in-next-15-minutes': 'en los próximos 15 minutos con un lado abierto.',
    'kvs-stores-projected-items-are-above': '{count} tiendas tienen artículos proyectados de KVS que superan',
    'kvs-store-projected-items-are-above': 'Los artículos proyectados de KVS de la tienda {store} superan',
    'consider-2nd-side-opening': 'Considere abrir el segundo lado',
    'breakfast-threshold': 'Umbral de Desayuno',
    'threshold': 'Umbral',
    'kvs-threshold-settings-items': 'Artículos',
    'labor-date': 'Fecha Laboral',
    'act-start': 'Inicio Real',
    'act-end': 'Fin Real',
    'sch-start': 'Inicio Programado',
    'sch-end': 'Fin Programado',
    'act-shift-length': 'Duración Real del Turno',
    'exception': 'Excepción',
    'exception-time': 'Hora de la Excepción',
    'is-manager-authorized': 'Está autorizado por el gerente',
    'punches-1': 'Marcajes 1',
    'punches-2': 'Marcajes 2',
    'punches-3': 'Marcajes 3',
    'punches-4': 'Marcajes 4',
    'punches-5': 'Marcajes 5',
    'punches-6': 'Marcajes 6',
    'there-were': 'Hubo',
    'exceptions-on-minor-employees': 'excepciones en empleados menores',
    'minutes': 'Minutos',
    'days-missed-limit': 'El límite de días perdidos se puede ajustar en la configuración de insights.',
    'filter-open-late-msg': '** Mostrando tiendas que han abierto tarde más que el límite de días perdidos ({days} días) en las últimas 7 aperturas.',
    'filter-close-early-msg': '** Mostrando tiendas que han cerrado temprano más que el límite de días perdidos ({days} días) en los últimos 7 cierres.',
    'olce-grid-open-late-close-early': 'Abrir Tarde/Cerrar Temprano',
    'olce-grid-filter': 'Filtrar',
    'olce-grid-open-late': 'Abierto Tarde',
    'olce-grid-close-early': 'Cerrado Temprano',
    'may-have': 'puede tener',
    'late-opens': 'o más aperturas tarde en 7 días.',
    'early-closes': 'o más cierres temprano en 7 días.',
    'olce-insight-open-late-close-early': 'Tarde/Temprano',
    'olce-insight-store': 'tienda',
    'days-missed': 'Días Perdidos',
    'ot-threshold-setting-hours': 'Horas',
    'employees-on-track': 'empleados están en camino de trabajar más de',
    'hours-this-week': 'horas esta semana.',
    'you-currently-have': 'Actualmente tienes',
    'items-out': 'artículos fuera en los últimos',
    'product-outage-insight-days': 'días.',
    'product-outage-insight-product-outage': 'Interrupción Producto',
    'active-product-outages': 'Interrupciones Producto Activas',
    'thirty-day-terms': 'Términos de 30 días',
    'ninety-day-terms': 'Términos de 90 días',
    'crew-type': 'Tipo de Empleados',
    'hire': 'Contratación',
    'termination': 'Terminación',
    'merged-terms-more-info-more-info': 'Más Información',
    'crew-termed-in-the-first': 'empleado(s) denominado(s) en los primeros',
    'days-since-hire': 'días desde la contratación',
    'no-30-day-terms': 'Sin bajas en los primeros 30 días desde la contratación.',
    'your-ninety-day-turnover-is-over': 'La rotación supera',
    'with': 'con',
    'crew-terminated-within': 'personal despedido dentro de',
    'you-have': 'Tiene',
    's': 'es',
    'with-90-day-turnover-above': 'con una rotación de 90 días superior al',
    'no-90-day-terms': 'Sin ubicaciones por encima del umbral de rotación de 90 días.',
    'people-terms-insight-thirty-day-terms': '30 Días',
    'people-terms-insight-ninety-day-terms': '90 Días',
    'people-terms-insight-location': 'ubicación',
    'seconds': 'Segundos',
    'your-oepe-no-park': 'Tu OEPE No Park ha subido en',
    'seconds-from-the-weekly-trend': 'segundos sobre la tendencia semanal.',
    'consider-parking-cars': 'Considere estacionar autos',
    'drawers-with-suspicious-activities': 'casos',
    'please-subscribe': 'Por favor suscríbase',
    'please-subscribe-verbiage': 'Suscríbase a Seguridad para ver todas las instancias de actividad sospechosa',
    'learn-more': 'Aprende más',
    'suspicious-activity-insight-suspicious-activity': 'Actividad Sospechosa',
    'shared-link-settings': 'Configuración de enlaces compartidos',
    'add-link': 'Agregar enlace',
    'there-are-currently-no-third-party-links': 'Actualmente no hay enlaces de terceros',
    'label-cannot-be-blank': 'La etiqueta no puede estar en blanco',
    'url-cannot-be-blank': 'La URL no puede estar en blanco',
    'links-settings-label': 'Etiqueta',
    'loading': 'Cargando...',
    'no-shared-links-have-been-added': 'No se han agregado enlaces compartidos para su organización.',
    'daily-activity': 'Actividad Diaria',
    'the-three-week-trend-is-calculated': 'La tendencia de 3 semanas se calcula en base al promedio de las últimas 3 semanas del mismo día de la semana.',
    'three-week-trend': 'Tendencia de 3 Semanas',
    'pivot-table': 'Tabla Dinámica',
    'show-all-qtr-hrs': 'Mostrar Todos los Trimestres',
    'dar-settings-row-settings': 'Configuración de Fila',
    'goal-settings': 'Configuración de Objetivos',
    'percent-to-improve': '% a mejorar',
    'driveThruHME': 'Auto-servicio de HME',
    'numbers-indicate-employee-hours-this-week': 'Los números indican las horas de los empleados esta semana - horas trabajadas más las programadas restantes. Las filas resaltadas indican menores.',
    'please-select-only-one-location': 'Por favor, seleccione solo una ubicación',
    'no-data-available': 'No hay datos disponibles',
    'not-scheduled': 'No Programado',
    'employee-roster-error-loading': 'Error al cargar',
    'expandable-search-search': 'Buscar...',
    'roster-filter-job-title-code': 'Código de Título de Trabajo',
    'working-today': 'Trabajando Hoy',
    'working': 'TRABAJANDO',
    'scheduled-employees-error-loading': 'Error al cargar',
    'scheduled-employees-upcoming': 'PRÓXIMO',
    'select-locations': 'Seleccione una o más ubicaciones',
    'at-least-one-location-required': 'Se requiere al menos una ubicación',
    'location-selector-locations': 'Ubicaciones',
    'task-list': 'Lista de Tareas',
    'failed-to-load-tasks': 'Error al cargar las tareas',
    'new-task': 'Nueva Tarea',
    'description-required': 'Descripción requerida',
    'max-140-characters': 'Máximo 140 caracteres',
    'complete-task': '¿Completar tarea?',
    'this-task-will-be-archived-and-removed': 'Esta tarea será archivada y eliminada de la lista del restaurante. ¿Continuar?',
    'Today': 'Hoy',
    'All': 'Todas',
    'task-list-no-tasks-available': 'No hay tareas disponibles',
    'task-list-complete': 'Completar',
    // Migrated from <i18n> SFC blocks (#6500)
    'trading-day': 'Día de negociación',
    'calendar-day': 'Día de calendario',
    'create-scorecard': 'Crear Scorecard',
    'max-scorecards': 'Se alcanzó el número máximo de scorecards',
    'name-assign': 'Nombre y Asignar',
    'select-metrics': 'Seleccionar Métricas',
    'set-goals': 'Establecer Metas',
    'qsr-defaults': 'Valores Predeterminados QSR',
    'defaults': 'Predeterminados',
    'click-cells-to-edit': 'Haz clic en las celdas para editar como en Excel',
    'scorecard-settings': 'Configuración de Scorecards',
    'goals': 'Metas',
    'score-card-container-settings-scorecards': 'Scorecards',
    'score-card-settings-are-you-sure': '¿Estás seguro de que quieres eliminar este scorecard?',
    'score-card-settings-scorecard-settings': 'Configuración de Scorecard',
    'score-card-settings-settings': 'Configuración',
    'score-card-settings-delete-scorecard': 'Eliminar Scorecard',
    'products-selected': 'productos seleccionados',
    'menu-items': 'Artículos del Menú',
    'watchlists': 'Listas de Seguimiento',
    'pmix-settings': 'Configuración de PMIX',
    'columns': 'Columnas',
    'products': 'Productos',
    'today-container-today': 'Hoy (Legado)',
    // Migrated from <i18n> SFC blocks (#6500)
    'preview-mode': 'Modo de Vista Previa',
    'preview-mode-subtitle': 'Revisando cambios sin guardar. Guarda para conservarlos o descarta para revertir.',
    'exit-preview': 'Salir de la Vista Previa',
    dashboard: 'Tablero',
    widget: 'Widget',
    shiftRunner: 'Corredor de Turno',
    insights: 'Perspectivas',
    due: 'Vence',
    expired: 'Vencido',
    upcoming: 'Próximo',
    completed: 'Completado',
    learnMore: 'Aprende más',
    pleaseSubscribe: 'Por favor suscríbase',
    // CreateDashboard
    'create-dashboard': 'Crear Panel',
    name: 'Nombre',
    roles: 'Roles',
    'starting-point': 'Punto de Partida',
    'name-description':
      'Seleccione un nombre para su panel. Los usuarios verán este nombre en el selector.',
    'roles-description':
      'Seleccione roles para su panel. Los usuarios asignados a estos roles podrán ver y elegir este panel.',
    'starting-point-description':
      'Elija un punto de partida. Puede elegir un panel de QSRSoft, otro panel que haya creado, o un lienzo en blanco.',
    cancel: 'Cancelar',
    back: 'Atrás',
    next: 'Siguiente',
    preview: 'Vista Previa',
    'name-required': 'El nombre es obligatorio',
    'name-exists': 'Ya existe un panel con ese nombre',
    'roles-required': 'Los roles son obligatorios',
    'blank-canvas': 'Lienzo en Blanco',
    'qsr-presets': 'Presets de QSR',
    'your-saved-dashboards': 'Sus Paneles Guardados',
    // ResetDashboard
    'reset-dashboard': 'Restablecer Panel',
    'reset-description':
      'Elija un punto de partida para restablecer el panel seleccionado. Puede elegir un panel de QSRSoft o un lienzo en blanco. Después de seleccionar un punto de partida, haga clic en el botón Guardar para aplicar los cambios.',
    // Settings
    'widget-settings': 'Configuración de Widgets',
    'row-settings': 'Configuración de Filas',
    'column-settings': 'Configuración de Columnas',
    close: 'Cerrar',
    save: 'Guardar',
    // DashboardContainerSettingsMulti
    customizeDashboardContainers: 'Personalizar Contenedores del Panel',
    unableToSaveSettings: 'No se pudo guardar la configuración del panel.',
    unableToResetSettings: 'No se pudo restablecer la configuración del panel.',
    // no_favorites_card
    noShortcuts: 'No tiene accesos directos de carpetas o archivos.',
    add: 'Agregar',
    // Shared
    moreInfo: 'Más Información',
    noData: 'Sin Datos',
    loadError: 'No se pudieron cargar los datos',
    actual: 'Real',
    current: 'Actual',
    // BudgetWidget
    budget: 'Presupuesto',
    fiscalPeriod: 'Período Fiscal',
    vsBudget: 'Vs Presupuesto',
    // FoodWidget
    food: 'Alimentos',
    week: 'Semana',
    // TextSettings
    bulletinBoardSettings: 'Configuración del Tablón de Anuncios',
    addText: 'Agregar Texto',
    isLink: 'es enlace',
    url: 'URL',
    text: 'Texto',
    // BUSalesRankPopUp
    oneYearComp: 'Comparar 1 Año',
    twoYearComp: 'Comparar 2 Años',
    // VoiceSmiley
    voice: 'VOZ',
    surveys: 'Encuestas',
    numSurveys: '# de Encuestas',
    voiceInfoText:
      'Los datos se reciben 2 días después de SMG y se agrupan por fecha de visita del cliente. SMG usa por defecto la fecha de la encuesta del cliente. Debido a estas diferencias, <strong>no</strong> se debe esperar que los sitios coincidan.',
    // SmileySettings
    metric: 'Métrica',
    all: 'Todos',
    metrics: 'Métricas',
    differentThresholds:
      'Las métricas seleccionadas tienen valores de umbral diferentes.',
    orSelectFewer: 'o seleccione menos métricas.',
    groupedMetrics: 'Estas son las métricas agrupadas:',
    group: 'Grupo',
    happyUpper: 'feliz superior',
    happyLower: 'feliz inferior',
    neutralLower: 'neutral inferior',
    // RMHC / Round Up
    roundUp: 'Redondeo',
    helpingHands: 'Manos que Ayudan',
    mtdDollar: 'MTD $',
    mtdCount: 'MTD Cantidad',
    progressGoal: 'Progreso / Meta',
    pctToGoal: '% de Meta:',
    goalsHit: 'Metas alcanzadas:',
    orgSettingsChanging: 'Configuración de Org Cambiando',
    orgSettingsConfirm:
      'Está a punto de cambiar la configuración a nivel de Org. ¿Está seguro?',
    no: 'No',
    donationDollar: 'Donación $',
    donationCount: 'Cantidad de Donaciones',
    goal: 'Meta',
    numOfDonations: '# de Donaciones',
    donationsDollar: 'Donaciones $',
    donationsCountGoal: 'Meta de Cantidad de Donaciones',
    donationsDollarGoal: 'Meta de Donaciones $',
    pctOfGoal: '% de Meta',
    // Voice row labels
    voiceOverall: 'General',
    beNice: 'Ser Amable',
    beFast: 'Ser Rápido',
    quality: 'Calidad',
    clean: 'Limpieza',
    accuracy: 'Precisión',
    // VoiceContainer
    customerFeedbackAndDonations: 'Comentarios de Clientes y Donaciones',
    // BigArch / Incentives
    bigArch: 'Big Arch',
    'hot-honey': 'Hot Honey',
    'snack-wraps': 'Bocadillos Envueltos',
    // Shared incentive keys
    'incentive-rank-out-of': 'Clasificación sobre',
    'incentive-restaurants': 'Restaurantes',
    'incentive-rank': 'Clasificación',
    'incentive-rank-compared':
      'Clasificación de la tienda en comparación con todo el BU',
    'incentive-units-1k-gc': 'Unidades/1K GC',
    'incentive-units-1k-rod-gc': 'Unidades/1K ROD GC',
    // BigArchWidget
    'big-arch-units': 'Unidades de Big Arch',
    'big-arch-sold-related':
      'Número de artículos del menú vendidos relacionados con Big Arch durante el Resto del Día (ROD) por cada mil unidades.',
    'big-arch-menu-items':
      'Los artículos del menú asociados son 25442, 25443 y 25444',
    // HotHoneyWidget
    'hot-honey-units': 'Unidades de Hot Honey',
    'hot-honey-sold-related':
      'Número de artículos del menú vendidos relacionados con Hot Honey durante el Resto del Día (ROD) por cada mil unidades.',
    // SnackWrapsWidget
    'wrap-units': 'Unidades de Wrap',
    'snack-wraps-message':
      'Snack Wrap ahora se informan como elementos individuales aquí',
    'snack-wraps-sold-related':
      'Número de artículos del menú vendidos relacionados con Wraps durante el Resto del Día (ROD) por cada mil unidades.',
    // IncentiveContainer
    leaderboard: 'Tabla de Clasificación',
    'mccrispy-strips': 'Tiras McCrispy',
    'round-up-pos': 'Redondear POS/Empleado',
    '3d-gc-incentive': 'Incentivo de Cuenta de Invitados 3D',
    'default-incentives': 'Incentivos Predeterminados',
    'new-beverage': 'Nuevas Bebidas',
    // BUGrid
    org: 'Org',
    orgVs: 'Org vs',
    // BusinessUnitContainer
    comp: 'Comparar',
    sales: 'Ventas',
    service: 'Servicio',
    labor: 'Labor',
    'digital-app': 'Aplicación Digital',
    'addon-subscribed': 'Complemento BU · Suscrito',
    'addon-upgrade': 'Complemento BU · Actualizar',
    'addon-upgrade-tooltip':
      'Hable con el líder de su BU sobre cómo agregar la Suscripción de Business Unit para obtener visibilidad a las vistas de Comparación BU',
    'bu-no-visibility':
      'No tiene visibilidad a la vista de Comparación BU por una o más de las siguientes razones:',
    'bu-app-backgrounded':
      'En dispositivos móviles, la aplicación ha estado en segundo plano demasiado tiempo. Si es así, cierre y reinicie la aplicación.',
    'bu-no-subscription':
      'Su Unidad de Negocio no está suscrita al producto BU Data & Analytics',
    'bu-opted-out':
      'Ha "optado por no participar" en la Administración de MyQSRSoft para compartir datos de BU.',
    'bu-contact-leadership':
      'Por favor contacte a su liderazgo de BU con preguntas sobre la suscripción de BU y las vistas de reportes asociadas.',
    // BUCompTypeSelector
    'comp-calendar': 'Calendario',
    'comp-trading': 'Trading',
    'comp-same-store': 'Misma Tienda',
    'comp-all-store': 'Todas las Tiendas',
    // BUSales tooltip
    'bu-financial-info':
      'Financiero se usa para la mitad del mes actual o rangos de fechas que se extienden fuera de meses completados. Financiero excluye ubicaciones que no han estado abiertas por 13 meses completos. El valor predeterminado para Financiero es Comparación por Día de Trading.',
    'bu-analytic-info':
      'Analítico se usa para meses completados y rangos de fechas que incluyen meses completados. Analítico usa una regla de 5 días. Si a una ubicación le faltan ventas por 5 o más días (en el Año Actual o el Año Anterior) se excluye del cálculo. El valor predeterminado para Analítico es Comparación por Día de Calendario.',
    'bu-financial-info-rank':
      'Financiero se usa para la mitad del mes actual o rangos de fechas que se extienden fuera de meses completados. Financiero excluye ubicaciones que no han estado abiertas por 13 meses completos. El valor predeterminado es Comparación por Día de Trading.',
    'bu-analytic-info-rank':
      'Analítico se usa para meses completados y rangos de fechas que incluyen meses completados. Analítico usa una regla de 5 días. Si a una ubicación le faltan ventas por 5 o más días (en el Año Actual o el Año Anterior) se excluye del cálculo. El valor predeterminado es Comparación por Día de Calendario.',
    // BUSales rows
    'bu-row-sales': 'Ventas',
    'bu-row-gcs': "GC's",
    'bu-row-avg-sales': 'Ventas Prom.',
    'bu-row-avg-check': 'Cheque Promedio',
    'bu-row-avg-check-diff': 'Cheque Promedio +/-',
    'bu-row-avg-check-diff-pct': 'Cheque Promedio +/- %',
    'bu-row-bfast-gcrd': 'Desayuno GC/R/D',
    'bu-row-bfast-gcrd-diff': 'Desayuno GC/R/D +/-',
    'bu-row-bfast-pct-sales': 'Desayuno % de Ventas',
    'bu-row-mcdelivery-avg-check': 'McDelivery Cheque Promedio',
    'bu-row-mcdelivery-gcrd': 'McDelivery GC/R/D',
    'bu-row-mcdelivery-gcrd-diff': 'McDelivery GC/R/D +/-',
    'bu-row-gma-del-avg-check': 'GMA Del Cheque Promedio',
    'bu-row-gma-del-gcrd-diff': 'GMA Del GC/R/D +/-',
    'bu-row-3po-avg-check': '3P0 Cheque Promedio',
    'bu-row-3po-gcrd-diff': '3P0 GC/R/D +/-',
    'bu-row-dt-pct-sales': 'DT % de Ventas Totales',
    'bu-row-dt-gcrd': 'DT GC/R/D',
    'bu-row-dt-gcrd-diff': 'DT GC/R/D +/-',
    // BUPeaksService format info tooltip
    'bu-peaks-timeslice-label': 'Franja horaria',
    'bu-peaks-show-details': 'Mostrar detalles',
    'bu-peaks-comp-short-same': 'Misma',
    'bu-peaks-comp-short-all': 'Todas',
    'bu-peaks-comp-basis': 'Base de comparación. Misma: cuenta solo los días-tienda presentes en ambos años. Todas: cuenta todos los días-tienda.',
    'bu-peaks-format-info-diff': 'Los valores predeterminados muestran la diferencia relativa con respecto a su BU',
    'bu-peaks-format-info-detail': 'Active "Mostrar detalles" para ver los valores originales de BU y Org de cada métrica',
    // BUService rows
    'bu-row-oepe-no-park': 'OEPE Sin Estac.',
    'bu-row-oepe-no-park-diff': 'OEPE Sin Estac. +/-',
    'bu-row-oepe': 'OEPE',
    'bu-row-oepe-diff': 'OEPE +/-',
    'bu-row-r2p': 'R2P',
    'bu-row-r2p-diff': 'R2P +/-',
    'bu-row-avg-ctp': 'CTP Prom.',
    'bu-row-avg-ctp-diff': 'CTP Prom. +/-',
    'bu-row-kvs-items-gc': 'KVS Artículos / GC',
    'bu-row-kvs-items-gc-diff': 'KVS Artículos / GC +/-',
    'bu-row-kvs-time-gc': 'KVS Tiempo / GC',
    'bu-row-kvs-time-gc-diff': 'KVS Tiempo / GC +/-',
    'bu-row-dt-pulled-fwd': 'DT Adelantado %',
    'bu-row-dt-pulled-fwd-diff': 'DT Adelantado % +/-',
    'bu-row-healthy-use': 'Uso Saludable',
    'bu-row-healthy-use-diff': 'Uso Saludable +/-',
    'bu-row-sales-r-d': 'Ventas/R/D',
    'bu-row-sales-r-d-diff': 'Ventas/R/D +/- %',
    'bu-row-gc-r-d': 'GC/R/D',
    'bu-row-gc-r-d-diff': 'GC/R/D +/- %',
    'bu-row-dt-sales-r-d': 'DT Ventas/R/D',
    'bu-row-dt-sales-r-d-diff': 'DT Ventas/R/D +/- %',
    'bu-row-fc-sales-r-d': 'FC Ventas/R/D',
    'bu-row-fc-sales-r-d-diff': 'FC Ventas/R/D +/- %',
    'bu-row-fc-gc-r-d': 'FC GC/R/D',
    'bu-row-fc-gc-r-d-diff': 'FC GC/R/D +/- %',
    'bu-row-kiosk-sales-r-d': 'Kiosco Ventas/R/D',
    'bu-row-kiosk-sales-r-d-diff': 'Kiosco Ventas/R/D +/- %',
    'bu-row-kiosk-gc-r-d': 'Kiosco GC/R/D',
    'bu-row-kiosk-gc-r-d-diff': 'Kiosco GC/R/D +/- %',
    'bu-row-moa-sales-r-d': 'MOA Ventas/R/D',
    'bu-row-moa-sales-r-d-diff': 'MOA Ventas/R/D +/- %',
    'bu-row-moa-gc-r-d': 'MOA GC/R/D',
    'bu-row-moa-gc-r-d-diff': 'MOA GC/R/D +/- %',
    'bu-row-delivery-sales-r-d': 'Entrega Ventas/R/D',
    'bu-row-delivery-sales-r-d-diff': 'Entrega Ventas/R/D +/- %',
    'bu-row-delivery-gc-r-d': 'Entrega GC/R/D',
    'bu-row-delivery-gc-r-d-diff': 'Entrega GC/R/D +/- %',
    'bu-row-dt-avg-check': 'DT Cheque Promedio',
    'bu-row-dt-avg-check-diff': 'DT Cheque Promedio +/-',
    'bu-row-fc-avg-check': 'FC Cheque Promedio',
    'bu-row-fc-avg-check-diff': 'FC Cheque Promedio +/-',
    'bu-row-kiosk-avg-check': 'Kiosco Cheque Promedio',
    'bu-row-kiosk-avg-check-diff': 'Kiosco Cheque Promedio +/-',
    'bu-row-moa-avg-check': 'MOA Cheque Promedio',
    'bu-row-moa-avg-check-diff': 'MOA Cheque Promedio +/-',
    'bu-row-delivery-avg-check': 'Entrega Cheque Promedio',
    'bu-row-delivery-avg-check-diff': 'Entrega Cheque Promedio +/-',
    'bu-digital-customer-count': 'Cantidad de Clientes Digitales',
    'bu-row-dt-gcrd-diff-pct': 'DT GC/R/D +/- %',
    'bu-row-avg-check-short': 'Cheque Promedio',
    'bu-row-avg-check-short-diff': 'Cheque Promedio +/-',
    // BULabor rows
    'bu-row-crew-labor': 'Labor Equipo %',
    'bu-row-actual-labor': 'Labor Real %',
    'bu-row-avg-rate': 'Tarifa Prom.',
    'bu-row-tpph': 'TPPH',
    'bu-row-total-labor': 'Labor Total %',
    // BUFood rows
    'bu-row-base-food': 'Alimento Base %',
    'bu-row-comp-waste': 'Desperdicio Comp %',
    'bu-row-condiments': 'Condimentos %',
    'bu-row-discount': 'Descuento %',
    'bu-row-emp-meals': 'Comidas Emp. %',
    'bu-row-fob': 'FOB %',
    'bu-row-raw-waste': 'Desperdicio Crudo %',
    'bu-row-stat-var': 'Var. Estad. %',
    'bu-row-unexplained': 'Sin Explicar %',
    'bu-row-pnl-food-cost': 'PNL Costo Alimento %',
    'bu-row-pnl-paper-cost': 'PNL Costo Papel %',
    // BUDigitalApp rows
    'bu-row-digital-sales': 'Ventas Digitales %',
    'bu-row-digital-gc': 'GC Digital %',
    'bu-row-digital-avg-check': 'Cheque Prom. Digital',
    'bu-row-digital-grd': 'Digital G/R/D',
    'bu-row-scanned-offer-sales': 'Ventas Oferta Escaneada',
    'bu-row-scanned-offer-gcs': "GC's Oferta Escaneada",
    'bu-row-scanned-offer-avg-check': 'Cheque Prom. Oferta Escaneada',
    'bu-row-scanned-offer-grd': 'Oferta Escaneada G/R/D',
    'bu-row-gma-delivery-sales': 'Ventas Entrega GMA',
    'bu-row-gma-delivery-gcs': "GC's Entrega GMA",
    'bu-row-gma-delivery-avg-check': 'Cheque Prom. Entrega GMA',
    'bu-row-gma-delivery-grd': 'Entrega GMA G/R/D',
    'bu-row-loyalty-sales': 'Ventas Lealtad Self ID',
    'bu-row-loyalty-gcs': "GC's Lealtad Self ID",
    'bu-row-loyalty-avg-check': 'Cheque Prom. Lealtad Self ID',
    'bu-row-loyalty-grd': 'Lealtad Self ID G/R/D',
    'bu-row-mop-offer-sales': 'MOP C/ Oferta Ventas',
    'bu-row-mop-offer-gcs': "MOP C/ Oferta GC's",
    'bu-row-mop-offer-avg-check': 'MOP C/ Oferta Cheque Prom.',
    'bu-row-mop-offer-grd': 'MOP C/ Oferta G/R/D',
    'bu-row-mop-no-offer-sales': 'MOP S/ Oferta Ventas',
    'bu-row-mop-no-offer-gcs': "MOP S/ Oferta GC's",
    'bu-row-mop-no-offer-avg-check': 'MOP S/ Oferta Cheque Prom.',
    'bu-row-mop-no-offer-grd': 'MOP S/ Oferta G/R/D',
    'bu-row-mop-curb-gcs': "MOP Acera GC's %",
    'bu-row-mop-fc-gcs': "MOP FC GC's %",
    'bu-row-mop-table-gcs': "MOP Mesa GC's %",
    'bu-row-mop-dt-gcs': "MOP DT GC's %",
    // BUVoice rows
    'bu-row-overall': 'General %',
    'bu-row-friendliness': 'Amabilidad %',
    'bu-row-fast': 'Rapidez %',
    'bu-row-quality': 'Calidad %',
    'bu-row-cleanliness': 'Limpieza %',
    'bu-row-accuracy': 'Precisión %',
    'bu-row-dt-overall': 'DT General %',
    'bu-row-dt-friendliness': 'DT Amabilidad %',
    'bu-row-dt-fast': 'DT Rapidez %',
    'bu-row-dt-quality': 'DT Calidad %',
    'bu-row-dt-cleanliness': 'DT Limpieza %',
    'bu-row-dt-accuracy': 'DT Precisión %',
    'bu-row-fc-overall': 'FC General %',
    'bu-row-fc-friendliness': 'FC Amabilidad %',
    'bu-row-fc-fast': 'FC Rapidez %',
    'bu-row-fc-quality': 'FC Calidad %',
    'bu-row-fc-cleanliness': 'FC Limpieza %',
    'bu-row-fc-accuracy': 'FC Precisión %',
    // BUTurnover rows
    'bu-row-crew-mth-ann-turnover': 'Rotación Anual Mes Equipo',
    'bu-row-crew-3mo-turnover': 'Rotación 3 Meses Equipo',
    'bu-row-crew-term': 'Baja Equipo',
    'bu-row-avg-crew-hire': 'Contratación Prom. Equipo',
    'bu-row-crew-roster': 'Plantilla Equipo',
    'bu-row-crew-ttm-turnover': 'Rotación TTM Equipo',
    'bu-row-crew-ytd-turnover': 'Rotación YTD Equipo',
    'bu-row-shift-mth-ann-turnover': 'Rotación Anual Mes Turno',
    'bu-row-shift-3mo-turnover': 'Rotación 3 Meses Turno',
    'bu-row-shift-term': 'Baja Turno',
    'bu-row-avg-shift-hire': 'Contratación Prom. Turno',
    'bu-row-shift-roster': 'Plantilla Turno',
    'bu-row-shift-ttm-turnover': 'Rotación TTM Turno',
    'bu-row-shift-ytd-turnover': 'Rotación YTD Turno',
    // BUDigitalOrderPts rows
    'bu-row-dop-digital-gc': 'GC Digital %',
    'bu-row-dop-digital-sales': 'Ventas Digitales %',
    'bu-row-dop-digital-grd': 'Digital G/R/D',
    'bu-row-dop-mop-gcs': "MOP GC's %",
    'bu-row-dop-mop-sales': 'MOP Ventas %',
    'bu-row-dop-mop-gcrd': 'MOP GC/R/D',
    'bu-row-dop-gma-del-gc': 'GMA Del GC %',
    'bu-row-dop-gma-del-sales': 'GMA Del Ventas %',
    'bu-row-dop-gma-del-grd': 'GMA Del G/R/D',
    'bu-row-dop-kiosk-gc': 'Kiosco GC %',
    'bu-row-dop-kiosk-sales': 'Kiosco Ventas %',
    'bu-row-dop-kiosk-grd': 'Kiosco G/R/D',
    'bu-row-dop-delivery-gc': 'Entrega GC %',
    'bu-row-dop-delivery-sales': 'Entrega Ventas %',
    'bu-row-dop-delivery-grd': 'Entrega G/R/D',
    // BUDateRange
    'start-date': 'Fecha de Inicio',
    'end-date': 'Fecha de Fin',
    // BUSalesRankPopUp
    'bu-sales': 'Ventas BU',
    rankings: 'Rankings',
    'custom-date-range-bu': 'Rango de Fechas Personalizado',
    thru: 'Hasta',
    // BUDigitalApp
    'fo-disclaimer':
      'Los resultados de ventas de FO se muestran después de la publicación trimestral de ventas de McDonalds.',
    // BUVoice
    'voice-rankings': 'Clasificaciones de Voz',
    'bu-comp-type-disclaimer':
      'Este widget solo está disponible para tipos de comparación de Unidad de Negocio y Oficina de Campo.',
    'voice-data-behind':
      'Los datos de voz generalmente tienen 2 días de retraso. Por favor seleccione un rango de fechas anterior',
    // BUTurnover
    people: 'Personas',
    'people-metrics-full-months':
      'Las métricas de personas se calculan usando meses completos.',
    'people-multiple-months':
      'Si se seleccionan varios meses, se usa el mes completo más reciente.',
    'people-partial-month':
      'Si un mes pasado se selecciona parcialmente, se usa el mes completo.',
    'people-detailed-breakdown':
      'Para un desglose detallado, consulte el reporte de Ranking BU.',
    'people-requires-full-month':
      'Los datos de personas requieren un rango de fechas de mes completo',
    // BUDigitalOrderPts
    'digital-order-pts': 'Puntos de Pedido Digital',
    // BUAppTrends
    'bu-loyalty-trend': 'Tendencia Activa de 90 Días de Lealtad BU',
    'bu-loyalty-tooltip':
      'Número de clientes únicos que realizaron al menos un pedido digital en el período de 90 días. Debido a que un cliente puede visitar más de un restaurante en una organización, este número no se puede sumar entre restaurantes.',
    // Consulting
    qsrsoftConsultingServices: 'Servicios de Consultoría QSRSoft',
    consultingHelpsCapture:
      'QSRSoft Consultoría ayuda a capturar oportunidades de flujo de caja',
    cashflowOpportunity: 'Oportunidad de Flujo de Caja',
    total: 'Total',
    laborPotentialCF: 'Potencial CF Laboral',
    fobPotentialCF: 'Potencial CF FOB',
    buGCGapPotentialCF: 'Potencial CF Brecha GC BU',
    // File Manager
    resourceLibrary: 'Biblioteca de Recursos',
    // Calendar
    calendar: 'Calendario',
    all_roles: 'Todos los Roles',
    'cal-role-crew': 'Equipo',
    'cal-role-shift-manager': 'Jefe de Turno',
    'cal-role-department-manager': 'Gerente de Departamento',
    'cal-role-general-manager': 'Gerente General',
    'cal-role-mid-manager': 'Gerente Intermedio',
    'cal-role-owner-operator': 'Dueño Operador',
    'cal-role-system-administrators': 'Administradores del Sistema',
    organization_calendar: 'Calendario de la Organización',
    'cal-days': 'Días',
    'cal-pick-a-day': 'Elige un día',
    'cal-new-event': 'Nuevo evento',
    'cal-open-calendar': 'Abrir calendario',
    'cal-open-day': 'Abrir día',
    'mc-open-report': 'Abrir informe',
    'mc-updated-at': 'Actualizado {time}',
    'mc-refresh': 'Actualizar',
    'mc-goals-hit': '{hit} de {total} metas',
    'mc-goals-short': '{hit} / {total}',
    'mc-actual': 'Real',
    'mc-goal': 'Meta',
    'mc-diff': 'Dif.',
    'mc-dayparts': 'Franjas horarias',
    'mc-peaks': 'Picos',
    'mc-custom-range': 'Rango de fechas personalizado',
    'mc-previous-period': 'Período anterior',
    'mc-next-period': 'Período siguiente',
    'mc-rank-stores': 'Clasificar tiendas',
    'mc-new-scorecard': 'Nueva tarjeta de puntuación',
    'mc-trend': 'Tendencia',
    'mc-metric': 'Métrica',
    'mc-item': 'Artículo',
    'cal-options': 'Opciones de calendario',
    'cal-shared-links': 'Enlaces de calendario compartidos',
    'cal-yesterday': 'Ayer',
    'cal-today': 'Hoy',
    'cal-tomorrow': 'Mañana',
    'cal-all-day': 'Todo el día',
    'cal-upcoming': 'Próximos',
    'cal-events': 'Eventos',
    'cal-earlier': 'Anteriores',
    'cal-nothing-scheduled': 'Nada programado',
    'cal-add-event': 'Agregar un evento',
    'cal-no-events': 'Sin eventos',
    'cal-one-event': '1 evento',
    'cal-n-events': '{n} eventos',
    'cal-n-timed': '{n} con hora',
    'cal-n-all-day': '{n} todo el día',
    'cal-n-celebrations': '{n} celebraciones',
    'cal-across-days': 'en estos días',
    'cal-dur-minutes': '{n} min',
    'cal-dur-hours': '{n} h',
    'cal-dur-hours-minutes': '{h} h {m} min',
    'cal-dur-days': '{n} días',
    'cal-error-loading': 'Error al cargar eventos',
    'cal-share-premium-header': 'Compartir Calendarios es una función premium',
    'cal-share-premium-description': 'Para compartir calendarios, necesitas ser un usuario premium.',
    'cal-create-premium-header': 'Crear Eventos es una función premium',
    'cal-create-premium-description': 'Para crear o editar eventos, necesitas ser un usuario premium.',
    shared_calendar: 'Compartido',
    birthdays: 'Cumpleaños',
    work_anniversaries: 'Aniversarios Laborales',
    // ScoreCard
    scorecards: 'Cuadros de Mando',
    'please-contact-org-admin':
      'Por favor, contacte a su administrador de organización para crear un cuadro de mando.',
    mtd: 'MDH',
    'last-month': 'El Mes Pasado',
    ytd: 'ADH',
    color: 'Color',
    'scorecard-setting': 'Configuración del Cuadro de Mando',
    settings: 'Configuraciones',
    delete: 'Eliminar',
    'delete-scorecard': 'Eliminar Cuadro de Mando',
    'are-you-sure':
      '¿Está seguro de que desea eliminar este cuadro de mando? Esta acción no se puede deshacer.',
    'avg-goal': 'Meta Promedio',
    diff: 'Diferencia',
    // TH Dashboard - Insights
    'did-you-know': '¿Sabías que?',
    'employee-requests': 'Solicitudes de Empleados',
    waste: 'Desperdicio',
    'closing-hours': 'Horas de Cierre',
    // WasteInsight template
    'waste-insight-text':
      '{dateText}, tienes {count} {storeWord} que faltan al menos {threshold} {dayWord} de desperdicio registrado',
    'store-singular': 'tienda',
    'store-plural': 'tiendas',
    'day-singular': 'día',
    'day-plural': 'días',
    // ClosingHourInsight template
    'closing-hour-insight-text':
      '{dateText}, tienes {lobbyCount} lobbies y {dtCount} DTs donde la última transacción fue {threshold} minutos o más antes de la hora de cierre',
    // TH Dashboard - Today
    today: 'Hoy',
    'current-day-sales': 'Ventas del Día Actual',
    'current-day-service': 'Servicio del Día Actual',
    'current-day-updates-around':
      'Actualización del día actual alrededor de las {time}',
    // TH Dashboard - Snapshot
    snapshot: 'Resumen',
    'dayparts-sales': 'Ventas por Período',
    'dayparts-service': 'Servicio por Período',
    'open-11am': 'Apertura - 11am',
    '11am-close': '11am - Cierre',
    'service-times': 'Tiempos de Servicio',
    // TH CurrentDaySales / SalesWidget rows
    'th-row-net-sales': 'Ventas Netas',
    'th-row-transactions': 'Transacciones',
    'th-row-refund-transactions': 'Transacciones de Reembolso',
    'th-row-eat-in-trans': 'Trans. Comer Aquí',
    'th-row-eat-in-refund-trans': 'Trans. Reembolso Comer Aquí',
    'th-row-take-out-trans': 'Trans. Para Llevar',
    'th-row-take-out-refund-trans': 'Trans. Reembolso Para Llevar',
    'th-row-drive-thru-trans': 'Trans. Autoservicio',
    'th-row-drive-thru-refund-trans': 'Trans. Reembolso Autoservicio',
    'th-row-delivery-trans': 'Trans. Entrega',
    'th-row-delivery-refund-trans': 'Trans. Reembolso Entrega',
    'th-row-kiosk-trans': 'Trans. Kiosco',
    'th-row-kiosk-refund-trans': 'Trans. Reembolso Kiosco',
    'th-row-mobile-take-out-trans': 'Trans. Móvil Para Llevar',
    'th-row-mobile-take-out-refund-trans': 'Trans. Reembolso Móvil Para Llevar',
    'th-row-mobile-drive-thru-trans': 'Trans. Móvil Autoservicio',
    'th-row-mobile-drive-thru-refund-trans':
      'Trans. Reembolso Móvil Autoservicio',
    'th-row-refund-sales': 'Ventas de Reembolso',
    'th-row-avg-check': 'Cheque Promedio',
    'th-row-eat-in-net-sales': 'Ventas Netas Comer Aquí',
    'th-row-eat-in-refund-sales': 'Ventas Reembolso Comer Aquí',
    'th-row-eat-in-avg-check': 'Cheque Prom. Comer Aquí',
    'th-row-take-out-net-sales': 'Ventas Netas Para Llevar',
    'th-row-take-out-refund-sales': 'Ventas Reembolso Para Llevar',
    'th-row-take-out-avg-check': 'Cheque Prom. Para Llevar',
    'th-row-drive-thru-net-sales': 'Ventas Netas Autoservicio',
    'th-row-drive-thru-refund-sales': 'Ventas Reembolso Autoservicio',
    'th-row-drive-thru-avg-check': 'Cheque Prom. Autoservicio',
    'th-row-delivery-net-sales': 'Ventas Netas Entrega',
    'th-row-delivery-refund-sales': 'Ventas Reembolso Entrega',
    'th-row-delivery-avg-check': 'Cheque Prom. Entrega',
    'th-row-kiosk-net-sales': 'Ventas Netas Kiosco',
    'th-row-kiosk-refund-sales': 'Ventas Reembolso Kiosco',
    'th-row-kiosk-avg-check': 'Cheque Prom. Kiosco',
    'th-row-mobile-take-out-net-sales': 'Ventas Netas Móvil Para Llevar',
    'th-row-mobile-take-out-refund-sales': 'Ventas Reembolso Móvil Para Llevar',
    'th-row-mobile-take-out-avg-check': 'Cheque Prom. Móvil Para Llevar',
    'th-row-mobile-delivery-net-sales': 'Ventas Netas Entrega Móvil',
    'th-row-mobile-delivery-refund-sales': 'Ventas Reembolso Entrega Móvil',
    'th-row-mobile-delivery-avg-check': 'Cheque Prom. Entrega Móvil',
    // TH Service rows
    'th-row-greet-time': 'Tiempo de Saludo',
    'th-row-order-time': 'Tiempo de Pedido',
    'th-row-queue-time': 'Tiempo de Espera',
    'th-row-window-time': 'Tiempo de Ventanilla',
    'th-row-total-time': 'Tiempo Total',
    // TH SalesWidget (Snapshot) rows
    'th-row-manager-void-amt': 'Monto Anulación Gerente',
    'th-row-cash-over-short': 'Sobrante/Faltante de Caja',
    'th-row-canceled-item-amt': 'Monto Artículo Cancelado',
    'th-row-canceled-item-cnt': 'Cantidad Artículos Cancelados',
    'th-row-canceled-order-amt': 'Monto Orden Cancelada',
    'th-row-canceled-order-cnt': 'Cantidad Órdenes Canceladas',
    'th-row-manager-void-cnt': 'Cantidad Anulaciones Gerente',
    'th-row-overring-amt': 'Monto Sobreregistro',
    // TH Labor rows
    'th-row-hourly-labor-pct': 'Labor por Hora %',
    'th-row-hourly-labor-hours': 'Horas Labor por Hora',
    'th-row-management-labor-pct': 'Labor Gerencial %',
    'th-row-hourly-labor-dollar': 'Labor por Hora $',
    'th-row-salaried-labor-hours': 'Horas Labor Asalariado',
    'th-row-total-labor-pct': 'Labor Total %',
    'th-row-proj-labor-guide': 'Guía Labor Proyectada',
    'th-row-total-labor-hours': 'Horas Labor Total',
    'th-row-training-hours': 'Horas de Capacitación',
    'th-row-labor-cost': 'Costo de Labor',
    'th-row-trans-per-labor-hour': 'Trans / Hora Labor',
    'th-row-act-labor-guide-hours': 'Horas Guía Labor Real',
    'th-row-adj-proj-hours': 'Horas Proy. Ajust. +/-',
    'th-row-avg-hourly-rate': 'Tarifa Promedio por Hora',
    // TH Shared headers
    'plus-minus': '+/-',
    // TH Main section titles
    controls: 'Controles',
    'shared-links': 'Enlaces Compartidos',
    'file-manager': 'Administrador de Archivos',
    'assumed-role': 'Rol asumido',
    forms: 'Formularios',
    // MT dashboard Forms section (components/multiClient/dashboard/forms)
    // MT dashboard Equipment section (components/multiClient/dashboard/equipment)
    'equip-tickets': 'Tickets',
    'equip-reported': 'Reportados',
    'equip-accepted': 'Aceptados',
    'equip-in-progress': 'En curso',
    'equip-assigned': 'Asignados',
    'equip-on-hold': 'En espera',
    'equip-unassigned': 'Sin asignar',
    'equip-scheduled': 'Programados',
    'equip-past-due': 'Vencidos',
    'equip-resolution': 'Resolución',
    'equip-completion': 'Finalización',
    'equip-next-due': 'Próxima tarea vence {date}',
    'equip-no-tasks-due': 'No hay tareas pendientes',
    'equip-time-left-hint': 'Quedan {time}',
    'equip-error-loading': 'Error al cargar los datos de equipos',
    'equip-new-ticket': 'Nuevo ticket',
    'equip-refresh': 'Actualizar',
    'equip-all-tickets': 'Todos los tickets',
    'equip-my-tickets-link': 'Mis tickets',
    'equip-maintenance-link': 'Mantenimiento',
    'equip-my-tasks-link': 'Mis tareas',
    'equip-selected-locations': 'Ubicaciones seleccionadas',
    'equip-you': 'Tú',
    'equip-my-tickets-maintenance': 'Mis Tickets y Mantenimiento',
    'equip-all-tickets-maintenance': 'Todos los Tickets y Mantenimiento',
    'equip-everyone': 'Todos',
    'equip-maintenance': 'Mantenimiento',
    'equip-open-count': '{n} abiertos',
    'equip-task-count': '{n} tareas',
    'equip-reported-lc': 'reportados',
    'equip-in-progress-lc': 'en curso',
    'equip-unassigned-lc': 'sin asignar',
    'equip-past-due-lc': 'vencidas',
    // Resource Library (File Manager shortcuts) on the MT home dashboard
    'fm-resources': 'Recursos',
    'fm-folders': 'Carpetas',
    'fm-files': 'Archivos',
    'fm-open-resource-library': 'Abrir la biblioteca de recursos',
    'fm-refresh': 'Actualizar',
    'fm-download': 'Descargar',
    'fm-remove-shortcut': 'Quitar acceso directo',
    'fm-scroll-left': 'Desplazar a la izquierda',
    'fm-scroll-right': 'Desplazar a la derecha',
    'fm-n-items': '{n} elementos',
    'fm-added': 'Agregado el {date}',
    'fm-n-shortcuts': '{n} accesos directos',
    'fm-no-folders': 'Sin accesos directos de carpetas',
    'fm-no-files': 'Sin accesos directos de archivos',
    'fm-empty': 'Aún no hay accesos directos de carpetas o archivos. Marque elementos con estrella en el administrador de archivos y aparecerán aquí.',
    'fm-add-shortcuts': 'Agregar accesos directos',
    'fm-error': 'Error al cargar los accesos directos',
    'forms-favorites': 'Favoritos',
    'forms-in-progress': 'En progreso',
    'forms-error-loading': 'Error al cargar formularios',
    retry: 'Reintentar',
    'forms-manage-favorites': 'Administrar favoritos',
    'forms-no-favorites-title': 'Aún no hay favoritos',
    'forms-no-favorites-hint':
      'Toca el engranaje para marcar los formularios que más usas.',
    'forms-nothing-in-progress-title': 'Nada en progreso. ¡Bien hecho!',
    'forms-nothing-in-progress-hint':
      'Los formularios que inicies aparecerán aquí para que puedas retomarlos.',
    'forms-started': 'Iniciado {when}',
    'forms-continue': 'Continuar',
    'forms-percent-complete': '{pct}% completado',
    'forms-open-form': 'Abrir {title}',
    equipment: 'Equipo',
    // Standard main section titles
    'snapshot-month': 'Resumen Mensual',
    // Calendar
    'view-calendar': 'Ver Calendario',
    'calendar-options': 'Opciones de Calendario',
    // TH Budget rows
    'th-row-total-labor-dollars': 'Dólares Labor Total',
    'th-row-food-cost': 'Costo de Alimentos',
    'th-row-food-cost-pct': 'Costo Alimentos %',
    'th-row-annual-salary': 'Salario Anual',
    'th-row-crew-dollars': 'Dólares Equipo',
    'th-row-crew-labor-pct': 'Labor Equipo %',
    'th-row-manager-labor-pct': 'Labor Gerente %',
    // TH Food rows
    'th-row-adj-theo-food-cost-pct': 'Costo Alimento Teórico Ajust. %',
    'th-row-food-var-pct': 'Varianza Alimentos %',
    'th-row-total-waste-pct': 'Desperdicio Total %',
    'th-row-total-cost': 'Costo Total',
    'th-row-paper-cost': 'Costo de Papel',
    'th-row-other-cost': 'Otros Costos',
    'th-row-total-var-cost': 'Costo Varianza Total',
    'th-row-food-var-cost': 'Costo Varianza Alimentos',
    'th-row-paper-var-cost': 'Costo Varianza Papel',
    'th-row-other-var-cost': 'Costo Varianza Otros',
    'th-row-total-waste-cost': 'Costo Desperdicio Total',
    'th-row-total-cost-pct': 'Costo Total %',
    'th-row-paper-cost-pct': 'Costo Papel %',
    'th-row-other-cost-pct': 'Otros Costos %',
    'th-row-total-var-pct': 'Varianza Total %',
    'th-row-paper-var-pct': 'Varianza Papel %',
    'th-row-other-var-pct': 'Varianza Otros %',
    'th-row-theo-food-cost-pct': 'Costo Alimento Teórico %',
    'th-row-gap-variance-pct': 'Varianza de Brecha %',
    // TH DayPart Sales rows
    'th-row-daypart-sales': 'Ventas',
    'th-row-daypart-avg-chk': 'Cheque Prom.',
    'th-row-daypart-tcs': "TC's",
    'th-row-daypart-dt-sales': 'Ventas Autoservicio',
    'th-row-daypart-dt-avg-chk': 'Cheque Prom. Autoservicio',
    'th-row-daypart-dt-tcs': "TC's Autoservicio",
    'th-row-daypart-lobby-sales': 'Ventas Lobby',
    'th-row-daypart-lobby-avg-chk': 'Cheque Prom. Lobby',
    'th-row-daypart-lobby-tcs': "TC's Lobby",
    // CompTypeSelector
    'trading': 'Trading',
    // Security / Insights
    'error-loading-data': 'Error al Cargar Datos',
    'security-events': 'Eventos',
    'security-locations': 'Ubicaciones',
    'security-employees': 'Empleados',
    'security-drill-down': 'Análisis de Seguridad',

    // Security Drill Down date tabs
    'security-date-today': 'Hoy',
    'security-date-yest': 'Ayer',
    'security-date-wtd': 'SDH',
    'security-date-lw': 'SP',
    'security-date-custom-range': 'Rango personalizado',
    'security-date-exceeds-max-range':
      'Excede el rango máximo de {days} días',


    // Insight Settings dialog
    'insight-settings-title': 'Configuración de Perspectivas',
    'insight-settings-insight': 'Perspectiva',
    'insight-settings-insights': 'Perspectivas',
    'insight-settings-for': 'Configuración de {name}',
    'insight-settings-watch-lists': 'Listas de Seguimiento',
    'insight-settings-threshold': 'Umbral',
    'insight-settings-minutes-threshold': 'Umbral de Minutos',
    'insight-settings-waste-threshold': 'Umbral de Desperdicio',
    'insight-settings-days-missed-limit': 'Límite de Días Perdidos',
    'insight-settings-modified-punches': 'Marcadas Modificadas',
    'widget-settings-select-card-color': 'Seleccionar el Color de la Tarjeta',

    'top-events': 'Principales Eventos',
    'top-locations': 'Principales Ubicaciones',
    'top-cashiers': 'Principales Cajeros',
    'top-managers': 'Principales Gerentes',
    'security-drill-down-title': 'Análisis de Seguridad',
    'security-drill-down-event-selection': 'Selección de Eventos',
    'security-drill-down-max-events': 'Seleccione hasta {max} eventos',
    'security-drill-down-customize-events': 'Personalizar Eventos',
    'security-drill-down-search-events': 'Evento',
    'security-drill-down-includes': 'Incluye:',
    'security-drill-down-coupon-letter': 'Cupón {letter}',
    'security-drill-down-events-auto': 'Los {max} principales por $',
    'security-drill-down-events-choose': 'Elegir eventos',
    'security-drill-down-order-value': 'Ordenar por $',
    'security-drill-down-order-custom': 'Orden personalizado',
    // the event names Security Events uses
    'security-drill-down-event-cash_refund': 'Reembolso en Efectivo',
    'security-drill-down-event-cashless_refund': 'Reembolso del Tarjeta Credito',
    'security-drill-down-event-pos_overring': 'Anulación POS',
    'security-drill-down-event-t_red_before': 'T-Red Antes',
    'security-drill-down-event-t_red_after': 'T-Red Después',
    'security-drill-down-event-total_order_promo': 'Promo Pedido Total',
    'security-drill-down-event-other_promo': 'Otro Promo',
    'security-drill-down-event-mobile_promo': 'Promos Móviles',
    'security-drill-down-event-delivery_promo': 'Promo Entrega',
    'security-drill-down-event-all_promo': 'Todas Promos',
    'security-drill-down-event-pos_auto_discount': 'Descuento Auto POS',
    'security-drill-down-event-mobile_discount': 'Descuentos Móviles',
    'security-drill-down-event-other_discount': 'Otra Descuento',
    'security-drill-down-event-all_discount': 'Todas Descuentos',
    'security-drill-down-event-coupon': 'Cupones',
    'security-drill-down-event-employee_meal': 'Comida de Empleados',
    'security-drill-down-event-manager_meal': 'Comida de Gerentes',
    'security-drill-down-event-duplicate_card_swipe': 'Deslizamiento Duplicado de Tarjeta',
    'security-drill-down-event-high_lock_out': 'Exclusión por Monto/Cantidad',
    'security-drill-down-event-high_lock_out_tender': 'Exclusión por Monto/Cantidad de Pago',
    'security-drill-down-event-billable_sales': 'Ventas Facturables',
    'security-drill-down-event-electronic_benefit_transfer': 'Transferencia Electrónica de Beneficios (EBT)',
    'cashiers': 'Cajeros',
    'managers': 'Gerentes',
    // SecurityTable
    'transactions': 'TRANSACCIONES',
    'activity-label': 'Actividad',
    'date-header': 'Fecha',
    'time-header': 'Hora',
    'daypart-header': 'Parte del Día',
    'register-header': 'Caja',
    'crew-header': 'Empleado',
    'manager-header': 'Gerente',
    'mgr-code-header': 'Tipo de Autorización de Gerente',
    'details-header': 'Ver Detalle',
    'camera-header': 'Cámara',
    'event-time-header': 'Hora del Evento',
    'amount-header': 'Cantidad',
    'remaining-amount-header': 'Cantidad Restante',
    'not-applicable-value': 'N/A',
    'unavailable-value': 'No disponible',
    'tender-type-header': 'Tipo de Pago',
    'loyalty-id-header': 'ID de Lealtad',
    'event-type-header': 'Tipo',
    'activity-type-header': 'Tipo de Actividad',
    'promo-type-header': 'Tipo de Promoción',
    'discount-type-header': 'Tipo de Descuento',
    'billable-org-header': 'Organización Facturable',
    'lockout-type-header': 'Tipo de Bloqueo',
    'item-count-header': 'Recuento de Artículos',
    'coupon-type-header': 'Tipo de Cupón',
    'overring-amount-header': 'Cantidad de Sobreprecio',
    'reduction-amount-header': 'Cantidad de Reducción',
    'discount-amount-header': 'Cantidad de Descuento',
    'promo-amount-header': 'Cantidad de Promoción',
    'refund-amount-header': 'Cantidad de Reembolso',
    'data-failed-to-load': 'Los datos no se cargaron. Por favor, inténtelo de nuevo.',
    'tender-cash': 'Efectivo',
    'tender-cashless': 'Del Tarjeta Crédito',
    'tender-us$_cashless': 'US$ Del Tarjeta Crédito',
    'tender-gift_card': 'Tarjeta de Regalo',
    'tender-no_tender': 'Sin Pago',
    'tender-billable_sales': 'Ventas Facturables',
    'tender-other': 'Otro',
    'mgr_auth_code': 'código de gerente',
    'mgr_auth_biometrics': 'biométrico',
    // Security event token labels
    'cash_refund': 'Reembolso en Efectivo',
    'cashless_refund': 'Reembolso del Tarjeta Credito',
    'pos_overring': 'Anulación POS',
    'other_promo': 'Otro Promo',
    'total_order_promo': 'Promo Total',
    'total_promo': 'Promo Total',
    'billable_sales': 'Ventas Facturables',
    'drawer_open': 'Cajón Abierto',
    'general_drawer_open': 'Cajón Abierto General',
    't_red_before': 'Reducción de Transacción Antes',
    't_red_after': 'Reducción de Transacción Después',
    'mobile_discount': 'Descuento Móvil',
    'mobile_promo': 'Promo Móvil',
    'pos_auto_discount': 'Descuento Automático POS',
    'other_discount': 'Otro Descuento',
    'loyalty_reward_ids': 'Recompensa de Lealtad',
    'employee_meal': 'Comida de Empleado',
    'manager_meal': 'Comida de Gerente',
    'duplicate_card_swipe': 'Tarjeta Duplicada',
    'coupon': 'Cupón',
    'all_discount': 'Todos los Descuentos',
    'all_promo': 'Todos los Promos',
    'high_lock_out': 'Bloqueo Alto',
    'high_lock_out_tender': 'Bloqueo Alto por Pago',
    'high_lock_out_amount': 'Bloqueo Alto por Monto',
    'high_lock_out_item': 'Bloqueo Alto por Artículo',
    'electronic_benefit_transfer': 'Transferencia Electrónica de Beneficios (EBT)',
    'delivery_promo': 'Promo de Entrega',
    'all_events': 'Actividades Mixtas',
    'event-type-earn': 'Ganar',
    'event-type-burn': 'Canjear',
    // SecurityTableSlideUp
    'highlight-info': 'Las filas resaltadas indican que el cajero fue cambiado en C&I después de que la caja fue cambiada en el POS durante el conteo de la caja.',
    // MoreInfo
    'more-info': 'Más información',
    'view-insight': 'Ver Perspectiva',
    'drawer-open-verbiage': '{cashierName} tuvo {eventQuantity} {eventName} el {date} en {location}',
    'general-drawer-open-verbiage': '{managerName} tuvo {eventQuantity} {eventName} el {date} en {location}',
    'drawer-open-verbiage-burst': '{cashierName} tuvo un burst de {eventQuantity} {eventName} el {date} en {location}',
    'other-verbiage': '{cashierName} tuvo {eventQuantity} {eventName} que suman {eventAmount} el {date} en {location}',
    'other-verbiage-burst': '{cashierName} tuvo un burst de {eventQuantity} {eventName} que suman {eventAmount} el {date} en {location}',
    'loyalty-reward-ids-verbiage': 'Un Id de Recompensa de Lealtad se usó {eventQuantity} veces por un total de {eventAmount} el {date} en {location}',
    'extended-over-eight-hours-drawer-open-verbiage-for-cashier': 'El cajero {cashierName} promedió {eventQuantity} {eventName}/8 horas POS durante los últimos {numOfDays} días en {location}',
    'extended-over-eight-hours-drawer-open-verbiage-for-cashier-general': 'El cajero {cashierName} promedió {eventQuantity} {eventName}/8 horas POS del {dateRange} en {location}',
    'extended-over-eight-hours-other-verbiage-for-cashier': 'El cajero {cashierName} promedió {eventAmount} de {eventName}/8 horas POS durante los últimos {numOfDays} días en {location}',
    'extended-over-eight-hours-other-verbiage-for-cashier-general': 'El cajero {cashierName} promedió {eventAmount} de {eventName}/8 horas POS del {dateRange} en {location}',
    'extended-less-than-eight-hours-drawer-open-verbiage-for-cashier': 'El cajero {cashierName} tuvo {eventQuantity} {eventName} en {lessEightHours} horas POS durante los últimos {numOfDays} días en {location} (menos de 8 hrs)',
    'extended-less-than-eight-hours-drawer-open-verbiage-for-cashier-general': 'El cajero {cashierName} tuvo {eventQuantity} {eventName} en {lessEightHours} horas POS del {dateRange} en {location} (menos de 8 hrs)',
    'extended-less-than-eight-hours-other-verbiage-for-cashier': 'El cajero {cashierName} tuvo {eventAmount} de {eventName} en {lessEightHours} horas POS durante los últimos {numOfDays} días en {location}',
    'extended-less-than-eight-hours-other-verbiage-for-cashier-general': 'El cajero {cashierName} tuvo {eventAmount} de {eventName} en {lessEightHours} horas POS del {dateRange} en {location}',
    'extended-drawer-open-verbiage-for-manager': 'El gerente {managerName} aprobó un total de {eventQuantity} {eventName} durante los últimos {numOfDays} días en {location}',
    'extended-drawer-open-verbiage-for-manager-general': 'El gerente {managerName} aprobó un total de {eventQuantity} {eventName} del {dateRange} en {location}',
    'extended-other-verbiage-for-manager': 'El gerente {managerName} aprobó un total de {eventAmount} de {eventName} durante los últimos {numOfDays} días en {location}',
    'extended-other-verbiage-for-manager-general': 'El gerente {managerName} aprobó un total de {eventAmount} de {eventName} del {dateRange} en {location}',
    'data-failed-to-load-support': 'Los datos no se cargaron. Por favor, inténtelo de nuevo o contacte a soporte si el problema persiste.',
    // InsightsContainer
    'all-quiet-here': 'Todo tranquilo aquí',
    'product-outage': 'Interrupción del Producto',
    'business-day-close': 'Cierre del Día Hábil',
    'open-late-close-early': 'Abrir Tarde/Cerrar Temprano',
    'minor-exceptions': 'Excepciones Menores',
    'product-default': 'Predeterminado',
    'product-product-and-inventory': 'Producto/Inventario',
    'product-people': 'Personas',
    'product-shift': 'Turno',
    'product-security': 'Seguridad',
    'employee-request': 'Solicitudes de Empleados',
    'suspicious-activity': 'Actividad Sospechosa',
    'rbd': 'RBD',
    'rbd-completed': 'RBD Completado',
    'rbd-activation': 'Activación RBD',
    'rbd-completed-threshold': 'Umbral RBD Completado',
    'threshold-hint': 'Alerta cuando las tiendas exceden este número de RBD completados en 30 días (1-10)',
    'potential-ot': 'OT Potencial',
    'simplethink': 'Premium',
    '30-day-terms': 'Términos de 30 Días',
    '90-day-terms': 'Términos de 90 Días',
    'people-terms': 'Bajas de Personal',
    'last-thirty-days': 'Últimos 30 Días',
    'trailing-365-days': '365 Días Anteriores',
    'trailing-thirty-days': '30 Días Anteriores',
    'yesterday': 'Ayer',
    'this-week': 'Esta semana',
    'last-week': 'Semana pasada',
    'this-month': 'Este mes',
    'last-seven-days': 'Últimos 7 Días',
    'modified-punches': 'Marcadas Modificadas',
    'store-alerts': 'Alertas de Restaurante',
    'store-notifications': 'Notificaciones de Restaurante',
    'product-candi': 'C&I',
    'waste-entry': 'Entrada de Desperdicio',
    'stat-inventory': 'Estadística de Inventario',
    // OLCEInsight
    'open-late-message': `<strong>{count}</strong> tienda puede tener <strong>{daysThreshold}</strong> o más aperturas tardías en los últimos 7 días. | <strong>{count}</strong> tiendas pueden tener <strong>{daysThreshold}</strong> o más aperturas tardías en los últimos 7 días.`,
    'close-early-message': `<strong>{count}</strong> tienda puede tener <strong>{daysThreshold}</strong> o más cierres anticipados en los últimos 7 días. | <strong>{count}</strong> tiendas pueden tener <strong>{daysThreshold}</strong> o más cierres anticipados en los últimos 7 días.`,
    // Shift Runner Scorecard
    'sms-shift-runner-scorecard': 'Tarjeta de Puntuación del Corredor de Turno',
    'sms-shift-scorecard': 'Tarjeta de Puntuación del Turno',
    'sms-no-data': 'Sin Datos',
    'sms-overall': 'En General',
    'sms-shift-prep': 'Preparación del Turno',
    'sms-shift-operational-metrics': 'Métricas operativas del turno - vs Objetivo',
    'sms-shift-runner': 'Corredor de Turno',
    'sms-shifts': 'Turnos',
    'sms-score': 'Puntuación',
    'sms-pre-shift-checklist': 'Lista de Verificación Previa al Turno',
    'sms-travel-path': 'Ruta de Viaje',
    'sms-oepe-w-o': 'OEPE Sin Estacionamiento',
    'sms-r2p': 'R2P',
    'sms-kvs-time-per-gc': 'Tiempo KVS por GC',
    'sms-kvs-healthy-usage': 'Uso Saludable KVS',
    'food-safety-completed': 'Completados',
    'food-safety-passed-failed': '{passed} aprobados · {failed} reprobados',
    'food-safety-equipment-issues': 'Problemas de Equipo',
    'food-safety-completed-forms': 'Formularios Completados',
    'food-safety-no-equipment-issues': 'Sin problemas de equipo',
    'food-safety-unknown-equipment': 'Equipo desconocido',
    'food-safety-no-location': 'Sin ubicación',
    'food-safety-exceptions': 'Excepciones',
    'food-safety-view-report': 'Ver Reporte',
    'food-safety-load-error': 'Error al cargar los datos de seguridad alimentaria',
    'food-safety-no-forms': 'No hay formularios de seguridad alimentaria configurados para esta organización',
    'food-safety-thresholds': 'Umbrales de Seguridad Alimentaria',
    'food-safety-thresholds-description':
      'Defina la tasa de aprobación necesaria para cada color. Se aplica a todos en su organización.',
    'food-safety-green-at': 'Verde desde',
    'food-safety-yellow-at': 'Amarillo desde',
    'food-safety-legend-green': 'Verde: {value}% o más',
    'food-safety-legend-yellow': 'Amarillo: {low}% a menos de {high}%',
    'food-safety-legend-red': 'Rojo: menos de {value}%',
    'food-safety-percent-rule': 'Ingrese un valor de 0 a 100',
    'food-safety-yellow-rule': 'Debe ser igual o menor al umbral verde',
    'food-safety-thresholds-save-error': 'No se pudieron guardar los umbrales. Inténtelo de nuevo.',
    'food-safety-insight-completed':
      '<strong>{count}</strong> formulario de seguridad alimentaria completado {period} | <strong>{count}</strong> formularios de seguridad alimentaria completados {period}',
    'food-safety-insight-pass-rate': '{rate} aprobados',
    'food-safety-insight-equipment':
      '<strong>{count}</strong> problema de equipo: | <strong>{count}</strong> problemas de equipo:',
    'food-safety-and-more': '+{count} más',
    'food-safety-equipment': 'Equipo',
    'food-safety-date-time': 'Fecha/Hora',
    'food-safety-store': 'Ubicación',
    'food-safety-form': 'Formulario',
    'food-safety-completed-at': 'Completado',
    'food-safety-completed-by': 'Completado Por',
    'food-safety-status': 'Estado',
    'food-safety-status-passed': 'Aprobado',
    'food-safety-status-failed': 'Reprobado',
    'food-safety-type': 'Tipo',
    'food-safety-type-safety': 'Seguridad',
    'food-safety-type-quality': 'Calidad',
    'food-safety-type-calibration': 'Calibración',
    'food-safety-temperature': 'Temp',
    'food-safety-target': 'Objetivo',
    'food-safety-product': 'Producto',
    'food-safety-corrective-action': 'Acción Correctiva',
  },
  fr: {
    // Migrated from <i18n> SFC blocks (#6500)
    'print': 'Imprimer',
    'calendar-view': 'Calendrier',
    'list-view': 'Liste',
    'calendar-list-all-day': 'Toute la journée',
    'no-events': 'Aucun événement sur cette période',
    'show-more': 'Afficher plus',
    'show-less': 'Afficher moins',
    'close-filters': 'Fermer les filtres',
    'open-filters': 'Ouvrir les filtres',
    'add-subscriptions': 'Ajouter des abonnements',
    'show': 'Afficher',
    'more': 'Davantage',
    'subscribe-premium-banner-header': 'Le partage de calendriers est une fonctionnalité premium',
    'subscribe-premium-banner-description': 'Pour partager des calendriers, vous devez être un utilisateur premium.',
    'all-day-label': 'Événements sur toute la journée',
    'events-title': 'Événements',
    'calendar-desktop-view-locations': 'Sites',
    'calendar-desktop-view-create': 'Créer un événement',
    'calendar-desktop-view-share-calendars': 'Partager des calendriers',
    'calendar-desktop-view-create-event-premium-banner-header': 'La création d’événements est une fonction premium',
    'calendar-desktop-view-create-event-premium-banner-description': 'Pour créer des événements, vous devez être un utilisateur premium.',
    'calendar-desktop-view-manage-calendars-premium-banner-description': 'Pour ajouter ou gérer des calendriers, vous devez être un utilisateur premium.',
    'calendar-desktop-view-manage-calendars': 'Gérer les calendriers',
    'calendar-desktop-view-manage-calendars-premium-banner-header': 'La gestion des calendriers est une fonctionnalité premium',
    'three-day': '3 jours',
    'calendar-mobile-view-locations': 'Sites',
    'calendar-mobile-view-create': 'Créer un événement',
    'calendar-mobile-view-share-calendars': 'Partager des calendriers',
    'calendar-mobile-view-no-events': 'Aucun événement',
    'calendar-mobile-view-create-event-premium-banner-header': 'La création d’événements est une fonction premium',
    'calendar-mobile-view-create-event-premium-banner-description': 'Pour créer des événements, vous devez être un utilisateur premium.',
    'calendar-mobile-view-manage-calendars-premium-banner-description': 'Pour ajouter ou gérer des calendriers, vous devez être un utilisateur premium.',
    'calendar-mobile-view-manage-calendars': 'Gérer les calendriers',
    'calendar-mobile-view-manage-calendars-premium-banner-header': 'La gestion des calendriers est une fonctionnalité premium',
    // Migrated from <i18n> SFC blocks (#6500)
    'custom-range': 'Plage de dates personnalisée',
    'apply': 'Appliquer',
    'quick-date-filter-last-week': 'Semaine dernière',
    'quick-date-filter-this-week': 'Cette semaine',
    'quick-date-filter-week-to-date': 'Semaine à ce jour',
    'quick-date-filter-this-month': 'Ce mois-ci',
    'quick-date-filter-month-to-date': 'Mois à ce jour',
    'quick-date-filter-year-to-date': 'Année à ce jour',
    'quick-date-filter-last-month': 'Mois dernier',
    'quick-date-filter-last-year': 'Année dernière',
    'quick-date-filter-start-date': 'Date de début',
    'quick-date-filter-end-date': 'Date de fin',
    'quick-date-filter-select-date': 'Sélectionner une date',
    // Migrated from <i18n> SFC blocks (#6500)
    'are-you-sure-you-want-to-delete': 'Voulez-vous vraiment supprimer ce calendrier ? Tous les événements associés à ce calendrier seront supprimés.',
    'basic_settings': 'Paramètres de base',
    'subscriptions': 'Abonnements',
    'add_subscription': 'Ajouter un abonnement',
    'subscription_url': 'URL de l’abonnement',
    'subscription_name': 'Nom de l’abonnement',
    'subscription_name_hint': 'Nom qui apparaîtra dans votre calendrier',
    'existing_subscriptions': 'Abonnements existants',
    'no_subscriptions_yet': 'Aucun abonnement ajouté pour le moment',
    'url_required': 'L’URL est obligatoire',
    'invalid_url': 'Veuillez saisir une URL valide',
    'ok': 'OK',
    'error_loading_subscriptions': 'Échec du chargement des abonnements au calendrier',
    'error_adding_subscription': 'Échec de l’ajout de l’abonnement au calendrier',
    'error_removing_subscription': 'Échec de la suppression de l’abonnement au calendrier',
    'error_syncing_subscription': 'Échec de la synchronisation de l’abonnement au calendrier',
    'sync_subscription': 'Synchroniser l’abonnement',
    'remove_subscription': 'Supprimer l’abonnement',
    'subscription': 'Abonnement',
    'are_you_sure_you_want_to_delete_subscription': 'Voulez-vous vraiment supprimer cet abonnement ? Il sera retiré de votre calendrier.',
    'edit_subscription_name': 'Modifier le nom de l’abonnement',
    'name_required': 'Le nom est obligatoire',
    'error_updating_subscription_name': 'Échec de la mise à jour du nom de l’abonnement',
    'subscription_already_exists': 'L’abonnement existe déjà',
    'subscription_already_added': 'L’abonnement a déjà été ajouté',
    'not_authorized': 'Non autorisé',
    'network_offline': 'Réseau hors ligne',
    'manage_subscriptions': 'Gérer les abonnements',
    'role-required': 'Au moins un rôle est requis',
    'location-required': 'Au moins un site est requis',
    'unknown_error': 'Erreur inconnue',
    'shift_manager': 'Responsable de poste',
    'general_manager': 'Directeur général',
    'mid_manager': 'Manager intermédiaire',
    'owner_operator': 'Propriétaire-exploitant',
    'color_primary_blue': 'Bleu primaire',
    'color_lavender': 'Lavande',
    'color_grape': 'Raisin',
    'color_blush': 'Rose poudré',
    'color_magenta': 'Magenta',
    'color_violet': 'Violet',
    'color_indigo': 'Indigo',
    'color_sky_blue': 'Bleu ciel',
    'color_navy': 'Bleu marine',
    'color_mint': 'Menthe',
    'color_teal': 'Bleu canard',
    'color_ice_blue': 'Bleu glacier',
    'color_ocean': 'Océan',
    'color_latte': 'Café au lait',
    'color_chocolate': 'Chocolat',
    'color_sage': 'Sauge',
    'color_olive': 'Olive',
    'color_butter': 'Beurre',
    'color_amber': 'Ambre',
    'color_peach': 'Pêche',
    'color_coral': 'Corail',
    'create-edit-calendar-locations': 'Sites',
    'create-edit-calendar-edit_subscription': 'Modifier l’abonnement',
    'attachment-of': '{current} sur {total}',
    'preview-not-available': 'Aperçu non disponible pour ce type de fichier',
    'video-not-supported': 'Votre navigateur ne prend pas en charge la lecture vidéo',
    'swipe-to-navigate': 'Balayez pour naviguer',
    'pdf-mobile-hint': 'Appuyez ci-dessous pour afficher le PDF dans votre navigateur',
    'open-pdf': 'Ouvrir le PDF',
    'go-to-attachment': 'Aller à la pièce jointe {number}',
    'attachment-media-viewer-previous': 'Pièce jointe précédente',
    'attachment-media-viewer-next': 'Pièce jointe suivante',
    'insert-link': 'Insérer un lien',
    'link': 'Lien',
    'title': 'Titre',
    'link-address-http-help': 'Saisissez une adresse de site web valide.',
    'summary-all-day': 'Toute la journée',
    'no-occurrence-before-end': 'Aucune occurrence avant le {date}. Modifiez les paramètres de répétition ou la date de fin.',
    'description-max-length': 'La description doit comporter 1 000 caractères ou moins',
    'existing-attachments': 'Pièces jointes actuelles',
    'remove-attachment': 'Retirer la pièce jointe',
    'undo-remove': 'Annuler le retrait',
    'audience': 'Public',
    'content': 'Contenu',
    'news-feed': 'Fil d’actualité',
    'feed-post': 'Afficher dans le fil d’actualité',
    'post-to-feed': 'Publier dans le fil',
    'days-before-event': 'jours avant',
    'lead-days-locked': 'L’événement commence aujourd’hui ou plus tôt, il ne peut donc pas être publié dans le fil à l’avance.',
    'days-before-event-label': 'jours avant l’événement',
    'days-before-event-lower': 'jours avant l’événement',
    'news-feed-settings': 'Paramètres du fil d’actualité',
    'event-name': 'Nom de l’événement',
    'calendar-name': 'Nom du calendrier',
    'event-start': 'Début de l’événement',
    'event-end': 'Fin de l’événement',
    'show-in-news-feed': 'Afficher dans le fil d’actualité',
    'repeat': 'Répéter',
    'subscription-edit-info': 'Certains détails de l’événement ne peuvent être modifiés que depuis l’endroit où il a été créé à l’origine.',
    'pin-to-top': 'Épingler en haut',
    'event-form-name': 'Nom de l’événement',
    'event-form-locations': 'Sites',
    'event-form-save': 'ENREGISTRER',
    'event-form-not-available': 'Non disponible',
    'event-form-start-date': 'Date de début',
    'event-form-start-time': 'Heure de début',
    'event-form-end-date': 'Date de fin',
    'event-form-end-time': 'Heure de fin',
    'event-form-all': 'Tous',
    'event-form-all-locations': 'Tous les emplacements',
    'event-form-mid_manager': 'Manager intermédiaire',
    'event-form-owner_operator': 'Propriétaire-exploitant',
    'stores': 'restaurants',
    'missing-at-least-one-business-day-close': 'auxquels il manque au moins une clôture de journée d’activité',
    'seven-days-insight-text': 'au cours des 7 derniers jours',
    'highlighted-cells-represent': 'Les cellules surlignées représentent',
    'service-sales-labor-negative-variance': 'Service, ventes et main-d’œuvre = écart négatif par rapport aux tendances récentes du même jour de la semaine.',
    'gc-proj-sales-proj': 'NC - Prév., Ventes - Prév. = écart horaire de +/- 10 par rapport aux prévisions',
    'projected-product-sales': 'Ventes produits prévues',
    'my-metrics': 'Mes indicateurs',
    'qtr': 'Trim.',
    'dar-widget-daypart': 'Période de la journée',
    // Migrated from <i18n> SFC blocks (#6500)
    'allow-users-to-create-their-own-dashboard': 'Autoriser les utilisateurs à créer leur propre tableau de bord',
    'no-shift-leader-scheduled': 'Aucun responsable de poste planifié',
    'current-shift-runner-thru': 'à',
    'current-shift-runner-shift-leader': 'Responsable de poste',
    'dashboard-settings': 'Paramètres du tableau de bord',
    'delete-dashboard': 'Supprimer le tableau de bord',
    'you-are-about-to-delete-this-dashboard': 'Vous êtes sur le point de supprimer ce tableau de bord. Cette action est irréversible.',
    'global-settings': 'Paramètres globaux',
    'qsr-admin-only-settings': 'Paramètres réservés aux administrateurs QSR',
    'copy-widgets': 'Copier les widgets',
    'reset-org': 'Réinitialiser l’organisation',
    'this-will-reset-the-entire-organization-dashboard': 'Les paramètres du tableau de bord de toute l’organisation seront réinitialisés. Cette action est irréversible.',
    'yes-nuke-em': 'Oui, tout effacer',
    'reset-this-user': 'Réinitialiser cet utilisateur',
    'this-will-reset-this-users-dashboard-settings-this-action-cannot-be-undone': 'Les paramètres du tableau de bord de cet utilisateur seront réinitialisés. Cette action est irréversible.',
    'dashboard-name': 'Nom du tableau de bord',
    'assigned-roles': 'Rôles attribués',
    'error-loading-events': 'Erreur de chargement des événements',
    'nothing-here': 'Rien ici',
    'yest': 'Hier',
    'tmw': 'Dem.',
    'create-event': 'Créer un événement',
    'share-calendars': 'Liens de calendrier partagés',
    'share-calendars-premium-banner-header': 'Le partage de calendriers est une fonctionnalité premium',
    'share-calendars-premium-banner-description': 'Pour partager des calendriers, vous devez être un utilisateur premium.',
    'create-event-premium-banner-header': 'La création d’événements est une fonctionnalité premium',
    'create-event-premium-banner-description': 'Pour créer ou modifier des événements, vous devez être un utilisateur premium.',
    'all-day': 'Toute la journée',
    'calendars': 'Calendriers inclus',
    'select-all': 'Tout sélectionner',
    'all-calendars': 'Tous les calendriers',
    'others': 'autres',
    'manage-calendars': 'Gérer les calendriers',
    'manage-calendars-premium-banner-header': 'La gestion des calendriers est une fonctionnalité premium',
    'manage-calendars-premium-banner-description': 'Pour gérer les calendriers, vous devez être un utilisateur premium.',
    'calendar-selector-home': 'Site principal',
    'create-calendar': 'Créer un calendrier',
    'manage-calendars-modal-manage-calendars': 'Gérer les calendriers',
    'calendar-is-premium-feature': 'Le calendrier est une fonctionnalité premium',
    'calendar-premium-description': 'Pour accéder au calendrier de l’organisation et créer ou modifier des événements et des calendriers,',
    'ask-system-admin-upgrade': 'Demandez à votre administrateur système de faire passer votre organisation à Premium.',
    'subscribe-to-premium': 'Passez à Premium',
    'date-text-field-ok': 'OK',
    'your-time': 'Votre heure',
    'event': 'Événement',
    'edit-this-and-future-occurrences': 'Modifier cette occurrence et les suivantes',
    'edit-this-occurrence': 'Modifier cette occurrence',
    'calendar-is-required': 'Le calendrier est obligatoire',
    'start': 'Début',
    'end': 'Fin',
    'timezone': 'Fuseau horaire',
    'end-recurring-event-on': 'Fin de la récurrence le',
    'delete-event': 'Supprimer l’événement',
    'are-you-sure-you-want-to-delete-this-event': 'Voulez-vous vraiment supprimer cet événement ? Tous les événements récurrents associés seront également supprimés.',
    'start-date-must-be-before-end-date': 'La date de début doit être antérieure à la date de fin',
    'event-details': 'Détails de l’événement',
    'edit-event': 'Modifier l’événement',
    'edit-event-form-update': 'Enregistrer',
    'attachments': 'Pièces jointes',
    'files-selected': '{count} fichiers sélectionnés',
    'drag-files-here': 'Glissez des fichiers ici ou cliquez pour parcourir',
    'accepted-file-types': 'Images, vidéos ou PDF',
    'drop-zone-label': 'Zone de dépôt des pièces jointes. Cliquez ou appuyez sur Entrée pour parcourir les fichiers.',
    'remove-file': 'Retirer {name}',
    'add-more-files': 'Cliquez ou glissez pour ajouter d’autres fichiers',
    'file-too-large': 'Fichier(s) trop volumineux : {names}. La taille maximale est de {limit} Mo.',
    'loading-attachments': 'Chargement des fichiers...',
    'error-loading': 'Échec du chargement des fichiers',
    'view-attachment': 'Voir {name}',
    'event-attachment-list-attachments': '{count} fichier | {count} fichiers',
    'does-not-repeat': 'Ne se répète pas',
    'none': 'Aucun',
    'no-description': 'Aucune description',
    'all-locations': 'Tous les emplacements',
    'all-roles': 'Tous les rôles',
    'search-locations': 'Rechercher des emplacements',
    'external-org': 'Externe — {org}',
    'internal-calendar': 'Interne — {calendar}',
    'repeats-every': 'Répéter tous les',
    'repeats': 'Répétition',
    'days': 'Jour(s)',
    'weeks': 'Semaine(s)',
    'months': 'Mois',
    'years': 'Année(s)',
    'frequency-settings-does-not-repeat': 'Ne se répète pas',
    'on-day': 'le jour',
    'on-the': 'le',
    'monthly-frequency-first': 'Premier',
    'monthly-frequency-second': 'Deuxième',
    'monthly-frequency-third': 'Troisième',
    'monthly-frequency-fourth': 'Quatrième',
    'monthly-frequency-last': 'Précédent',
    'm': 'LU',
    'tu': 'MA',
    'w': 'ME',
    'th': 'JE',
    'f': 'VE',
    'sa': 'SA',
    'su': 'DI',
    'january': 'Janvier',
    'february': 'Février',
    'march': 'Mars',
    'april': 'Avril',
    'may': 'Mai',
    'june': 'Juin',
    'july': 'Juillet',
    'august': 'Août',
    'september': 'Septembre',
    'october': 'Octobre',
    'november': 'Novembre',
    'december': 'Décembre',
    'yearly-frequency-on': 'de',
    'yearly-frequency-sunday': 'Dimanche',
    'yearly-frequency-first': 'Premier',
    'yearly-frequency-second': 'Deuxième',
    'yearly-frequency-third': 'Troisième',
    'yearly-frequency-fourth': 'Quatrième',
    'yearly-frequency-last': 'Précédent',
    'edit_subscription': 'Modifier le lien de calendrier partagé',
    'subscribe_to_myq_calendar': 'Liens de calendrier partagés',
    'add_to_calendar': 'Ajoutez un calendrier MyQ à l’un des calendriers suivants :',
    'calendar_link_copied': 'Lien du calendrier copié dans le presse-papiers !',
    'icalendar_instructions': 'Vous pouvez utiliser le lien iCalendar pour ajouter un calendrier MyQ à toute application de calendrier compatible avec le format iCalendar. Copiez simplement le lien et collez-le dans votre application de calendrier, ou cliquez sur l’un des boutons ci-dessus pour l’ajouter directement à votre calendrier préféré.',
    'learn_google': 'En savoir plus sur l’ajout de liens iCalendar à Google Agenda',
    'learn_outlook': 'En savoir plus sur l’ajout de liens iCalendar à Outlook',
    'learn_apple': 'En savoir plus sur l’ajout de liens iCalendar à Calendrier Apple',
    'icalendar_panel_title': 'Comment utiliser un lien iCalendar :',
    'confirm_deletion': 'Confirmer la suppression',
    'confirm_deletion_message': 'Voulez-vous vraiment supprimer l’abonnement au calendrier',
    'confirm_deletion_message_strong': ' ? Cette action est irréversible.',
    'delete_2': 'Après la suppression de ce calendrier, la connexion sera perdue et il \nne recevra plus les mises à jour du calendrier QSRSoft. Si vous souhaitez supprimer complètement le calendrier partagé, veuillez \nle faire depuis l’application correspondante (Google, Outlook ou Apple).',
    'calendar_name': 'Nom du calendrier',
    'create_shareable_calendar': 'Créer un lien de calendrier partageable',
    'create_shareable_calendar_2': ' + Ajouter un lien',
    'choose_calendar': 'Choisir un calendrier',
    'this_will_appear_as_the_title_in_your_external_app': 'Ce nom apparaîtra comme titre dans l’application externe',
    'choose_one_or_more_calendars_to_share': 'Choisissez un ou plusieurs calendriers à partager',
    'your_calendar_name': 'Nom de votre calendrier',
    'calendar_name_must_be_at_least_1_character': 'Le nom du calendrier doit comporter au moins 1 caractère',
    'please_select_at_least_one_calendar': 'Veuillez sélectionner au moins un calendrier',
    'shared_calendars_header': 'Liens de calendrier partagés',
    'no_shared_calendars': 'Vous n’avez aucun lien de calendrier partagé.',
    'start_adding_shared_calendars': 'Commencez à en ajouter dans la section « Nouveau lien de calendrier partagé »',
    'or_add_your_calendar': 'Ou ajoutez votre calendrier à l’une des applications de calendrier suivantes :',
    'new_shared_calendar_link': 'Nouveau lien de calendrier partagé',
    'shared_calendar_links': 'Liens de calendrier partagés',
    'continue': 'Continuer',
    'confirm_google_dialog_title': 'Continuer vers Google Agenda',
    'confirm_google_dialog_message': 'Google a récemment modifié le fonctionnement des abonnements aux calendriers. Pour ajouter ce calendrier à Google, vous devrez coller manuellement le lien d’abonnement dans Google Agenda.',
    'confirm_google_dialog_message_strong': 'Nous avons déjà copié le lien pour vous. Cliquez sur le bouton Continuer ci-dessous pour poursuivre. Une fois redirigé, collez le lien dans le champ URL et cliquez sur Ajouter l’agenda.',
    'confirm_google_dialog_message_strong_mobile': 'Nous avons déjà copié le lien pour vous. Cliquez sur le bouton Continuer ci-dessous pour poursuivre. Une fois redirigé, cliquez sur l’icône « + » à côté de Autres agendas dans la barre latérale gauche, sélectionnez À partir de l’URL, collez le lien dans le champ URL, puis cliquez sur Ajouter un agenda',
    'failed_to_get_subscriptions': 'Échec de la récupération des abonnements au calendrier',
    'failed_to_add_subscription': 'Échec de l’ajout de l’abonnement au calendrier',
    'failed_to_edit_subscription': 'Échec de la modification de l’abonnement au calendrier',
    'failed_to_delete_subscription': 'Échec de la suppression de l’abonnement au calendrier',
    'failed_to_copy_link': 'Échec de la copie du lien du calendrier',
    'calendar_name_required': 'Le nom du calendrier est obligatoire',
    'create-ticket': 'Créer un ticket',
    'you-do-not-have-permissions-to-view-this-widget': 'Vous n’avez pas la permission de voir ce widget',
    'my-planned-maintenance': 'Ma maintenance planifiée',
    'error-loading-tasks': 'Erreur de chargement des tâches',
    'tasks-due-by': 'Tâche(s) à échéance le',
    'all-tasks-completed': 'Toutes les tâches sont terminées !',
    'assigned': 'Assignés',
    'time-left': 'Temps restant',
    'my-planned-maintenance-hours': 'h',
    'my-planned-maintenance-past-due': 'En retard',
    'my-planned-maintenance-completed': 'Terminé',
    'my-planned-maintenance-none': 'Aucune',
    'tickets': 'Tickets',
    'error-loading-tickets': 'Erreur de chargement des formulaires',
    'in-progress': 'En cours',
    'on-hold': 'En attente',
    'resolved': 'Résolu',
    'my-tickets-none': 'Aucune',
    'planned-maintenance-overview': 'Vue d’ensemble de la maintenance planifiée',
    'unassigned': 'Non assignées',
    'planned-maintenance-error-loading-tasks': 'Erreur de chargement des tâches',
    'planned-maintenance-assigned': 'Assignés',
    'planned-maintenance-completed': 'Terminé',
    'tickets-overview': 'Vue d’ensemble des tickets',
    'reported': 'Signalés',
    'accepted': 'Acceptés',
    'tickets-overview-error-loading-tickets': 'Erreur de chargement des tickets',
    'favorite-forms': 'Formulaires favoris',
    'error-loading-forms': 'Erreur de chargement des formulaires',
    'forms-favorites-title': 'Formulaires favoris',
    'forms-favorites-your-favorites': 'Vos favoris',
    'forms-favorites-org-favorites': 'Favoris de l’organisation',
    'forms-favorites-available-forms': 'Formulaires disponibles',
    'forms-favorites-current-favorites': 'Favoris actuels',
    'forms-favorites-no-favorites-yet': 'Aucun favori pour le moment',
    'forms-favorites-add-form-hint': 'Sélectionnez un formulaire ci-dessus pour commencer.',
    'forms-favorites-uncategorized': 'Sans catégorie',
    'forms-favorites-unknown-form': 'Formulaire inconnu',
    'forms-favorites-load-error': 'Impossible de charger les favoris pour le moment. Veuillez réessayer.',
    'forms-favorites-save-error': 'Impossible d’enregistrer les modifications. Veuillez réessayer.',
    'shift-forms': 'Formulaires de poste',
    'forms-all': 'Tous',
    'forms-in-progress-2': 'En cours',
    'in-progress-forms': 'Formulaires en cours',
    'workflow-forms': 'Formulaires de flux de travail',
    'too-many-locations-selected': 'Trop de sites sélectionnés. Veuillez sélectionner un seul site.',
    'no-tasks-with-forms': 'Aucune tâche avec formulaires',
    'workflow-forms-error-loading-forms': 'Erreur de chargement des formulaires',
    'task-row-expired': 'Expiré',
    'org-error-message-a': 'Votre organisation n’est actuellement pas abonnée à QSRSoft Premium. Cliquez ',
    'org-error-message-b': ' pour en savoir plus.',
    'select-one_location': 'Veuillez sélectionner un seul site',
    'no-tasks-available': 'Aucune tâche disponible - veuillez contacter votre administrateur système',
    'store-time-zone': 'Fuseau horaire du restaurant',
    'store-hours-gathered': 'Les horaires du restaurant proviennent de vos paramètres RFM',
    'user-error-message': 'Vous n’avez pas l’autorisation d’accéder aux formulaires. Veuillez contacter votre administrateur système.',
    'work-flow-here': 'ICI',
    'work-flow-missing-permissions': 'Autorisations manquantes',
    'Recurrence': 'Récurrence',
    'How often a new instance of a task is due': 'Fréquence à laquelle une nouvelle occurrence de la tâche arrive à échéance',
    'Every': 'Chaque',
    'Date': 'Date',
    'Next 10 Recurrences': '10 prochaines occurrences',
    'Starting at': 'À partir de',
    'Due': 'À échéance',
    'Ending at': 'Se terminant à',
    'Timezone': 'Fuseau horaire',
    'On day': 'Le jour',
    'Day of month': 'Jour du mois',
    'On the': 'Le',
    'Week': 'Semaine',
    'Day': 'Jour',
    'Once': 'Une fois',
    'Minute': 'Minute',
    'Hour': 'Heure',
    'Month': 'Mois',
    'Mon': 'Lun',
    'Tue': 'Mar',
    'Wed': 'Mer',
    'Thu': 'Jeu',
    'Fri': 'Ven',
    'Sat': 'Sam',
    'Sun': 'Dim',
    'First': 'Premier',
    'Second': 'Deuxième',
    'Third': 'Troisième',
    'Fourth': 'Quatrième',
    'Last': 'Précédent',
    'Invalid RRULE': 'RRULE non valide',
    'Does not repeat': 'Ne se répète pas',
    'AM': 'AM',
    'PM': 'PM',
    'oepe-trends': 'Tendances OEPE',
    'kvs-projections': 'Prévisions KVS',
    'gc-projections': 'Prévisions NC',
    'insights-container-open-late-close-early': 'Ouverture tardive / fermeture anticipée',
    'stores-with-alerts': '{count} restaurant(s) avec alertes actives',
    'stores-with-alerts-suffix': 'restaurant(s) avec alertes actives',
    'total-errors': '{count} erreur(s) active(s) au total',
    'total-errors-suffix': 'erreur(s) active(s) au total',
    'bdc-stores-missing-prefix': 'restaurant auquel il manque au moins une | restaurants auxquels il manque au moins une',
    'instore-events-insight-old-missing-bdc': 'restaurant auquel il manque au moins une | restaurants auxquels il manque au moins une',
    'message': 'Message',
    'severity': 'Gravité',
    'timestamp': 'Horodatage',
    'error': 'Erreur',
    'warning': 'Avertissement',
    'instore-events-more-info-info': 'Info',
    'number-of-bdc-missing': 'Nb de BDC manquants',
    'merged-alerts-more-info-business-date': 'Date(s) d’activité',
    'merged-alerts-more-info-info': 'Info',
    'merged-alerts-more-info-more-info': 'Plus d’informations',
    'guest-counts-are': 'Le nombre de clients est',
    'or-more-above': 'ou plus au-dessus des prévisions sur les 2 dernières heures',
    'or-more-below': 'ou plus en dessous des prévisions sur les 2 dernières heures',
    'consider-reviewing': 'Envisagez de revoir les effectifs et l’affectation aux postes',
    'gc-projections-threshold': 'NC - Seuil des prévisions',
    'lower-limit': 'Limite inférieure',
    'upper-limit': 'Limite supérieure',
    'bdc-grid-business-date': 'Date(s) d’activité',
    'upcoming-kvs-projected-items': 'À venir, les articles KVS prévus dépassent',
    'in-next-15-minutes': 'dans les 15 prochaines minutes avec un seul côté ouvert.',
    'kvs-stores-projected-items-are-above': '{count} restaurants ont des articles KVS prévus supérieurs à',
    'kvs-store-projected-items-are-above': 'Les articles KVS prévus de {store} dépassent',
    'consider-2nd-side-opening': 'Envisagez d’ouvrir le 2e côté',
    'breakfast-threshold': 'Seuil du petit-déjeuner',
    'threshold': 'Seuil',
    'kvs-threshold-settings-items': 'Articles',
    'labor-date': 'Date de travail',
    'act-start': 'Début réel',
    'act-end': 'Fin réelle',
    'sch-start': 'Début planifié',
    'sch-end': 'Fin planifiée',
    'act-shift-length': 'Durée réelle du poste',
    'exception': 'Exception',
    'exception-time': 'Heure de l’exception',
    'is-manager-authorized': 'Autorisé par un manager',
    'punches-1': 'Pointages 1',
    'punches-2': 'Pointages 2',
    'punches-3': 'Pointages 3',
    'punches-4': 'Pointages 4',
    'punches-5': 'Pointages 5',
    'punches-6': 'Pointages 6',
    'there-were': 'Il y a eu',
    'exceptions-on-minor-employees': 'exceptions concernant des employés mineurs',
    'minutes': 'Minutes',
    'days-missed-limit': 'La limite de jours manqués peut être ajustée dans les paramètres des analyses.',
    'filter-open-late-msg': '** Affichage des restaurants ayant ouvert en retard plus souvent que la limite de jours manqués ({days} jours) lors des 7 dernières ouvertures.',
    'filter-close-early-msg': '** Affichage des restaurants ayant fermé en avance plus souvent que la limite de jours manqués ({days} jours) lors des 7 dernières fermetures.',
    'olce-grid-open-late-close-early': 'Ouverture tardive / fermeture anticipée',
    'olce-grid-filter': 'Filtre',
    'olce-grid-open-late': 'Ouverture tardive',
    'olce-grid-close-early': 'Fermeture anticipée',
    'may-have': 'avec potentiellement',
    'late-opens': 'ouvertures tardives ou plus au cours des 7 derniers jours.',
    'early-closes': 'fermetures anticipées ou plus au cours des 7 derniers jours.',
    'olce-insight-open-late-close-early': 'Ouverture tardive / fermeture anticipée',
    'olce-insight-store': 'restaurant',
    'days-missed': 'Jours manqués',
    'ot-threshold-setting-hours': 'Heures',
    'employees-on-track': 'employés risquent de travailler plus de',
    'hours-this-week': 'heures cette semaine.',
    'you-currently-have': 'Vous avez actuellement',
    'items-out': 'articles en rupture au cours des',
    'product-outage-insight-days': 'jours.',
    'product-outage-insight-product-outage': 'Rupture de produit',
    'active-product-outages': 'Ruptures de produit actives',
    'thirty-day-terms': 'Départs à 30 jours',
    'ninety-day-terms': 'Départs à 90 jours',
    'crew-type': 'Type d’équipier',
    'hire': 'Embauche',
    'termination': 'Départ',
    'merged-terms-more-info-more-info': 'Plus d’informations',
    'crew-termed-in-the-first': 'départs d’équipiers au cours des',
    'days-since-hire': 'premiers jours suivant l’embauche',
    'no-30-day-terms': 'Aucun départ d’équipier au cours des 30 premiers jours suivant l’embauche.',
    'your-ninety-day-turnover-is-over': 'La rotation dépasse',
    'with': 'avec',
    'crew-terminated-within': 'départs d’équipiers au cours des',
    'you-have': 'Vous avez',
    's': 's',
    'with-90-day-turnover-above': 'dont la rotation à 90 jours dépasse',
    'no-90-day-terms': 'Aucun site au-dessus du seuil de rotation à 90 jours.',
    'people-terms-insight-thirty-day-terms': '30 jours',
    'people-terms-insight-ninety-day-terms': '90 jours',
    'people-terms-insight-location': 'site',
    'seconds': 'Secondes',
    'your-oepe-no-park': 'Votre OEPE hors mise en attente a augmenté de',
    'seconds-from-the-weekly-trend': 'secondes par rapport à la tendance hebdomadaire.',
    'consider-parking-cars': 'Envisagez de mettre des voitures en attente',
    'drawers-with-suspicious-activities': 'cas',
    'please-subscribe': 'Veuillez vous abonner',
    'please-subscribe-verbiage': 'Abonnez-vous à Sécurité pour voir toutes les instances d\'activité suspecte',
    'learn-more': 'En savoir plus',
    'suspicious-activity-insight-suspicious-activity': 'Activité Suspecte',
    'shared-link-settings': 'Paramètres des liens partagés',
    'add-link': 'Ajouter un lien',
    'there-are-currently-no-third-party-links': 'Il n’y a actuellement aucun lien tiers',
    'label-cannot-be-blank': 'L’étiquette ne peut pas être vide',
    'url-cannot-be-blank': 'L’URL ne peut pas être vide',
    'links-settings-label': 'Étiquette',
    'loading': 'Chargement...',
    'no-shared-links-have-been-added': 'Aucun lien partagé n\'a été ajouté pour votre organisation.',
    'daily-activity': 'Activité quotidienne',
    'the-three-week-trend-is-calculated': 'La tendance sur 3 semaines est calculée à partir de la moyenne des 3 dernières semaines pour le même jour de la semaine.',
    'three-week-trend': 'Tendance sur 3 semaines',
    'pivot-table': 'Tableau croisé dynamique',
    'show-all-qtr-hrs': 'Afficher tous les quarts d’heure',
    'dar-settings-row-settings': 'Paramètres des lignes',
    'goal-settings': 'Paramètres des objectifs',
    'percent-to-improve': '% à améliorer',
    'driveThruHME': 'Drive HME',
    'numbers-indicate-employee-hours-this-week': 'Les chiffres indiquent les heures des employés cette semaine - heures travaillées plus heures planifiées restantes. Les lignes surlignées correspondent à des mineurs.',
    'please-select-only-one-location': 'Veuillez sélectionner un seul site',
    'no-data-available': 'Aucune donnée disponible',
    'not-scheduled': 'Non planifié',
    'employee-roster-error-loading': 'Erreur de chargement',
    'expandable-search-search': 'Rechercher...',
    'roster-filter-job-title-code': 'Code de poste',
    'working-today': 'Au travail aujourd’hui',
    'working': 'AU TRAVAIL',
    'scheduled-employees-error-loading': 'Erreur de chargement',
    'scheduled-employees-upcoming': 'À VENIR',
    'select-locations': 'Sélectionnez un ou plusieurs sites',
    'at-least-one-location-required': 'Au moins un site est requis',
    'location-selector-locations': 'Sites',
    'task-list': 'Liste des tâches',
    'failed-to-load-tasks': 'Échec du chargement des tâches',
    'new-task': 'Nouvelle tâche',
    'description-required': 'Description requise',
    'max-140-characters': 'Maximum 140 caractères',
    'complete-task': 'Terminer la tâche ?',
    'this-task-will-be-archived-and-removed': 'Cette tâche sera archivée et retirée de la liste du restaurant. Continuer ?',
    'Today': 'Aujourd’hui',
    'All': 'Tous',
    'task-list-no-tasks-available': 'Aucune tâche disponible',
    'task-list-complete': 'Terminer',
    // Migrated from <i18n> SFC blocks (#6500)
    'trading-day': 'Jour d’exploitation',
    'calendar-day': 'Jour calendaire',
    'create-scorecard': 'Créer un tableau de résultats',
    'max-scorecards': 'Nombre maximal de tableaux de résultats atteint',
    'name-assign': 'Nommer et assigner',
    'select-metrics': 'Sélectionner les indicateurs',
    'set-goals': 'Définir les objectifs',
    'qsr-defaults': 'Valeurs par défaut QSR',
    'defaults': 'Valeurs par défaut',
    'click-cells-to-edit': 'Cliquez sur les cellules pour les modifier comme dans Excel',
    'scorecard-settings': 'Paramètres du tableau de résultats',
    'goals': 'Objectifs',
    'score-card-container-settings-scorecards': 'Tableaux de résultats',
    'score-card-settings-are-you-sure': 'Voulez-vous vraiment supprimer ce tableau de résultats ?',
    'score-card-settings-scorecard-settings': 'Paramètres du tableau de résultats',
    'score-card-settings-settings': 'Paramètres',
    'score-card-settings-delete-scorecard': 'Supprimer le tableau de résultats',
    'products-selected': 'produits sélectionnés',
    'menu-items': 'Articles du menu',
    'watchlists': 'Listes de surveillance',
    'pmix-settings': 'Paramètres PMIX',
    'columns': 'Colonnes',
    'products': 'Produits',
    'today-container-today': 'Aujourd’hui (ancienne version)',
    // Migrated from <i18n> SFC blocks (#6500)
    'preview-mode': 'Mode aperçu',
    'preview-mode-subtitle': 'Vérification des modifications non enregistrées. Enregistrez pour les conserver ou ignorez-les pour revenir en arrière.',
    'exit-preview': 'Quitter l’aperçu',
    dashboard: 'Tableau de bord',
    widget: 'Widget',
    shiftRunner: 'Chef de quart',
    insights: 'Analyses',
    due: 'À échéance',
    expired: 'Expiré',
    upcoming: 'À venir',
    completed: 'Terminé',
    learnMore: 'En savoir plus',
    pleaseSubscribe: 'Veuillez souscrire',
    // CreateDashboard
    'create-dashboard': 'Créer un tableau de bord',
    name: 'Nom',
    roles: 'Rôles',
    'starting-point': 'Point de départ',
    'name-description':
      'Choisissez un nom pour votre tableau de bord. Les utilisateurs verront ce nom dans le sélecteur.',
    'roles-description':
      'Sélectionnez les rôles pour votre tableau de bord. Les utilisateurs auxquels ces rôles sont attribués pourront le voir et le choisir.',
    'starting-point-description':
      'Choisissez un point de départ. Vous pouvez partir d’un tableau de bord QSRSoft, d’un autre tableau de bord que vous avez créé, ou d’une page vierge.',
    cancel: 'Annuler',
    back: 'Retour',
    next: 'Suivant',
    preview: 'Aperçu',
    'name-required': 'Le nom est obligatoire',
    'name-exists': 'Un tableau de bord portant ce nom existe déjà',
    'roles-required': 'Les rôles sont obligatoires',
    'blank-canvas': 'Page vierge',
    'qsr-presets': 'Préréglages QSR',
    'your-saved-dashboards': 'Vos tableaux de bord enregistrés',
    // ResetDashboard
    'reset-dashboard': 'Réinitialiser le tableau de bord',
    'reset-description':
      'Choisissez le point de départ vers lequel réinitialiser le tableau de bord sélectionné. Vous pouvez choisir un tableau de bord QSRSoft ou une page vierge. Après avoir choisi un point de départ, cliquez sur Enregistrer pour appliquer les modifications.',
    // Settings
    'widget-settings': 'Paramètres du widget',
    'row-settings': 'Paramètres des lignes',
    'column-settings': 'Paramètres des colonnes',
    close: 'Fermer',
    save: 'Enregistrer',
    // DashboardContainerSettingsMulti
    customizeDashboardContainers: 'Personnaliser les conteneurs du tableau de bord',
    unableToSaveSettings: 'Impossible d’enregistrer les paramètres du tableau de bord.',
    unableToResetSettings: 'Impossible de réinitialiser les paramètres du tableau de bord.',
    // no_favorites_card
    noShortcuts: 'Vous n’avez aucun raccourci de dossier ou de fichier.',
    add: 'Ajouter',
    // Shared
    moreInfo: 'Plus d’informations',
    noData: 'Aucune donnée',
    loadError: 'Impossible de charger les données',
    actual: 'Réel',
    current: 'En cours',
    // BudgetWidget
    budget: 'Budget',
    fiscalPeriod: 'Période fiscale',
    vsBudget: 'Vs budget',
    // FoodWidget
    food: 'Matières',
    week: 'Semaine',
    // TextSettings
    bulletinBoardSettings: 'Paramètres du tableau d’affichage',
    addText: 'Ajouter du texte',
    isLink: 'est un lien',
    url: 'URL',
    text: 'Texte',
    // BUSalesRankPopUp
    oneYearComp: 'Comparaison 1 an',
    twoYearComp: 'Comparaison 2 ans',
    // VoiceSmiley
    voice: 'VOICE',
    surveys: 'Enquêtes',
    numSurveys: 'Nb d’enquêtes',
    voiceInfoText:
      'Les données sont reçues 2 jours après SMG et regroupées par date de visite du client. SMG se base par défaut sur la date de l’enquête. En raison de ces différences, il ne faut <strong>pas</strong> s’attendre à ce que les deux sources concordent.',
    // SmileySettings
    metric: 'Indicateur',
    all: 'Tous',
    metrics: 'Indicateurs',
    differentThresholds: 'Les indicateurs sélectionnés ont des seuils différents.',
    orSelectFewer: 'ou sélectionnez moins d’indicateurs.',
    groupedMetrics: 'Voici les indicateurs regroupés :',
    group: 'Groupe',
    happyUpper: 'satisfait - borne haute',
    happyLower: 'satisfait - borne basse',
    neutralLower: 'neutre - borne basse',
    // RMHC / Round Up
    roundUp: 'Arrondi solidaire',
    helpingHands: 'Helping Hands',
    mtdDollar: 'CMJ $',
    mtdCount: 'Nombre CMJ',
    progressGoal: 'Avancement / objectif',
    pctToGoal: '% de l’objectif atteint :',
    goalsHit: 'Objectifs atteints :',
    orgSettingsChanging: 'Modification des paramètres de l’organisation',
    orgSettingsConfirm:
      'Vous êtes sur le point de modifier des paramètres au niveau de l’organisation. Confirmez-vous ?',
    no: 'Non',
    donationDollar: 'Don $',
    donationCount: 'Nombre de dons',
    goal: 'Objectif',
    numOfDonations: 'Nb de dons',
    donationsDollar: 'Dons $',
    donationsCountGoal: 'Objectif de nombre de dons',
    donationsDollarGoal: 'Objectif de dons $',
    pctOfGoal: '% de l’objectif',
    // Voice row labels
    voiceOverall: 'Global',
    beNice: 'Amabilité',
    beFast: 'Rapidité',
    quality: 'Qualité',
    clean: 'Propreté',
    accuracy: 'Exactitude',
    // VoiceContainer
    customerFeedbackAndDonations: 'Retours clients et dons',
    // BigArch / Incentives
    bigArch: 'Big Arch',
    'hot-honey': 'Hot Honey',
    'snack-wraps': 'Snack Wraps',
    // Shared incentive keys
    'incentive-rank-out-of': 'Classement sur',
    'incentive-restaurants': 'Restaurants',
    'incentive-rank': 'Classement',
    'incentive-rank-compared': 'Classement du restaurant par rapport à l’ensemble de la BU',
    'incentive-units-1k-gc': 'Unités/1 000 NC',
    'incentive-units-1k-rod-gc': 'Unités/1 000 NC ROD',
    // BigArchWidget
    'big-arch-units': 'Unités Big Arch',
    'big-arch-sold-related':
      'Nombre d’articles du menu liés à Big Arch vendus sur le reste de la journée (ROD) pour mille unités.',
    'big-arch-menu-items':
      'Les articles du menu concernés sont les 25442, 25443 et 25444',
    // HotHoneyWidget
    'hot-honey-units': 'Unités Hot Honey',
    'hot-honey-sold-related':
      'Nombre d’articles du menu liés à Hot Honey vendus sur le reste de la journée (ROD) pour mille unités.',
    // SnackWrapsWidget
    'wrap-units': 'Unités Wrap',
    'snack-wraps-message':
      'Les Snack Wraps sont désormais comptabilisés ici comme des articles individuels',
    'snack-wraps-sold-related':
      'Nombre d’articles du menu liés aux Wraps vendus sur le reste de la journée (ROD) pour mille unités.',
    // IncentiveContainer
    leaderboard: 'Classement',
    'mccrispy-strips': 'McCrispy Strips',
    'round-up-pos': 'Arrondi solidaire caisse/employé',
    '3d-gc-incentive': 'Challenge nombre de clients 3D',
    'default-incentives': 'Challenges par défaut',
    'new-beverage': 'Nouvelles boissons',
    // BUGrid
    org: 'Organisation',
    orgVs: 'Organisation vs',
    // BusinessUnitContainer
    comp: 'Comparaison',
    sales: 'Ventes',
    service: 'Service',
    labor: 'Main-d’œuvre',
    'digital-app': 'Application mobile',
    'addon-subscribed': 'Module complémentaire BU · Abonné',
    'addon-upgrade': 'Module complémentaire BU · Mise à niveau',
    'addon-upgrade-tooltip':
      'Parlez à votre responsable BU de l’ajout de l’Abonnement de l’Unité d’Affaires pour obtenir une visibilité sur les vues de Comparaison BU',
    'bu-no-visibility':
      'Vous n’avez pas accès à la vue Comparaison BU pour une ou plusieurs des raisons suivantes :',
    'bu-app-backgrounded':
      'Sur mobile, l’application est restée trop longtemps en arrière-plan. Si c’est le cas, veuillez quitter et redémarrer l’application.',
    'bu-no-subscription':
      'Votre business unit n’est pas abonnée au produit BU Data & Analytics',
    'bu-opted-out':
      'Vous avez « refusé » le partage des données BU dans l’administration MyQSRSoft.',
    'bu-contact-leadership':
      'Veuillez contacter la direction de votre BU pour toute question sur l’abonnement BU et les vues de rapports associées.',
    // BUCompTypeSelector
    'comp-calendar': 'Calendrier',
    'comp-trading': 'Exercice commercial',
    'comp-same-store': 'Restaurants comparables',
    'comp-all-store': 'Tous les restaurants',
    // BUSales tooltip
    'bu-financial-info':
      'Le mode Financier s’applique au mois en cours ou aux plages de dates dépassant les mois clôturés. Il exclut les sites ouverts depuis moins de 13 mois complets. Par défaut, le mode Financier utilise la comparaison par jour d’exploitation.',
    'bu-analytic-info':
      'Le mode Analytique s’applique aux mois clôturés et aux plages de dates incluant des mois clôturés. Il applique une règle de 5 jours : si un site n’a pas de ventes pendant 5 jours ou plus (sur l’année en cours ou l’année précédente), il est exclu du calcul. Par défaut, le mode Analytique utilise la comparaison par jour calendaire.',
    'bu-financial-info-rank':
      'Le mode Financier s’applique au mois en cours ou aux plages de dates dépassant les mois clôturés. Il exclut les sites ouverts depuis moins de 13 mois complets. Par défaut, comparaison par jour d’exploitation.',
    'bu-analytic-info-rank':
      'Le mode Analytique s’applique aux mois clôturés et aux plages de dates incluant des mois clôturés. Il applique une règle de 5 jours : si un site n’a pas de ventes pendant 5 jours ou plus (sur l’année en cours ou l’année précédente), il est exclu du calcul. Par défaut, comparaison par jour calendaire.',
    // BUSales rows
    'bu-row-sales': 'Ventes',
    'bu-row-gcs': 'NC',
    'bu-row-avg-sales': 'Ventes moyennes',
    'bu-row-avg-check': 'Ticket moyen',
    'bu-row-avg-check-diff': 'Ticket moyen +/-',
    'bu-row-avg-check-diff-pct': 'Ticket moyen +/- %',
    'bu-row-bfast-gcrd': 'NC/R/J petit-déjeuner',
    'bu-row-bfast-gcrd-diff': 'NC/R/J petit-déjeuner +/-',
    'bu-row-bfast-pct-sales': '% des ventes petit-déjeuner',
    'bu-row-mcdelivery-avg-check': 'Ticket moyen McDelivery',
    'bu-row-mcdelivery-gcrd': 'NC/R/J McDelivery',
    'bu-row-mcdelivery-gcrd-diff': 'NC/R/J McDelivery +/-',
    'bu-row-gma-del-avg-check': 'Ticket moyen livraison GMA',
    'bu-row-gma-del-gcrd-diff': 'NC/R/J livraison GMA +/-',
    'bu-row-3po-avg-check': 'Ticket moyen 3PO',
    'bu-row-3po-gcrd-diff': 'NC/R/J 3PO +/-',
    'bu-row-dt-pct-sales': '% des ventes totales au Drive',
    'bu-row-dt-gcrd': 'NC/R/J Drive',
    'bu-row-dt-gcrd-diff': 'NC/R/J Drive +/-',
    // BUPeaksService format info tooltip
    'bu-peaks-timeslice-label': 'Créneau horaire',
    'bu-peaks-show-details': 'Afficher les détails',
    'bu-peaks-comp-short-same': 'Comparables',
    'bu-peaks-comp-short-all': 'Tous',
    'bu-peaks-comp-basis': 'Base de comparaison. Comparables : ne compte que les jours-restaurant présents les deux années. Tous : compte tous les jours-restaurant.',
    'bu-peaks-format-info-diff': "Les valeurs par défaut affichent l'écart relatif par rapport à votre BU",
    'bu-peaks-format-info-detail': 'Activez « Afficher les détails » pour afficher les valeurs brutes BU et Org de chaque indicateur',
    // BUService rows
    'bu-row-oepe-no-park': 'OEPE hors mise en attente',
    'bu-row-oepe-no-park-diff': 'OEPE hors mise en attente +/-',
    'bu-row-oepe': 'OEPE',
    'bu-row-oepe-diff': 'OEPE +/-',
    'bu-row-r2p': 'R2P',
    'bu-row-r2p-diff': 'R2P +/-',
    'bu-row-avg-ctp': 'CTP moyen',
    'bu-row-avg-ctp-diff': 'CTP moyen +/-',
    'bu-row-kvs-items-gc': 'Articles KVS / NC',
    'bu-row-kvs-items-gc-diff': 'Articles KVS / NC +/-',
    'bu-row-kvs-time-gc': 'Temps KVS / NC',
    'bu-row-kvs-time-gc-diff': 'Temps KVS / NC +/-',
    'bu-row-dt-pulled-fwd': '% avancés au Drive',
    'bu-row-dt-pulled-fwd-diff': '% avancés au Drive +/-',
    'bu-row-healthy-use': 'Utilisation saine',
    'bu-row-healthy-use-diff': 'Utilisation saine +/-',
    'bu-row-sales-r-d': 'Ventes/R/J',
    'bu-row-sales-r-d-diff': 'Ventes/R/J +/- %',
    'bu-row-gc-r-d': 'NC/R/J',
    'bu-row-gc-r-d-diff': 'NC/R/J +/- %',
    'bu-row-dt-sales-r-d': 'Ventes/R/J Drive',
    'bu-row-dt-sales-r-d-diff': 'Ventes/R/J Drive +/- %',
    'bu-row-fc-sales-r-d': 'Ventes/R/J comptoir',
    'bu-row-fc-sales-r-d-diff': 'Ventes/R/J comptoir +/- %',
    'bu-row-fc-gc-r-d': 'NC/R/J comptoir',
    'bu-row-fc-gc-r-d-diff': 'NC/R/J comptoir +/- %',
    'bu-row-kiosk-sales-r-d': 'Ventes/R/J borne',
    'bu-row-kiosk-sales-r-d-diff': 'Ventes/R/J borne +/- %',
    'bu-row-kiosk-gc-r-d': 'NC/R/J borne',
    'bu-row-kiosk-gc-r-d-diff': 'NC/R/J borne +/- %',
    'bu-row-moa-sales-r-d': 'Ventes/R/J MOA',
    'bu-row-moa-sales-r-d-diff': 'Ventes/R/J MOA +/- %',
    'bu-row-moa-gc-r-d': 'NC/R/J MOA',
    'bu-row-moa-gc-r-d-diff': 'NC/R/J MOA +/- %',
    'bu-row-delivery-sales-r-d': 'Ventes/R/J livraison',
    'bu-row-delivery-sales-r-d-diff': 'Ventes/R/J livraison +/- %',
    'bu-row-delivery-gc-r-d': 'NC/R/J livraison',
    'bu-row-delivery-gc-r-d-diff': 'NC/R/J livraison +/- %',
    'bu-row-dt-avg-check': 'Ticket moyen Drive',
    'bu-row-dt-avg-check-diff': 'Ticket moyen Drive +/-',
    'bu-row-fc-avg-check': 'Ticket moyen comptoir',
    'bu-row-fc-avg-check-diff': 'Ticket moyen comptoir +/-',
    'bu-row-kiosk-avg-check': 'Ticket moyen borne',
    'bu-row-kiosk-avg-check-diff': 'Ticket moyen borne +/-',
    'bu-row-moa-avg-check': 'Ticket moyen MOA',
    'bu-row-moa-avg-check-diff': 'Ticket moyen MOA +/-',
    'bu-row-delivery-avg-check': 'Ticket moyen livraison',
    'bu-row-delivery-avg-check-diff': 'Ticket moyen livraison +/-',
    'bu-digital-customer-count': 'Nombre de clients digitaux',
    'bu-row-dt-gcrd-diff-pct': 'NC/R/J Drive +/- %',
    'bu-row-avg-check-short': 'Ticket moyen',
    'bu-row-avg-check-short-diff': 'Ticket moyen +/-',
    // BULabor rows
    'bu-row-crew-labor': '% MO équipiers',
    'bu-row-actual-labor': '% MO réelle',
    'bu-row-avg-rate': 'Taux moyen',
    'bu-row-tpph': 'TPPH',
    'bu-row-total-labor': '% MO totale',
    // BUFood rows
    'bu-row-base-food': '% matières de base',
    'bu-row-comp-waste': '% pertes produits finis',
    'bu-row-condiments': '% condiments',
    'bu-row-discount': '% remises',
    'bu-row-emp-meals': '% repas employés',
    'bu-row-fob': '% FOB',
    'bu-row-raw-waste': '% pertes brutes',
    'bu-row-stat-var': '% écart statistique',
    'bu-row-unexplained': '% inexpliqué',
    'bu-row-pnl-food-cost': '% coût matières compte de résultat',
    'bu-row-pnl-paper-cost': '% coût papier compte de résultat',
    // BUDigitalApp rows
    'bu-row-digital-sales': '% ventes digitales',
    'bu-row-digital-gc': '% NC digital',
    'bu-row-digital-avg-check': 'Ticket moyen digital',
    'bu-row-digital-grd': 'G/R/J digital',
    'bu-row-scanned-offer-sales': 'Ventes offres scannées',
    'bu-row-scanned-offer-gcs': 'NC offres scannées',
    'bu-row-scanned-offer-avg-check': 'Ticket moyen offres scannées',
    'bu-row-scanned-offer-grd': 'G/R/J offres scannées',
    'bu-row-gma-delivery-sales': 'Ventes livraison GMA',
    'bu-row-gma-delivery-gcs': 'NC livraison GMA',
    'bu-row-gma-delivery-avg-check': 'Ticket moyen livraison GMA',
    'bu-row-gma-delivery-grd': 'G/R/J livraison GMA',
    'bu-row-loyalty-sales': 'Ventes auto-identification fidélité',
    'bu-row-loyalty-gcs': 'NC auto-identification fidélité',
    'bu-row-loyalty-avg-check': 'Ticket moyen auto-identification fidélité',
    'bu-row-loyalty-grd': 'G/R/J auto-identification fidélité',
    'bu-row-mop-offer-sales': 'Ventes MOP avec offre',
    'bu-row-mop-offer-gcs': 'NC MOP avec offre',
    'bu-row-mop-offer-avg-check': 'Ticket moyen MOP avec offre',
    'bu-row-mop-offer-grd': 'G/R/J MOP avec offre',
    'bu-row-mop-no-offer-sales': 'Ventes MOP sans offre',
    'bu-row-mop-no-offer-gcs': 'NC MOP sans offre',
    'bu-row-mop-no-offer-avg-check': 'Ticket moyen MOP sans offre',
    'bu-row-mop-no-offer-grd': 'G/R/J MOP sans offre',
    'bu-row-mop-curb-gcs': '% NC MOP retrait en voiture',
    'bu-row-mop-fc-gcs': '% NC MOP comptoir',
    'bu-row-mop-table-gcs': '% NC MOP à table',
    'bu-row-mop-dt-gcs': '% NC MOP Drive',
    // BUVoice rows
    'bu-row-overall': '% global',
    'bu-row-friendliness': '% amabilité',
    'bu-row-fast': '% rapidité',
    'bu-row-quality': '% qualité',
    'bu-row-cleanliness': '% propreté',
    'bu-row-accuracy': '% exactitude',
    'bu-row-dt-overall': '% global Drive',
    'bu-row-dt-friendliness': '% amabilité Drive',
    'bu-row-dt-fast': '% rapidité Drive',
    'bu-row-dt-quality': '% qualité Drive',
    'bu-row-dt-cleanliness': '% propreté Drive',
    'bu-row-dt-accuracy': '% exactitude Drive',
    'bu-row-fc-overall': '% global comptoir',
    'bu-row-fc-friendliness': '% amabilité comptoir',
    'bu-row-fc-fast': '% rapidité comptoir',
    'bu-row-fc-quality': '% qualité comptoir',
    'bu-row-fc-cleanliness': '% propreté comptoir',
    'bu-row-fc-accuracy': '% exactitude comptoir',
    // BUTurnover rows
    'bu-row-crew-mth-ann-turnover': 'Rotation mens. ann. équipiers',
    'bu-row-crew-3mo-turnover': 'Rotation équipiers sur 3 mois',
    'bu-row-crew-term': 'Départs équipiers',
    'bu-row-avg-crew-hire': 'Embauches moy. équipiers',
    'bu-row-crew-roster': 'Effectif équipiers',
    'bu-row-crew-ttm-turnover': 'Rotation TTM équipiers',
    'bu-row-crew-ytd-turnover': 'Rotation cumulée annuelle équipiers',
    'bu-row-shift-mth-ann-turnover': 'Rotation mens. ann. responsables de poste',
    'bu-row-shift-3mo-turnover': 'Rotation responsables de poste sur 3 mois',
    'bu-row-shift-term': 'Départs responsables de poste',
    'bu-row-avg-shift-hire': 'Embauches moy. responsables de poste',
    'bu-row-shift-roster': 'Effectif responsables de poste',
    'bu-row-shift-ttm-turnover': 'Rotation TTM responsables de poste',
    'bu-row-shift-ytd-turnover': 'Rotation cumulée annuelle responsables de poste',
    // BUDigitalOrderPts rows
    'bu-row-dop-digital-gc': '% NC digital',
    'bu-row-dop-digital-sales': '% ventes digitales',
    'bu-row-dop-digital-grd': 'G/R/J digital',
    'bu-row-dop-mop-gcs': '% NC MOP',
    'bu-row-dop-mop-sales': '% ventes MOP',
    'bu-row-dop-mop-gcrd': 'NC/R/J MOP',
    'bu-row-dop-gma-del-gc': '% NC livraison GMA',
    'bu-row-dop-gma-del-sales': '% ventes livraison GMA',
    'bu-row-dop-gma-del-grd': 'G/R/J livraison GMA',
    'bu-row-dop-kiosk-gc': '% NC borne',
    'bu-row-dop-kiosk-sales': '% ventes borne',
    'bu-row-dop-kiosk-grd': 'G/R/J borne',
    'bu-row-dop-delivery-gc': '% NC livraison',
    'bu-row-dop-delivery-sales': '% ventes livraison',
    'bu-row-dop-delivery-grd': 'G/R/J livraison',
    // BUDateRange
    'start-date': 'Date de début',
    'end-date': 'Date de fin',
    // BUSalesRankPopUp
    'bu-sales': 'Ventes BU',
    rankings: 'Classements',
    'custom-date-range-bu': 'Plage de dates personnalisée',
    thru: 'Au',
    // BUDigitalApp
    'fo-disclaimer':
      'Les résultats de ventes FO sont affichés après la publication trimestrielle des ventes McDonald’s.',
    // BUVoice
    'voice-rankings': 'Classements Voice',
    'bu-comp-type-disclaimer':
      'Ce widget n’est disponible que pour les types de comparaison Business Unit et Field Office.',
    'voice-data-behind':
      'Les données Voice accusent généralement 2 jours de retard. Veuillez sélectionner une plage de dates antérieure',
    // BUTurnover
    people: 'Ressources humaines',
    'people-metrics-full-months':
      'Les indicateurs RH sont calculés sur des mois complets.',
    'people-multiple-months':
      'Si plusieurs mois sont sélectionnés, le mois complet le plus récent est utilisé.',
    'people-partial-month':
      'Si un mois passé est partiellement sélectionné, le mois complet est utilisé.',
    'people-detailed-breakdown':
      'Pour un détail complet, consultez le rapport BU Rank.',
    'people-requires-full-month': 'Les données RH exigent une plage de dates couvrant un mois complet',
    // BUDigitalOrderPts
    'digital-order-pts': 'Points de commande digitaux',
    // BUAppTrends
    'bu-loyalty-trend': 'Tendance des actifs fidélité BU sur 90 jours',
    'bu-loyalty-tooltip':
      'Nombre de clients uniques ayant enregistré au moins un NC via l’application mobile sur la période de 90 jours. Un client pouvant fréquenter plusieurs restaurants d’une même organisation, ce nombre ne peut pas être additionné entre restaurants.',
    // Consulting
    qsrsoftConsultingServices: 'Services de conseil QSRSoft',
    consultingHelpsCapture:
      'Le conseil QSRSoft aide à capter des opportunités de trésorerie',
    cashflowOpportunity: 'Opportunité de trésorerie',
    total: 'Total',
    laborPotentialCF: 'Trésorerie potentielle MO',
    fobPotentialCF: 'Trésorerie potentielle FOB',
    buGCGapPotentialCF: 'Trésorerie potentielle écart NC BU',
    // File Manager
    resourceLibrary: 'Bibliothèque de ressources',
    // Calendar
    calendar: 'Calendrier',
    all_roles: 'Tous les rôles',
    'cal-role-crew': 'Équipiers',
    'cal-role-shift-manager': 'Responsable de poste',
    'cal-role-department-manager': 'Responsable de département',
    'cal-role-general-manager': 'Directeur de restaurant',
    'cal-role-mid-manager': 'Cadre intermédiaire',
    'cal-role-owner-operator': 'Propriétaire exploitant',
    'cal-role-system-administrators': 'Administrateurs système',
    organization_calendar: 'Calendrier de l’organisation',
    'cal-days': 'Jours',
    'cal-pick-a-day': 'Choisir un jour',
    'cal-new-event': 'Nouvel événement',
    'cal-open-calendar': 'Ouvrir le calendrier',
    'cal-open-day': 'Ouvrir le jour',
    'mc-open-report': 'Ouvrir le rapport',
    'mc-updated-at': 'Mis à jour {time}',
    'mc-refresh': 'Actualiser',
    'mc-goals-hit': '{hit} objectifs sur {total}',
    'mc-goals-short': '{hit} / {total}',
    'mc-actual': 'Réel',
    'mc-goal': 'Objectif',
    'mc-diff': 'Écart',
    'mc-dayparts': 'Plages horaires',
    'mc-peaks': 'Pics',
    'mc-custom-range': 'Plage de dates personnalisée',
    'mc-previous-period': 'Période précédente',
    'mc-next-period': 'Période suivante',
    'mc-rank-stores': 'Classer les restaurants',
    'mc-new-scorecard': 'Nouvelle fiche de résultats',
    'mc-trend': 'Tendance',
    'mc-metric': 'Mesure',
    'mc-item': 'Article',
    'cal-options': 'Options du calendrier',
    'cal-shared-links': 'Liens de calendrier partagés',
    'cal-yesterday': 'Hier',
    'cal-today': 'Aujourd’hui',
    'cal-tomorrow': 'Demain',
    'cal-all-day': 'Toute la journée',
    'cal-upcoming': 'À venir',
    'cal-events': 'Événements',
    'cal-earlier': 'Plus tôt',
    'cal-nothing-scheduled': 'Rien de prévu',
    'cal-add-event': 'Ajouter un événement',
    'cal-no-events': 'Aucun événement',
    'cal-one-event': '1 événement',
    'cal-n-events': '{n} événements',
    'cal-n-timed': '{n} avec heure',
    'cal-n-all-day': '{n} toute la journée',
    'cal-n-celebrations': '{n} célébrations',
    'cal-across-days': 'sur ces jours',
    'cal-dur-minutes': '{n} min',
    'cal-dur-hours': '{n} h',
    'cal-dur-hours-minutes': '{h} h {m} min',
    'cal-dur-days': '{n} jours',
    'cal-error-loading': 'Erreur de chargement des événements',
    'cal-share-premium-header': 'Le partage de calendriers est une fonctionnalité premium',
    'cal-share-premium-description': 'Pour partager des calendriers, vous devez être un utilisateur premium.',
    'cal-create-premium-header': 'La création d’événements est une fonctionnalité premium',
    'cal-create-premium-description': 'Pour créer ou modifier des événements, vous devez être un utilisateur premium.',
    shared_calendar: 'Partagé',
    birthdays: 'Anniversaires',
    work_anniversaries: 'Anniversaires d’ancienneté',
    // ScoreCard
    scorecards: 'Tableaux de résultats',
    'please-contact-org-admin':
      'Veuillez contacter l’administrateur de votre organisation pour créer un tableau de résultats.',
    mtd: 'CMJ',
    'last-month': 'Mois dernier',
    ytd: 'CAJ',
    color: 'Couleur',
    'scorecard-setting': 'Paramètres du tableau de résultats',
    settings: 'Paramètres',
    delete: 'Supprimer',
    'delete-scorecard': 'Supprimer le tableau de résultats',
    'are-you-sure':
      'Voulez-vous vraiment supprimer ce tableau de résultats ? Cette action est irréversible.',
    'avg-goal': 'Objectif moyen',
    diff: 'Écart',
    // TH Dashboard - Insights
    'did-you-know': 'Le saviez-vous ?',
    'employee-requests': 'Demandes des employés',
    waste: 'Pertes',
    'closing-hours': 'Heures de fermeture',
    // WasteInsight template
    'waste-insight-text':
      '{dateText}, vous avez {count} {storeWord} pour lesquels il manque au moins {threshold} {dayWord} de pertes enregistrées',
    'store-singular': 'restaurant',
    'store-plural': 'restaurants',
    'day-singular': 'jour',
    'day-plural': 'jours',
    // ClosingHourInsight template
    'closing-hour-insight-text':
      '{dateText}, vous avez {lobbyCount} salles et {dtCount} Drive où la dernière transaction précède l’heure de fermeture de {threshold} minutes ou plus',
    // TH Dashboard - Today
    today: 'Aujourd’hui',
    'current-day-sales': 'Ventes du jour',
    'current-day-service': 'Service du jour',
    'current-day-updates-around': 'Les données du jour sont actualisées vers {time}',
    // TH Dashboard - Snapshot
    snapshot: 'Instantané',
    'dayparts-sales': 'Ventes par période de la journée',
    'dayparts-service': 'Service par période de la journée',
    'open-11am': 'Ouverture - 11 h',
    '11am-close': '11 h - fermeture',
    'service-times': 'Temps de service',
    // TH CurrentDaySales / SalesWidget rows
    'th-row-net-sales': 'Ventes nettes',
    'th-row-transactions': 'Transactions',
    'th-row-refund-transactions': 'Transactions remboursées',
    'th-row-eat-in-trans': 'Trans sur place',
    'th-row-eat-in-refund-trans': 'Trans remboursées sur place',
    'th-row-take-out-trans': 'Trans à emporter',
    'th-row-take-out-refund-trans': 'Trans remboursées à emporter',
    'th-row-drive-thru-trans': 'Trans Drive',
    'th-row-drive-thru-refund-trans': 'Trans remboursées Drive',
    'th-row-delivery-trans': 'Trans livraison',
    'th-row-delivery-refund-trans': 'Trans remboursées livraison',
    'th-row-kiosk-trans': 'Trans borne',
    'th-row-kiosk-refund-trans': 'Trans remboursées borne',
    'th-row-mobile-take-out-trans': 'Trans à emporter mobile',
    'th-row-mobile-take-out-refund-trans': 'Trans remboursées à emporter mobile',
    'th-row-mobile-drive-thru-trans': 'Trans Drive mobile',
    'th-row-mobile-drive-thru-refund-trans': 'Trans remboursées Drive mobile',
    'th-row-refund-sales': 'Ventes remboursées',
    'th-row-avg-check': 'Ticket moyen',
    'th-row-eat-in-net-sales': 'Ventes nettes sur place',
    'th-row-eat-in-refund-sales': 'Ventes remboursées sur place',
    'th-row-eat-in-avg-check': 'Ticket moyen sur place',
    'th-row-take-out-net-sales': 'Ventes nettes à emporter',
    'th-row-take-out-refund-sales': 'Ventes remboursées à emporter',
    'th-row-take-out-avg-check': 'Ticket moyen à emporter',
    'th-row-drive-thru-net-sales': 'Ventes nettes Drive',
    'th-row-drive-thru-refund-sales': 'Ventes remboursées Drive',
    'th-row-drive-thru-avg-check': 'Ticket moyen Drive',
    'th-row-delivery-net-sales': 'Ventes nettes livraison',
    'th-row-delivery-refund-sales': 'Ventes remboursées livraison',
    'th-row-delivery-avg-check': 'Ticket moyen livraison',
    'th-row-kiosk-net-sales': 'Ventes nettes borne',
    'th-row-kiosk-refund-sales': 'Ventes remboursées borne',
    'th-row-kiosk-avg-check': 'Ticket moyen borne',
    'th-row-mobile-take-out-net-sales': 'Ventes nettes à emporter mobile',
    'th-row-mobile-take-out-refund-sales': 'Ventes remboursées à emporter mobile',
    'th-row-mobile-take-out-avg-check': 'Ticket moyen à emporter mobile',
    'th-row-mobile-delivery-net-sales': 'Ventes nettes livraison mobile',
    'th-row-mobile-delivery-refund-sales': 'Ventes remboursées livraison mobile',
    'th-row-mobile-delivery-avg-check': 'Ticket moyen livraison mobile',
    // TH Service rows
    'th-row-greet-time': 'Temps d’accueil',
    'th-row-order-time': 'Temps de commande',
    'th-row-queue-time': 'Temps d’attente en file',
    'th-row-window-time': 'Temps au guichet',
    'th-row-total-time': 'Temps total',
    // TH SalesWidget (Snapshot) rows
    'th-row-manager-void-amt': 'Mnt annulations manager',
    'th-row-cash-over-short': 'Excédent/manquant de caisse',
    'th-row-canceled-item-amt': 'Mnt articles annulés',
    'th-row-canceled-item-cnt': 'Nb articles annulés',
    'th-row-canceled-order-amt': 'Mnt commandes annulées',
    'th-row-canceled-order-cnt': 'Nb commandes annulées',
    'th-row-manager-void-cnt': 'Nb annulations manager',
    'th-row-overring-amt': 'Mnt surenregistrements',
    // TH Labor rows
    'th-row-hourly-labor-pct': '% MO horaire',
    'th-row-hourly-labor-hours': 'Heures MO horaire',
    'th-row-management-labor-pct': '% MO encadrement',
    'th-row-hourly-labor-dollar': 'MO horaire $',
    'th-row-salaried-labor-hours': 'Heures MO salariée',
    'th-row-total-labor-pct': '% MO totale',
    'th-row-proj-labor-guide': 'Guide MO prévu',
    'th-row-total-labor-hours': 'Heures MO totales',
    'th-row-training-hours': 'Heures de formation',
    'th-row-labor-cost': 'Coût de la main-d’œuvre',
    'th-row-trans-per-labor-hour': 'Trans / heure MO',
    'th-row-act-labor-guide-hours': 'Heures guides MO réelles',
    'th-row-adj-proj-hours': 'Heures proj ajust +/-',
    'th-row-avg-hourly-rate': 'Taux horaire moyen',
    // TH Shared headers
    'plus-minus': '+/-',
    // TH Main section titles
    controls: 'Contrôles',
    'shared-links': 'Liens partagés',
    'file-manager': 'Gestionnaire de fichiers',
    'assumed-role': 'Rôle assumé',
    forms: 'Formulaires',
    // MT dashboard Forms section (components/multiClient/dashboard/forms)
    // MT dashboard Equipment section (components/multiClient/dashboard/equipment)
    'equip-tickets': 'Tickets',
    'equip-reported': 'Signalés',
    'equip-accepted': 'Acceptés',
    'equip-in-progress': 'En cours',
    'equip-assigned': 'Assignés',
    'equip-on-hold': 'En attente',
    'equip-unassigned': 'Non assignées',
    'equip-scheduled': 'Planifiées',
    'equip-past-due': 'En retard',
    'equip-resolution': 'Résolution',
    'equip-completion': 'Achèvement',
    'equip-next-due': 'Prochaine tâche due le {date}',
    'equip-no-tasks-due': 'Aucune tâche à venir',
    'equip-time-left-hint': '{time} restant',
    'equip-error-loading': 'Erreur de chargement des données d’équipement',
    'equip-new-ticket': 'Nouveau ticket',
    'equip-refresh': 'Actualiser',
    'equip-all-tickets': 'Tous les tickets',
    'equip-my-tickets-link': 'Mes tickets',
    'equip-maintenance-link': 'Maintenance',
    'equip-my-tasks-link': 'Mes tâches',
    'equip-selected-locations': 'Emplacements sélectionnés',
    'equip-you': 'Vous',
    'equip-my-tickets-maintenance': 'Mes tickets et maintenance',
    'equip-all-tickets-maintenance': 'Tous les tickets et maintenance',
    'equip-everyone': 'Tous',
    'equip-maintenance': 'Maintenance',
    'equip-open-count': '{n} ouverts',
    'equip-task-count': '{n} tâches',
    'equip-reported-lc': 'signalés',
    'equip-in-progress-lc': 'en cours',
    'equip-unassigned-lc': 'non assignées',
    'equip-past-due-lc': 'en retard',
    // Resource Library (File Manager shortcuts) on the MT home dashboard
    'fm-resources': 'Ressources',
    'fm-folders': 'Dossiers',
    'fm-files': 'Fichiers',
    'fm-open-resource-library': 'Ouvrir la bibliothèque de ressources',
    'fm-refresh': 'Actualiser',
    'fm-download': 'Télécharger',
    'fm-remove-shortcut': 'Retirer le raccourci',
    'fm-scroll-left': 'Défiler vers la gauche',
    'fm-scroll-right': 'Défiler vers la droite',
    'fm-n-items': '{n} éléments',
    'fm-added': 'Ajouté le {date}',
    'fm-n-shortcuts': '{n} raccourcis',
    'fm-no-folders': 'Aucun raccourci de dossier',
    'fm-no-files': 'Aucun raccourci de fichier',
    'fm-empty': 'Aucun raccourci de dossier ou de fichier pour le moment. Marquez des éléments d’une étoile dans le gestionnaire de fichiers et ils apparaîtront ici.',
    'fm-add-shortcuts': 'Ajouter des raccourcis',
    'fm-error': 'Erreur lors du chargement des raccourcis',
    'forms-favorites': 'Favoris',
    'forms-in-progress': 'En cours',
    'forms-error-loading': 'Erreur de chargement des formulaires',
    retry: 'Réessayer',
    'forms-manage-favorites': 'Gérer les favoris',
    'forms-no-favorites-title': 'Aucun favori pour le moment',
    'forms-no-favorites-hint':
      'Appuyez sur l’engrenage pour ajouter les formulaires que vous utilisez le plus.',
    'forms-nothing-in-progress-title': 'Rien en cours. Bravo !',
    'forms-nothing-in-progress-hint':
      'Les formulaires que vous commencez apparaîtront ici pour que vous puissiez les reprendre.',
    'forms-started': 'Commencé {when}',
    'forms-continue': 'Continuer',
    'forms-percent-complete': '{pct} % terminé',
    'forms-open-form': 'Ouvrir {title}',
    equipment: 'Équipements',
    // Standard main section titles
    'snapshot-month': 'Instantané du mois',
    // Calendar
    'view-calendar': 'Voir le calendrier',
    'calendar-options': 'Options du calendrier',
    // TH Budget rows
    'th-row-total-labor-dollars': 'Total MO en dollars',
    'th-row-food-cost': 'Coût matières',
    'th-row-food-cost-pct': '% coût matières',
    'th-row-annual-salary': 'Salaire annuel',
    'th-row-crew-dollars': 'Équipiers en dollars',
    'th-row-crew-labor-pct': '% MO équipiers',
    'th-row-manager-labor-pct': '% MO managers',
    // TH Food rows
    'th-row-adj-theo-food-cost-pct': '% coût matières théorique ajusté',
    'th-row-food-var-pct': '% écart matières',
    'th-row-total-waste-pct': '% pertes totales',
    'th-row-total-cost': 'Coût total',
    'th-row-paper-cost': 'Coût papier',
    'th-row-other-cost': 'Coût autres',
    'th-row-total-var-cost': 'Coût écart total',
    'th-row-food-var-cost': 'Coût écart matières',
    'th-row-paper-var-cost': 'Coût écart papier',
    'th-row-other-var-cost': 'Coût écart autres',
    'th-row-total-waste-cost': 'Coût pertes totales',
    'th-row-total-cost-pct': '% coût total',
    'th-row-paper-cost-pct': '% coût papier',
    'th-row-other-cost-pct': '% coût autres',
    'th-row-total-var-pct': '% écart total',
    'th-row-paper-var-pct': '% écart papier',
    'th-row-other-var-pct': '% écart autres',
    'th-row-theo-food-cost-pct': '% coût matières théorique',
    'th-row-gap-variance-pct': '% écart d’intervalle',
    // TH DayPart Sales rows
    'th-row-daypart-sales': 'Ventes',
    'th-row-daypart-avg-chk': 'Ticket moy.',
    'th-row-daypart-tcs': 'TC',
    'th-row-daypart-dt-sales': 'Ventes Drive',
    'th-row-daypart-dt-avg-chk': 'Ticket moy. Drive',
    'th-row-daypart-dt-tcs': 'TC Drive',
    'th-row-daypart-lobby-sales': 'Ventes salle',
    'th-row-daypart-lobby-avg-chk': 'Ticket moy. salle',
    'th-row-daypart-lobby-tcs': 'TC salle',
    // CompTypeSelector
    'trading': 'Exercice commercial',
    // Security / Insights
    'error-loading-data': 'Erreur de chargement des données',
    'security-events': 'Événements',
    'security-locations': 'Sites',
    'security-employees': 'Employés',
    'security-drill-down': 'Analyse sécurité',


    // Insight Settings dialog
    'insight-settings-title': 'Paramètres des analyses',
    'insight-settings-insight': 'Analyse',
    'insight-settings-insights': 'Analyses',
    'insight-settings-for': 'Paramètres – {name}',
    'insight-settings-watch-lists': 'Listes de surveillance',
    'insight-settings-threshold': 'Seuil',
    'insight-settings-minutes-threshold': 'Seuil en minutes',
    'insight-settings-waste-threshold': 'Seuil de gaspillage',
    'insight-settings-days-missed-limit': 'Limite de jours manqués',
    'insight-settings-modified-punches': 'Pointages modifiés',
    'widget-settings-select-card-color': 'Sélectionner la couleur de la carte',

    // Security Drill Down date tabs
    'security-date-today': 'Auj.',
    'security-date-yest': 'Hier',
    'security-date-wtd': 'SEC',
    'security-date-lw': 'SD',
    'security-date-custom-range': 'Plage de dates personnalisée',
    'security-date-exceeds-max-range':
      'Dépasse la plage maximale de {days} jours',

    'top-events': 'Principaux événements',
    'top-locations': 'Principaux sites',
    'top-cashiers': 'Principaux caissiers',
    'top-managers': 'Principaux managers',
    'security-drill-down-title': 'Analyse sécurité',
    'security-drill-down-event-selection': 'Sélection des événements',
    'security-drill-down-max-events': "Sélectionnez jusqu'à {max} événements",
    'security-drill-down-customize-events': 'Personnaliser les événements',
    'security-drill-down-search-events': 'Événement',
    'security-drill-down-includes': 'Comprend :',
    'security-drill-down-coupon-letter': 'Coupon {letter}',
    'security-drill-down-events-auto': 'Les {max} premiers par $',
    'security-drill-down-events-choose': 'Choisir les événements',
    'security-drill-down-order-value': 'Trier par $',
    'security-drill-down-order-custom': 'Ordre personnalisé',
    // the event names Security Events uses
    'security-drill-down-event-cash_refund': 'Remboursement en espèces',
    'security-drill-down-event-cashless_refund': 'Remboursement sans espèces',
    'security-drill-down-event-pos_overring': 'Sur-enregistrement POS',
    'security-drill-down-event-t_red_before': 'T-Red Avant',
    'security-drill-down-event-t_red_after': 'T-Red Après',
    'security-drill-down-event-total_order_promo': 'Promo de Commande Totale',
    'security-drill-down-event-other_promo': 'Autre Promo',
    'security-drill-down-event-mobile_promo': 'Promo Mobile',
    'security-drill-down-event-delivery_promo': 'Promo de Livraison',
    'security-drill-down-event-all_promo': 'Toutes les Promos',
    'security-drill-down-event-pos_auto_discount': 'Remise Automatique POS',
    'security-drill-down-event-mobile_discount': 'Remise Mobile',
    'security-drill-down-event-other_discount': 'Autre Remise',
    'security-drill-down-event-all_discount': 'Toutes les Remises',
    'security-drill-down-event-coupon': 'Coupons',
    'security-drill-down-event-employee_meal': 'Repas des Employés',
    'security-drill-down-event-manager_meal': 'Repas des Gérants',
    'security-drill-down-event-duplicate_card_swipe': 'Glissement de Carte en Double',
    'security-drill-down-event-high_lock_out': 'Verrouillage pour Montant Élevé',
    'security-drill-down-event-high_lock_out_tender': 'Verrouillage pour Montant Élevé (Paiement)',
    'security-drill-down-event-billable_sales': 'Ventes Facturables',
    'security-drill-down-event-electronic_benefit_transfer': 'Transfert Électronique de Prestations (EBT)',
    'cashiers': 'Caissiers',
    'managers': 'Managers',
    // SecurityTable
    'transactions': 'TRANSACTIONS',
    'activity-label': 'Activité',
    'date-header': 'Date',
    'time-header': 'Heure',
    'daypart-header': 'Période de la journée',
    'register-header': 'Caisse',
    'crew-header': 'Équipier',
    'manager-header': 'Manager',
    'mgr-code-header': "Type d'autorisation du manager",
    'details-header': 'Voir le détail',
    'camera-header': 'Caméra',
    'event-time-header': "Heure de l'événement",
    'amount-header': 'Montant',
    'remaining-amount-header': 'Montant restant',
    'not-applicable-value': 'S.O.',
    'unavailable-value': 'Non disponible',
    'tender-type-header': 'Mode de paiement',
    'loyalty-id-header': 'ID fidélité',
    'event-type-header': 'Type',
    'activity-type-header': 'Type d’activité',
    'promo-type-header': 'Type de promo',
    'discount-type-header': 'Type de remise',
    'billable-org-header': 'Organisation facturable',
    'lockout-type-header': 'Type de verrouillage',
    'item-count-header': 'Nombre d’articles',
    'coupon-type-header': 'Type de coupon',
    'overring-amount-header': 'Montant du surenregistrement',
    'reduction-amount-header': 'Montant de la réduction',
    'discount-amount-header': 'Montant de la remise',
    'promo-amount-header': 'Montant de la promo',
    'refund-amount-header': 'Montant du remboursement',
    'data-failed-to-load': 'Le chargement des données a échoué. Veuillez réessayer.',
    'tender-cash': 'Espèces',
    'tender-cashless': 'Sans espèces',
    'tender-us$_cashless': 'Sans espèces USD',
    'tender-gift_card': 'Carte cadeau',
    'tender-no_tender': 'Aucun paiement',
    'tender-billable_sales': 'Ventes facturables',
    'tender-other': 'Autre',
    'mgr_auth_code': 'code de manager',
    'mgr_auth_biometrics': 'biométrie',
    // Security event token labels
    'cash_refund': 'Remboursement espèces',
    'cashless_refund': 'Remboursement sans espèces',
    'pos_overring': 'Surenregistrement caisse',
    'other_promo': 'Autre promo',
    'total_order_promo': 'Promo totale',
    'total_promo': 'Promo totale',
    'billable_sales': 'Ventes facturables',
    'drawer_open': 'Ouverture de tiroir',
    'general_drawer_open': 'Ouverture de tiroir générale',
    't_red_before': 'Réduction de transaction avant',
    't_red_after': 'Réduction de transaction après',
    'mobile_discount': 'Remise mobile',
    'mobile_promo': 'Promo mobile',
    'pos_auto_discount': 'Remise automatique caisse',
    'other_discount': 'Autre remise',
    'loyalty_reward_ids': 'Récompense fidélité',
    'employee_meal': 'Repas employé',
    'manager_meal': 'Repas manager',
    'duplicate_card_swipe': 'Passage de carte en double',
    'coupon': 'Coupon',
    'all_discount': 'Toutes les remises',
    'all_promo': 'Toutes les promos',
    'high_lock_out': 'Verrouillage élevé',
    'high_lock_out_tender': 'Verrouillage élevé – mode de paiement',
    'high_lock_out_amount': 'Verrouillage élevé – montant',
    'high_lock_out_item': 'Verrouillage élevé – article',
    'electronic_benefit_transfer': 'Transfert électronique de prestations (EBT)',
    'delivery_promo': 'Promo livraison',
    'all_events': 'Activités mixtes',
    'event-type-earn': 'Cumul',
    'event-type-burn': 'Utilisation',
    // SecurityTableSlideUp
    'highlight-info': 'Les lignes surlignées indiquent que le caissier a été modifié dans C&I après le changement de tiroir en caisse lors du comptage.',
    // MoreInfo
    'more-info': 'Plus d’informations',
    'view-insight': 'Voir l’analyse',
    'drawer-open-verbiage': '{cashierName} a eu {eventQuantity} {eventName} le {date} à {location}',
    'general-drawer-open-verbiage': '{managerName} a eu {eventQuantity} {eventName} le {date} à {location}',
    'drawer-open-verbiage-burst': '{cashierName} a eu une série de {eventQuantity} {eventName} le {date} à {location}',
    'other-verbiage': '{cashierName} a eu {eventQuantity} {eventName} pour un total de {eventAmount} le {date} à {location}',
    'other-verbiage-burst': '{cashierName} a eu une série de {eventQuantity} {eventName} pour un total de {eventAmount} le {date} à {location}',
    'loyalty-reward-ids-verbiage': 'Un identifiant de récompense fidélité a été utilisé {eventQuantity} fois pour un total de {eventAmount} le {date} à {location}',
    'extended-over-eight-hours-drawer-open-verbiage-for-cashier': 'Le caissier {cashierName} a enregistré en moyenne {eventQuantity} {eventName}/8 h de caisse sur les {numOfDays} derniers jours à {location}',
    'extended-over-eight-hours-drawer-open-verbiage-for-cashier-general': 'Le caissier {cashierName} a enregistré en moyenne {eventQuantity} {eventName}/8 h de caisse du {dateRange} à {location}',
    'extended-over-eight-hours-other-verbiage-for-cashier': 'Le caissier {cashierName} a enregistré en moyenne {eventAmount} de {eventName}/8 h de caisse sur les {numOfDays} derniers jours à {location}',
    'extended-over-eight-hours-other-verbiage-for-cashier-general': 'Le caissier {cashierName} a enregistré en moyenne {eventAmount} de {eventName}/8 h de caisse du {dateRange} à {location}',
    'extended-less-than-eight-hours-drawer-open-verbiage-for-cashier': 'Le caissier {cashierName} a enregistré {eventQuantity} {eventName} en {lessEightHours} h de caisse sur les {numOfDays} derniers jours à {location} (moins de 8 h)',
    'extended-less-than-eight-hours-drawer-open-verbiage-for-cashier-general': 'Le caissier {cashierName} a enregistré {eventQuantity} {eventName} en {lessEightHours} h de caisse du {dateRange} à {location} (moins de 8 h)',
    'extended-less-than-eight-hours-other-verbiage-for-cashier': 'Le caissier {cashierName} a enregistré {eventAmount} de {eventName} en {lessEightHours} h de caisse sur les {numOfDays} derniers jours à {location}',
    'extended-less-than-eight-hours-other-verbiage-for-cashier-general': 'Le caissier {cashierName} a enregistré {eventAmount} de {eventName} en {lessEightHours} h de caisse du {dateRange} à {location}',
    'extended-drawer-open-verbiage-for-manager': 'Le manager {managerName} a approuvé au total {eventQuantity} {eventName} sur les {numOfDays} derniers jours à {location}',
    'extended-drawer-open-verbiage-for-manager-general': 'Le manager {managerName} a approuvé au total {eventQuantity} {eventName} du {dateRange} à {location}',
    'extended-other-verbiage-for-manager': 'Le manager {managerName} a approuvé au total {eventAmount} de {eventName} sur les {numOfDays} derniers jours à {location}',
    'extended-other-verbiage-for-manager-general': 'Le manager {managerName} a approuvé au total {eventAmount} de {eventName} du {dateRange} à {location}',
    'data-failed-to-load-support': 'Le chargement des données a échoué. Veuillez réessayer ou contacter le support si le problème persiste.',
    // InsightsContainer
    'all-quiet-here': 'Rien à signaler',
    'product-outage': 'Rupture de produit',
    'business-day-close': 'Clôture de la journée d’activité',
    'open-late-close-early': 'Ouverture tardive / fermeture anticipée',
    'minor-exceptions': 'Exceptions mineurs',
    'product-default': 'Par défaut',
    'product-product-and-inventory': 'Prod/stock',
    'product-people': 'RH',
    'product-shift': 'Poste',
    'product-security': 'Sécurité',
    'employee-request': 'Demandes des employés',
    'suspicious-activity': 'Activité suspecte',
    'rbd': 'RBD',
    'rbd-completed': 'RBD finalisés',
    'rbd-activation': 'Activation RBD',
    'rbd-completed-threshold': 'Seuil de RBD finalisés',
    'threshold-hint': 'Alerter lorsque des restaurants dépassent ce nombre de RBD finalisés sur 30 jours (1-10)',
    'potential-ot': 'Heures sup. potentielles',
    'simplethink': 'Premium',
    '30-day-terms': 'Départs à 30 jours',
    '90-day-terms': 'Départs à 90 jours',
    'people-terms': 'Départs RH',
    'last-thirty-days': '30 derniers jours',
    'trailing-365-days': '365 derniers jours',
    'trailing-thirty-days': '30 derniers jours glissants',
    'yesterday': 'Hier',
    'this-week': 'Cette semaine',
    'last-week': 'Semaine dernière',
    'this-month': 'Ce mois-ci',
    'last-seven-days': '7 derniers jours',
    'modified-punches': 'Pointages modifiés',
    'store-alerts': 'Alertes restaurant',
    'store-notifications': 'Notifications restaurant', // TODO translation review
    'product-candi': 'C&I',
    'waste-entry': 'Saisie des pertes',
    'stat-inventory': 'Statistiques de stock',
    // OLCEInsight
    'open-late-message': `<strong>{count}</strong> restaurant peut avoir enregistré <strong>{daysThreshold}</strong> ouvertures tardives ou plus au cours des 7 derniers jours. | <strong>{count}</strong> restaurants peuvent avoir enregistré <strong>{daysThreshold}</strong> ouvertures tardives ou plus au cours des 7 derniers jours.`,
    'close-early-message': `<strong>{count}</strong> restaurant peut avoir enregistré <strong>{daysThreshold}</strong> fermetures anticipées ou plus au cours des 7 derniers jours. | <strong>{count}</strong> restaurants peuvent avoir enregistré <strong>{daysThreshold}</strong> fermetures anticipées ou plus au cours des 7 derniers jours.`,
    // Shift Runner Scorecard
    'sms-shift-runner-scorecard': 'Fiche de résultats du chef de quart',
    'sms-shift-scorecard': 'Fiche de résultats du quart',
    'sms-no-data': 'Aucune donnée',
    'sms-overall': 'Global',
    'sms-shift-prep': 'Préparation du quart',
    'sms-shift-operational-metrics': 'Métriques d’exploitation du quart - vs objectif',
    'sms-shift-runner': 'Chef de quart',
    'sms-shifts': 'Quarts',
    'sms-score': 'Score',
    'sms-pre-shift-checklist': 'Liste de vérification avant quart',
    'sms-travel-path': 'Parcours',
    'sms-oepe-w-o': 'OEPE sans stationnement',
    'sms-r2p': 'R2P',
    'sms-kvs-time-per-gc': 'Temps KVS par client',
    'sms-kvs-healthy-usage': 'Utilisation saine du KVS',
    'food-safety-completed': 'Complétés',
    'food-safety-passed-failed': '{passed} réussis · {failed} échoués',
    'food-safety-equipment-issues': "Problèmes d'équipement",
    'food-safety-completed-forms': 'Formulaires complétés',
    'food-safety-no-equipment-issues': "Aucun problème d'équipement",
    'food-safety-unknown-equipment': 'Équipement inconnu',
    'food-safety-no-location': 'Aucun emplacement',
    'food-safety-exceptions': 'Exceptions',
    'food-safety-view-report': 'Voir le rapport',
    'food-safety-load-error': 'Erreur lors du chargement des données de sécurité alimentaire',
    'food-safety-no-forms': "Aucun formulaire de sécurité alimentaire n'est configuré pour cette organisation",
    'food-safety-thresholds': 'Seuils de sécurité alimentaire',
    'food-safety-thresholds-description':
      "Définissez le taux de réussite requis pour chaque couleur. Ces seuils s'appliquent à toute votre organisation.",
    'food-safety-green-at': 'Vert à partir de',
    'food-safety-yellow-at': 'Jaune à partir de',
    'food-safety-legend-green': 'Vert : {value} % et plus',
    'food-safety-legend-yellow': 'Jaune : de {low} % à moins de {high} %',
    'food-safety-legend-red': 'Rouge : moins de {value} %',
    'food-safety-percent-rule': 'Entrez une valeur de 0 à 100',
    'food-safety-yellow-rule': 'Doit être inférieur ou égal au seuil vert',
    'food-safety-thresholds-save-error': "Impossible d'enregistrer les seuils. Veuillez réessayer.",
    'food-safety-insight-completed':
      '<strong>{count}</strong> formulaire de sécurité alimentaire complété {period} | <strong>{count}</strong> formulaires de sécurité alimentaire complétés {period}',
    'food-safety-insight-pass-rate': '{rate} réussis',
    'food-safety-insight-equipment':
      "<strong>{count}</strong> problème d'équipement : | <strong>{count}</strong> problèmes d'équipement :",
    'food-safety-and-more': '+{count} de plus',
    'food-safety-equipment': 'Équipement',
    'food-safety-date-time': 'Date/heure',
    'food-safety-store': 'Emplacement',
    'food-safety-form': 'Formulaire',
    'food-safety-completed-at': 'Complété le',
    'food-safety-completed-by': 'Complété par',
    'food-safety-status': 'Statut',
    'food-safety-status-passed': 'Réussi',
    'food-safety-status-failed': 'Échoué',
    'food-safety-type': 'Type',
    'food-safety-type-safety': 'Sécurité',
    'food-safety-type-quality': 'Qualité',
    'food-safety-type-calibration': 'Étalonnage',
    'food-safety-temperature': 'Temp.',
    'food-safety-target': 'Cible',
    'food-safety-product': 'Produit',
    'food-safety-corrective-action': 'Mesure corrective',
  },
  'fr-ca': {
    // Migrated from <i18n> SFC blocks (#6500)
    'print': 'Imprimer',
    'calendar-view': 'Calendrier',
    'list-view': 'Liste',
    'calendar-list-all-day': 'Toute la journée',
    'no-events': 'Aucun événement pour cette période',
    'show-more': 'Afficher plus',
    'show-less': 'Afficher moins',
    'close-filters': 'Fermer les filtres',
    'open-filters': 'Ouvrir les filtres',
    'add-subscriptions': 'Ajouter des abonnements',
    'show': 'Afficher',
    'more': 'Plus',
    'subscribe-premium-banner-header': 'Le partage de calendriers est une fonctionnalité premium',
    'subscribe-premium-banner-description': 'Pour partager des calendriers, vous devez être un utilisateur premium.',
    'all-day-label': 'Événements sur toute la journée',
    'events-title': 'Événements',
    'calendar-desktop-view-locations': 'Emplacements',
    'calendar-desktop-view-create': 'Créer un événement',
    'calendar-desktop-view-share-calendars': 'Partager des calendriers',
    'calendar-desktop-view-create-event-premium-banner-header': 'La création d’événements est une fonction premium',
    'calendar-desktop-view-create-event-premium-banner-description': 'Pour créer des événements, vous devez être un utilisateur premium.',
    'calendar-desktop-view-manage-calendars-premium-banner-description': 'Pour ajouter ou gérer des calendriers, vous devez être un utilisateur premium.',
    'calendar-desktop-view-manage-calendars': 'Gérer les calendriers',
    'calendar-desktop-view-manage-calendars-premium-banner-header': 'La gestion des calendriers est une fonctionnalité premium',
    'three-day': '3 jours',
    'calendar-mobile-view-locations': 'Emplacements',
    'calendar-mobile-view-create': 'Créer un événement',
    'calendar-mobile-view-share-calendars': 'Partager des calendriers',
    'calendar-mobile-view-no-events': 'Aucun événement',
    'calendar-mobile-view-create-event-premium-banner-header': 'La création d’événements est une fonction premium',
    'calendar-mobile-view-create-event-premium-banner-description': 'Pour créer des événements, vous devez être un utilisateur premium.',
    'calendar-mobile-view-manage-calendars-premium-banner-description': 'Pour ajouter ou gérer des calendriers, vous devez être un utilisateur premium.',
    'calendar-mobile-view-manage-calendars': 'Gérer les calendriers',
    'calendar-mobile-view-manage-calendars-premium-banner-header': 'La gestion des calendriers est une fonctionnalité premium',
    // Migrated from <i18n> SFC blocks (#6500)
    'custom-range': 'Plage de dates personnalisée',
    'apply': 'Appliquer',
    'quick-date-filter-last-week': 'Semaine dernière',
    'quick-date-filter-this-week': 'Cette semaine',
    'quick-date-filter-week-to-date': 'Semaine à ce jour',
    'quick-date-filter-this-month': 'Ce mois-ci',
    'quick-date-filter-month-to-date': 'Mois à ce jour',
    'quick-date-filter-year-to-date': 'Année à ce jour',
    'quick-date-filter-last-month': 'Mois dernier',
    'quick-date-filter-last-year': 'An dernier',
    'quick-date-filter-start-date': 'Date de début',
    'quick-date-filter-end-date': 'Date de fin',
    'quick-date-filter-select-date': 'Sélectionner une date',
    // Migrated from <i18n> SFC blocks (#6500)
    'are-you-sure-you-want-to-delete': 'Voulez-vous vraiment supprimer ce calendrier? Tous les événements associés à ce calendrier seront supprimés.',
    'basic_settings': 'Paramètres de base',
    'subscriptions': 'Abonnements',
    'add_subscription': 'Ajouter un abonnement',
    'subscription_url': 'URL de l’abonnement',
    'subscription_name': 'Nom de l’abonnement',
    'subscription_name_hint': 'Nom qui apparaîtra dans votre calendrier',
    'existing_subscriptions': 'Abonnements existants',
    'no_subscriptions_yet': 'Aucun abonnement ajouté pour l’instant',
    'url_required': 'L’URL est obligatoire',
    'invalid_url': 'Veuillez entrer une URL valide',
    'ok': 'OK',
    'error_loading_subscriptions': 'Échec du chargement des abonnements au calendrier',
    'error_adding_subscription': 'Échec de l’ajout de l’abonnement au calendrier',
    'error_removing_subscription': 'Échec de la suppression de l’abonnement au calendrier',
    'error_syncing_subscription': 'Échec de la synchronisation de l’abonnement au calendrier',
    'sync_subscription': 'Synchroniser l’abonnement',
    'remove_subscription': 'Supprimer l’abonnement',
    'subscription': 'Abonnement',
    'are_you_sure_you_want_to_delete_subscription': 'Voulez-vous vraiment supprimer cet abonnement? Il sera retiré de votre calendrier.',
    'edit_subscription_name': 'Modifier le nom de l’abonnement',
    'name_required': 'Le nom est obligatoire',
    'error_updating_subscription_name': 'Échec de la mise à jour du nom de l’abonnement',
    'subscription_already_exists': 'L’abonnement existe déjà',
    'subscription_already_added': 'L’abonnement a déjà été ajouté',
    'not_authorized': 'Non autorisé',
    'network_offline': 'Réseau hors ligne',
    'manage_subscriptions': 'Gérer les abonnements',
    'role-required': 'Au moins un rôle est requis',
    'location-required': 'Au moins un emplacement est requis',
    'unknown_error': 'Erreur inconnue',
    'shift_manager': 'Gérant de quart',
    'general_manager': 'Directeur général',
    'mid_manager': 'Gérant intermédiaire',
    'owner_operator': 'Propriétaire-exploitant',
    'color_primary_blue': 'Bleu primaire',
    'color_lavender': 'Lavande',
    'color_grape': 'Raisin',
    'color_blush': 'Rose poudré',
    'color_magenta': 'Magenta',
    'color_violet': 'Violet',
    'color_indigo': 'Indigo',
    'color_sky_blue': 'Bleu ciel',
    'color_navy': 'Bleu marine',
    'color_mint': 'Menthe',
    'color_teal': 'Sarcelle',
    'color_ice_blue': 'Bleu glacier',
    'color_ocean': 'Océan',
    'color_latte': 'Café au lait',
    'color_chocolate': 'Chocolat',
    'color_sage': 'Sauge',
    'color_olive': 'Olive',
    'color_butter': 'Beurre',
    'color_amber': 'Ambre',
    'color_peach': 'Pêche',
    'color_coral': 'Corail',
    'create-edit-calendar-locations': 'Emplacements',
    'create-edit-calendar-edit_subscription': 'Modifier l’abonnement',
    'attachment-of': '{current} sur {total}',
    'preview-not-available': 'Aperçu non disponible pour ce type de fichier',
    'video-not-supported': 'Votre navigateur ne prend pas en charge la lecture vidéo',
    'swipe-to-navigate': 'Glissez pour naviguer',
    'pdf-mobile-hint': 'Appuyez ci-dessous pour afficher le PDF dans votre navigateur',
    'open-pdf': 'Ouvrir le PDF',
    'go-to-attachment': 'Aller à la pièce jointe {number}',
    'attachment-media-viewer-previous': 'Pièce jointe précédente',
    'attachment-media-viewer-next': 'Pièce jointe suivante',
    'insert-link': 'Insérer un lien',
    'link': 'Lien',
    'title': 'Titre',
    'link-address-http-help': 'Entrez une adresse Web valide.',
    'summary-all-day': 'Toute la journée',
    'no-occurrence-before-end': 'Aucune occurrence avant le {date}. Modifiez les paramètres de répétition ou la date de fin.',
    'description-max-length': 'La description doit comporter 1 000 caractères ou moins',
    'existing-attachments': 'Pièces jointes actuelles',
    'remove-attachment': 'Retirer la pièce jointe',
    'undo-remove': 'Annuler le retrait',
    'audience': 'Public',
    'content': 'Contenu',
    'news-feed': 'Fil de nouvelles',
    'feed-post': 'Afficher dans le fil de nouvelles',
    'post-to-feed': 'Publier dans le fil',
    'days-before-event': 'jours avant',
    'lead-days-locked': 'L’événement commence aujourd’hui ou plus tôt, il ne peut donc pas être publié dans le fil à l’avance.',
    'days-before-event-label': 'jours avant l’événement',
    'days-before-event-lower': 'jours avant l’événement',
    'news-feed-settings': 'Paramètres du fil de nouvelles',
    'event-name': 'Nom de l’événement',
    'calendar-name': 'Nom du calendrier',
    'event-start': 'Début de l’événement',
    'event-end': 'Fin de l’événement',
    'show-in-news-feed': 'Afficher dans le fil de nouvelles',
    'repeat': 'Répéter',
    'subscription-edit-info': 'Certains détails de l’événement ne peuvent être modifiés qu’à partir de l’endroit où il a été créé à l’origine.',
    'pin-to-top': 'Épingler en haut',
    'event-form-name': 'Nom de l’événement',
    'event-form-locations': 'Emplacements',
    'event-form-save': 'ENREGISTRER',
    'event-form-not-available': 'Non disponible',
    'event-form-start-date': 'Date de début',
    'event-form-start-time': 'Heure de début',
    'event-form-end-date': 'Date de fin',
    'event-form-end-time': 'Heure de fin',
    'event-form-all': 'Tous',
    'event-form-all-locations': 'Tous les emplacements',
    'event-form-mid_manager': 'Gérant intermédiaire',
    'event-form-owner_operator': 'Propriétaire-exploitant',
    'stores': 'restaurants',
    'missing-at-least-one-business-day-close': 'auxquels il manque au moins une fermeture de journée d’exploitation',
    'seven-days-insight-text': 'au cours des 7 derniers jours',
    'highlighted-cells-represent': 'Les cellules surlignées représentent',
    'service-sales-labor-negative-variance': 'Service, ventes et main-d’œuvre = écart négatif par rapport aux tendances récentes du même jour de la semaine.',
    'gc-proj-sales-proj': 'NC - Prév., Ventes - Prév. = écart horaire de +/- 10 par rapport aux prévisions',
    'projected-product-sales': 'Ventes de produits prévues',
    'my-metrics': 'Mes indicateurs',
    'qtr': 'Trim.',
    'dar-widget-daypart': 'Période de la journée',
    // Migrated from <i18n> SFC blocks (#6500)
    'allow-users-to-create-their-own-dashboard': 'Permettre aux utilisateurs de créer leur propre tableau de bord',
    'no-shift-leader-scheduled': 'Aucun chef de quart à l’horaire',
    'current-shift-runner-thru': 'à',
    'current-shift-runner-shift-leader': 'Chef de quart',
    'dashboard-settings': 'Paramètres du tableau de bord',
    'delete-dashboard': 'Supprimer le tableau de bord',
    'you-are-about-to-delete-this-dashboard': 'Vous êtes sur le point de supprimer ce tableau de bord. Cette action est irréversible.',
    'global-settings': 'Paramètres généraux',
    'qsr-admin-only-settings': 'Paramètres réservés aux administrateurs QSR',
    'copy-widgets': 'Copier les widgets',
    'reset-org': 'Réinitialiser l’organisation',
    'this-will-reset-the-entire-organization-dashboard': 'Les paramètres du tableau de bord de toute l’organisation seront réinitialisés. Cette action est irréversible.',
    'yes-nuke-em': 'Oui, tout effacer',
    'reset-this-user': 'Réinitialiser cet utilisateur',
    'this-will-reset-this-users-dashboard-settings-this-action-cannot-be-undone': 'Les paramètres du tableau de bord de cet utilisateur seront réinitialisés. Cette action est irréversible.',
    'dashboard-name': 'Nom du tableau de bord',
    'assigned-roles': 'Rôles attribués',
    'error-loading-events': 'Erreur de chargement des événements',
    'nothing-here': 'Rien ici',
    'yest': 'Hier',
    'tmw': 'Dem.',
    'create-event': 'Créer un événement',
    'share-calendars': 'Liens de calendrier partagés',
    'share-calendars-premium-banner-header': 'Le partage de calendriers est une fonctionnalité premium',
    'share-calendars-premium-banner-description': 'Pour partager des calendriers, vous devez être un utilisateur premium.',
    'create-event-premium-banner-header': 'La création d’événements est une fonctionnalité premium',
    'create-event-premium-banner-description': 'Pour créer ou modifier des événements, vous devez être un utilisateur premium.',
    'all-day': 'Toute la journée',
    'calendars': 'Calendriers inclus',
    'select-all': 'Tout sélectionner',
    'all-calendars': 'Tous les calendriers',
    'others': 'autres',
    'manage-calendars': 'Gérer les calendriers',
    'manage-calendars-premium-banner-header': 'La gestion des calendriers est une fonctionnalité premium',
    'manage-calendars-premium-banner-description': 'Pour gérer les calendriers, vous devez être un utilisateur premium.',
    'calendar-selector-home': 'Emplacement d’attache',
    'create-calendar': 'Créer un calendrier',
    'manage-calendars-modal-manage-calendars': 'Gérer les calendriers',
    'calendar-is-premium-feature': 'Le calendrier est une fonctionnalité premium',
    'calendar-premium-description': 'Pour accéder au calendrier de l’organisation et créer ou modifier des événements et des calendriers,',
    'ask-system-admin-upgrade': 'Demandez à votre administrateur système de faire passer votre organisation à Premium.',
    'subscribe-to-premium': 'Passez à Premium',
    'date-text-field-ok': 'OK',
    'your-time': 'Votre heure',
    'event': 'Événement',
    'edit-this-and-future-occurrences': 'Modifier cette occurrence et les suivantes',
    'edit-this-occurrence': 'Modifier cette occurrence',
    'calendar-is-required': 'Le calendrier est obligatoire',
    'start': 'Début',
    'end': 'Fin',
    'timezone': 'Fuseau horaire',
    'end-recurring-event-on': 'Fin de la récurrence le',
    'delete-event': 'Supprimer l’événement',
    'are-you-sure-you-want-to-delete-this-event': 'Voulez-vous vraiment supprimer cet événement? Tous les événements récurrents associés seront également supprimés.',
    'start-date-must-be-before-end-date': 'La date de début doit être antérieure à la date de fin',
    'event-details': 'Détails de l’événement',
    'edit-event': 'Modifier l’événement',
    'edit-event-form-update': 'Enregistrer',
    'attachments': 'Pièces jointes',
    'files-selected': '{count} fichiers sélectionnés',
    'drag-files-here': 'Glissez des fichiers ici ou cliquez pour parcourir',
    'accepted-file-types': 'Images, vidéos ou PDF',
    'drop-zone-label': 'Zone de dépôt des pièces jointes. Cliquez ou appuyez sur Entrée pour parcourir les fichiers.',
    'remove-file': 'Retirer {name}',
    'add-more-files': 'Cliquez ou glissez pour ajouter d’autres fichiers',
    'file-too-large': 'Fichier(s) trop volumineux : {names}. La taille maximale est de {limit} Mo.',
    'loading-attachments': 'Chargement des fichiers...',
    'error-loading': 'Échec du chargement des fichiers',
    'view-attachment': 'Voir {name}',
    'event-attachment-list-attachments': '{count} fichier | {count} fichiers',
    'does-not-repeat': 'Ne se répète pas',
    'none': 'Aucune',
    'no-description': 'Aucune description',
    'all-locations': 'Tous les emplacements',
    'all-roles': 'Tous les rôles',
    'search-locations': 'Rechercher des emplacements',
    'external-org': 'Externe — {org}',
    'internal-calendar': 'Interne — {calendar}',
    'repeats-every': 'Répéter tous les',
    'repeats': 'Répétition',
    'days': 'Jour(s)',
    'weeks': 'Semaine(s)',
    'months': 'Mois',
    'years': 'Année(s)',
    'frequency-settings-does-not-repeat': 'Ne se répète pas',
    'on-day': 'le jour',
    'on-the': 'le',
    'monthly-frequency-first': 'Premier',
    'monthly-frequency-second': 'Deuxième',
    'monthly-frequency-third': 'Troisième',
    'monthly-frequency-fourth': 'Quatrième',
    'monthly-frequency-last': 'Précédent',
    'm': 'LU',
    'tu': 'MA',
    'w': 'ME',
    'th': 'JE',
    'f': 'VE',
    'sa': 'SA',
    'su': 'DI',
    'january': 'Janvier',
    'february': 'Février',
    'march': 'Mars',
    'april': 'Avril',
    'may': 'Mai',
    'june': 'Juin',
    'july': 'Juillet',
    'august': 'Août',
    'september': 'Septembre',
    'october': 'Octobre',
    'november': 'Novembre',
    'december': 'Décembre',
    'yearly-frequency-on': 'de',
    'yearly-frequency-sunday': 'Dimanche',
    'yearly-frequency-first': 'Premier',
    'yearly-frequency-second': 'Deuxième',
    'yearly-frequency-third': 'Troisième',
    'yearly-frequency-fourth': 'Quatrième',
    'yearly-frequency-last': 'Précédent',
    'edit_subscription': 'Modifier le lien de calendrier partagé',
    'subscribe_to_myq_calendar': 'Liens de calendrier partagés',
    'add_to_calendar': 'Ajoutez un calendrier MyQ à l’un des calendriers suivants :',
    'calendar_link_copied': 'Lien du calendrier copié dans le presse-papiers!',
    'icalendar_instructions': 'Vous pouvez utiliser le lien iCalendar pour ajouter un calendrier MyQ à toute application de calendrier compatible avec le format iCalendar. Copiez simplement le lien et collez-le dans votre application de calendrier, ou cliquez sur l’un des boutons ci-dessus pour l’ajouter directement à votre calendrier préféré.',
    'learn_google': 'En savoir plus sur l’ajout de liens iCalendar à Google Agenda',
    'learn_outlook': 'En savoir plus sur l’ajout de liens iCalendar à Outlook',
    'learn_apple': 'En savoir plus sur l’ajout de liens iCalendar à Calendrier Apple',
    'icalendar_panel_title': 'Comment utiliser un lien iCalendar :',
    'confirm_deletion': 'Confirmer la suppression',
    'confirm_deletion_message': 'Voulez-vous vraiment supprimer l’abonnement au calendrier',
    'confirm_deletion_message_strong': '? Cette action est irréversible.',
    'delete_2': 'Après la suppression de ce calendrier, la connexion sera perdue et il \nne recevra plus les mises à jour du calendrier QSRSoft. Si vous souhaitez supprimer complètement le calendrier partagé, veuillez \nle faire à partir de l’application correspondante (Google, Outlook ou Apple).',
    'calendar_name': 'Nom du calendrier',
    'create_shareable_calendar': 'Créer un lien de calendrier partageable',
    'create_shareable_calendar_2': ' + Ajouter un lien',
    'choose_calendar': 'Choisir un calendrier',
    'this_will_appear_as_the_title_in_your_external_app': 'Ce nom apparaîtra comme titre dans l’application externe',
    'choose_one_or_more_calendars_to_share': 'Choisissez un ou plusieurs calendriers à partager',
    'your_calendar_name': 'Nom de votre calendrier',
    'calendar_name_must_be_at_least_1_character': 'Le nom du calendrier doit comporter au moins 1 caractère',
    'please_select_at_least_one_calendar': 'Veuillez sélectionner au moins un calendrier',
    'shared_calendars_header': 'Liens de calendrier partagés',
    'no_shared_calendars': 'Vous n’avez aucun lien de calendrier partagé.',
    'start_adding_shared_calendars': 'Commencez à en ajouter dans la section « Nouveau lien de calendrier partagé »',
    'or_add_your_calendar': 'Ou ajoutez votre calendrier à l’une des applications de calendrier suivantes :',
    'new_shared_calendar_link': 'Nouveau lien de calendrier partagé',
    'shared_calendar_links': 'Liens de calendrier partagés',
    'continue': 'Continuer',
    'confirm_google_dialog_title': 'Continuer vers Google Agenda',
    'confirm_google_dialog_message': 'Google a récemment modifié le fonctionnement des abonnements aux calendriers. Pour ajouter ce calendrier à Google, vous devrez coller manuellement le lien d’abonnement dans Google Agenda.',
    'confirm_google_dialog_message_strong': 'Nous avons déjà copié le lien pour vous. Cliquez sur le bouton Continuer ci-dessous pour poursuivre. Une fois redirigé, collez le lien dans le champ URL et cliquez sur Ajouter l’agenda.',
    'confirm_google_dialog_message_strong_mobile': 'Nous avons déjà copié le lien pour vous. Cliquez sur le bouton Continuer ci-dessous pour poursuivre. Une fois redirigé, cliquez sur l’icône « + » à côté de Autres agendas dans la barre latérale gauche, sélectionnez À partir de l’URL, collez le lien dans le champ URL, puis cliquez sur Ajouter un agenda',
    'failed_to_get_subscriptions': 'Échec de la récupération des abonnements au calendrier',
    'failed_to_add_subscription': 'Échec de l’ajout de l’abonnement au calendrier',
    'failed_to_edit_subscription': 'Échec de la modification de l’abonnement au calendrier',
    'failed_to_delete_subscription': 'Échec de la suppression de l’abonnement au calendrier',
    'failed_to_copy_link': 'Échec de la copie du lien du calendrier',
    'calendar_name_required': 'Le nom du calendrier est obligatoire',
    'create-ticket': 'Créer un billet',
    'you-do-not-have-permissions-to-view-this-widget': 'Vous n’avez pas la permission de voir ce widget',
    'my-planned-maintenance': 'Mon entretien planifié',
    'error-loading-tasks': 'Erreur de chargement des tâches',
    'tasks-due-by': 'Tâche(s) à échéance le',
    'all-tasks-completed': 'Toutes les tâches sont terminées!',
    'assigned': 'Assignés',
    'time-left': 'Temps restant',
    'my-planned-maintenance-hours': 'h',
    'my-planned-maintenance-past-due': 'En retard',
    'my-planned-maintenance-completed': 'Terminé',
    'my-planned-maintenance-none': 'Aucune',
    'tickets': 'Billets',
    'error-loading-tickets': 'Erreur de chargement des formulaires',
    'in-progress': 'En cours',
    'on-hold': 'En attente',
    'resolved': 'Résolu',
    'my-tickets-none': 'Aucune',
    'planned-maintenance-overview': 'Aperçu de l’entretien planifié',
    'unassigned': 'Non assignées',
    'planned-maintenance-error-loading-tasks': 'Erreur de chargement des tâches',
    'planned-maintenance-assigned': 'Assignés',
    'planned-maintenance-completed': 'Terminé',
    'tickets-overview': 'Aperçu des billets',
    'reported': 'Signalés',
    'accepted': 'Acceptés',
    'tickets-overview-error-loading-tickets': 'Erreur de chargement des billets',
    'favorite-forms': 'Formulaires favoris',
    'error-loading-forms': 'Erreur de chargement des formulaires',
    'forms-favorites-title': 'Formulaires favoris',
    'forms-favorites-your-favorites': 'Vos favoris',
    'forms-favorites-org-favorites': 'Favoris de l’organisation',
    'forms-favorites-available-forms': 'Formulaires disponibles',
    'forms-favorites-current-favorites': 'Favoris actuels',
    'forms-favorites-no-favorites-yet': 'Aucun favori pour le moment',
    'forms-favorites-add-form-hint': 'Sélectionnez un formulaire ci-dessus pour commencer.',
    'forms-favorites-uncategorized': 'Sans catégorie',
    'forms-favorites-unknown-form': 'Formulaire inconnu',
    'forms-favorites-load-error': 'Impossible de charger les favoris pour le moment. Veuillez réessayer.',
    'forms-favorites-save-error': 'Impossible d’enregistrer les modifications. Veuillez réessayer.',
    'shift-forms': 'Formulaires de quart',
    'forms-all': 'Tous',
    'forms-in-progress-2': 'En cours',
    'in-progress-forms': 'Formulaires en cours',
    'workflow-forms': 'Formulaires de flux de travail',
    'too-many-locations-selected': 'Trop d’emplacements sélectionnés. Veuillez sélectionner un seul emplacement.',
    'no-tasks-with-forms': 'Aucune tâche avec formulaires',
    'workflow-forms-error-loading-forms': 'Erreur de chargement des formulaires',
    'task-row-expired': 'Expiré',
    'org-error-message-a': 'Votre organisation n’est actuellement pas abonnée à QSRSoft Premium. Cliquez ',
    'org-error-message-b': ' pour en savoir plus.',
    'select-one_location': 'Veuillez sélectionner un seul emplacement',
    'no-tasks-available': 'Aucune tâche disponible - veuillez communiquer avec votre administrateur système',
    'store-time-zone': 'Fuseau horaire du restaurant',
    'store-hours-gathered': 'Les heures d’ouverture proviennent de vos paramètres RFM',
    'user-error-message': 'Vous n’avez pas l’autorisation d’accéder aux formulaires. Veuillez communiquer avec votre administrateur système.',
    'work-flow-here': 'ICI',
    'work-flow-missing-permissions': 'Autorisations manquantes',
    'Recurrence': 'Récurrence',
    'How often a new instance of a task is due': 'Fréquence à laquelle une nouvelle occurrence de la tâche arrive à échéance',
    'Every': 'Chaque',
    'Date': 'Date',
    'Next 10 Recurrences': '10 prochaines occurrences',
    'Starting at': 'À partir de',
    'Due': 'À échéance',
    'Ending at': 'Se terminant à',
    'Timezone': 'Fuseau horaire',
    'On day': 'Le jour',
    'Day of month': 'Jour du mois',
    'On the': 'Le',
    'Week': 'Semaine',
    'Day': 'Jour',
    'Once': 'Une fois',
    'Minute': 'Minute',
    'Hour': 'Heure',
    'Month': 'Mois',
    'Mon': 'Lun',
    'Tue': 'Mar',
    'Wed': 'Mer',
    'Thu': 'Jeu',
    'Fri': 'Ven',
    'Sat': 'Sam',
    'Sun': 'Dim',
    'First': 'Premier',
    'Second': 'Deuxième',
    'Third': 'Troisième',
    'Fourth': 'Quatrième',
    'Last': 'Précédent',
    'Invalid RRULE': 'RRULE non valide',
    'Does not repeat': 'Ne se répète pas',
    'AM': 'AM',
    'PM': 'PM',
    'oepe-trends': 'Tendances OEPE',
    'kvs-projections': 'Prévisions KVS',
    'gc-projections': 'Prévisions NC',
    'insights-container-open-late-close-early': 'Ouverture tardive et fermeture hâtive',
    'stores-with-alerts': '{count} restaurant(s) avec alertes actives',
    'stores-with-alerts-suffix': 'restaurant(s) avec alertes actives',
    'total-errors': '{count} erreur(s) active(s) au total',
    'total-errors-suffix': 'erreur(s) active(s) au total',
    'bdc-stores-missing-prefix': 'restaurant auquel il manque au moins une | restaurants auxquels il manque au moins une',
    'instore-events-insight-old-missing-bdc': 'restaurant auquel il manque au moins une | restaurants auxquels il manque au moins une',
    'message': 'Message',
    'severity': 'Gravité',
    'timestamp': 'Horodatage',
    'error': 'Erreur',
    'warning': 'Avertissement',
    'instore-events-more-info-info': 'Info',
    'number-of-bdc-missing': 'Nb de BDC manquants',
    'merged-alerts-more-info-business-date': 'Date(s) d’exploitation',
    'merged-alerts-more-info-info': 'Info',
    'merged-alerts-more-info-more-info': 'Plus de renseignements',
    'guest-counts-are': 'L’achalandage est',
    'or-more-above': 'ou plus au-dessus des prévisions au cours des 2 dernières heures',
    'or-more-below': 'ou plus en dessous des prévisions au cours des 2 dernières heures',
    'consider-reviewing': 'Envisagez de revoir la dotation et l’affectation aux postes',
    'gc-projections-threshold': 'NC - Seuil des prévisions',
    'lower-limit': 'Limite inférieure',
    'upper-limit': 'Limite supérieure',
    'bdc-grid-business-date': 'Date(s) d’exploitation',
    'upcoming-kvs-projected-items': 'À venir, les articles KVS prévus dépassent',
    'in-next-15-minutes': 'dans les 15 prochaines minutes avec un seul côté ouvert.',
    'kvs-stores-projected-items-are-above': '{count} restaurants ont des articles KVS prévus supérieurs à',
    'kvs-store-projected-items-are-above': 'Les articles KVS prévus de {store} dépassent',
    'consider-2nd-side-opening': 'Envisagez d’ouvrir le 2e côté',
    'breakfast-threshold': 'Seuil du déjeuner',
    'threshold': 'Seuil',
    'kvs-threshold-settings-items': 'Articles',
    'labor-date': 'Date de travail',
    'act-start': 'Début réel',
    'act-end': 'Fin réelle',
    'sch-start': 'Début prévu',
    'sch-end': 'Fin prévue',
    'act-shift-length': 'Durée réelle du quart',
    'exception': 'Exception',
    'exception-time': 'Heure de l’exception',
    'is-manager-authorized': 'Autorisé par un gérant',
    'punches-1': 'Poinçons 1',
    'punches-2': 'Poinçons 2',
    'punches-3': 'Poinçons 3',
    'punches-4': 'Poinçons 4',
    'punches-5': 'Poinçons 5',
    'punches-6': 'Poinçons 6',
    'there-were': 'Il y a eu',
    'exceptions-on-minor-employees': 'exceptions visant des employés mineurs',
    'minutes': 'Minutes',
    'days-missed-limit': 'La limite de jours manqués peut être ajustée dans les paramètres des analyses.',
    'filter-open-late-msg': '** Affichage des restaurants ayant ouvert en retard plus souvent que la limite de jours manqués ({days} jours) lors des 7 dernières ouvertures.',
    'filter-close-early-msg': '** Affichage des restaurants ayant fermé hâtivement plus souvent que la limite de jours manqués ({days} jours) lors des 7 dernières fermetures.',
    'olce-grid-open-late-close-early': 'Ouverture tardive et fermeture hâtive',
    'olce-grid-filter': 'Filtre',
    'olce-grid-open-late': 'Ouverture tardive',
    'olce-grid-close-early': 'Fermeture hâtive',
    'may-have': 'avec possiblement',
    'late-opens': 'ouvertures tardives ou plus au cours des 7 derniers jours.',
    'early-closes': 'fermetures hâtives ou plus au cours des 7 derniers jours.',
    'olce-insight-open-late-close-early': 'Ouverture tardive et fermeture hâtive',
    'olce-insight-store': 'restaurant',
    'days-missed': 'Jours manqués',
    'ot-threshold-setting-hours': 'Heures',
    'employees-on-track': 'employés sont en voie de travailler plus de',
    'hours-this-week': 'heures cette semaine.',
    'you-currently-have': 'Vous avez actuellement',
    'items-out': 'articles en rupture au cours des',
    'product-outage-insight-days': 'jours.',
    'product-outage-insight-product-outage': 'Rupture de produit',
    'active-product-outages': 'Ruptures de produit actives',
    'thirty-day-terms': 'Cessations à 30 jours',
    'ninety-day-terms': 'Cessations à 90 jours',
    'crew-type': 'Type d’équipier',
    'hire': 'Embauche',
    'termination': 'Cessation d’emploi',
    'merged-terms-more-info-more-info': 'Plus de renseignements',
    'crew-termed-in-the-first': 'cessations d’emploi d’équipiers au cours des',
    'days-since-hire': 'premiers jours suivant l’embauche',
    'no-30-day-terms': 'Aucune cessation d’emploi d’équipier au cours des 30 premiers jours suivant l’embauche.',
    'your-ninety-day-turnover-is-over': 'Le roulement dépasse',
    'with': 'avec',
    'crew-terminated-within': 'cessations d’emploi d’équipiers au cours des',
    'you-have': 'Vous avez',
    's': 's',
    'with-90-day-turnover-above': 'dont le roulement à 90 jours dépasse',
    'no-90-day-terms': 'Aucun emplacement au-dessus du seuil de roulement à 90 jours.',
    'people-terms-insight-thirty-day-terms': '30 jours',
    'people-terms-insight-ninety-day-terms': '90 jours',
    'people-terms-insight-location': 'emplacement',
    'seconds': 'Secondes',
    'your-oepe-no-park': 'Votre OEPE sans stationnement a augmenté de',
    'seconds-from-the-weekly-trend': 'secondes par rapport à la tendance hebdomadaire.',
    'consider-parking-cars': 'Envisagez de stationner des voitures',
    'drawers-with-suspicious-activities': 'cas',
    'please-subscribe': 'Veuillez vous abonner',
    'please-subscribe-verbiage': 'Abonnez-vous à Sécurité pour voir toutes les instances d\'activité suspecte',
    'learn-more': 'En savoir plus',
    'suspicious-activity-insight-suspicious-activity': 'Activité Suspecte',
    'shared-link-settings': 'Paramètres des liens partagés',
    'add-link': 'Ajouter un lien',
    'there-are-currently-no-third-party-links': 'Il n’y a actuellement aucun lien tiers',
    'label-cannot-be-blank': 'L’étiquette ne peut pas être vide',
    'url-cannot-be-blank': 'L’URL ne peut pas être vide',
    'links-settings-label': 'Étiquette',
    'loading': 'Chargement...',
    'no-shared-links-have-been-added': 'Aucun lien partagé n\'a été ajouté pour votre organisation.',
    'daily-activity': 'Activité quotidienne',
    'the-three-week-trend-is-calculated': 'La tendance sur 3 semaines est calculée à partir de la moyenne des 3 dernières semaines pour le même jour de la semaine.',
    'three-week-trend': 'Tendance sur 3 semaines',
    'pivot-table': 'Tableau croisé dynamique',
    'show-all-qtr-hrs': 'Afficher tous les quarts d’heure',
    'dar-settings-row-settings': 'Paramètres des rangées',
    'goal-settings': 'Paramètres des objectifs',
    'percent-to-improve': '% à améliorer',
    'driveThruHME': 'Service au volant HME',
    'numbers-indicate-employee-hours-this-week': 'Les nombres indiquent les heures des employés cette semaine - heures travaillées plus heures restantes à l’horaire. Les rangées surlignées correspondent à des mineurs.',
    'please-select-only-one-location': 'Veuillez sélectionner un seul emplacement',
    'no-data-available': 'Aucune donnée disponible',
    'not-scheduled': 'Non planifié',
    'employee-roster-error-loading': 'Erreur de chargement',
    'expandable-search-search': 'Rechercher...',
    'roster-filter-job-title-code': 'Code de titre d’emploi',
    'working-today': 'Au travail aujourd’hui',
    'working': 'AU TRAVAIL',
    'scheduled-employees-error-loading': 'Erreur de chargement',
    'scheduled-employees-upcoming': 'À VENIR',
    'select-locations': 'Sélectionnez un ou plusieurs emplacements',
    'at-least-one-location-required': 'Au moins un emplacement est requis',
    'location-selector-locations': 'Emplacements',
    'task-list': 'Liste des tâches',
    'failed-to-load-tasks': 'Échec du chargement des tâches',
    'new-task': 'Nouvelle tâche',
    'description-required': 'Description requise',
    'max-140-characters': 'Maximum 140 caractères',
    'complete-task': 'Terminer la tâche?',
    'this-task-will-be-archived-and-removed': 'Cette tâche sera archivée et retirée de la liste du restaurant. Continuer?',
    'Today': 'Aujourd’hui',
    'All': 'Tous',
    'task-list-no-tasks-available': 'Aucune tâche disponible',
    'task-list-complete': 'Terminer',
    // Migrated from <i18n> SFC blocks (#6500)
    'trading-day': 'Jour d’exploitation',
    'calendar-day': 'Jour civil',
    'create-scorecard': 'Créer une fiche de rendement',
    'max-scorecards': 'Nombre maximal de fiches de rendement atteint',
    'name-assign': 'Nommer et assigner',
    'select-metrics': 'Sélectionner les indicateurs',
    'set-goals': 'Définir les objectifs',
    'qsr-defaults': 'Valeurs par défaut QSR',
    'defaults': 'Valeurs par défaut',
    'click-cells-to-edit': 'Cliquez sur les cellules pour les modifier comme dans Excel',
    'scorecard-settings': 'Paramètres de la fiche de rendement',
    'goals': 'Objectifs',
    'score-card-container-settings-scorecards': 'Fiches de rendement',
    'score-card-settings-are-you-sure': 'Voulez-vous vraiment supprimer cette fiche de rendement?',
    'score-card-settings-scorecard-settings': 'Paramètres de la fiche de rendement',
    'score-card-settings-settings': 'Paramètres',
    'score-card-settings-delete-scorecard': 'Supprimer la fiche de rendement',
    'products-selected': 'produits sélectionnés',
    'menu-items': 'Articles du menu',
    'watchlists': 'Listes de surveillance',
    'pmix-settings': 'Paramètres PMIX',
    'columns': 'Colonnes',
    'products': 'Produits',
    'today-container-today': 'Aujourd’hui (ancienne version)',
    // Migrated from <i18n> SFC blocks (#6500)
    'preview-mode': 'Mode aperçu',
    'preview-mode-subtitle': 'Vérification des modifications non enregistrées. Enregistrez pour les conserver ou ignorez-les pour revenir en arrière.',
    'exit-preview': 'Quitter l’aperçu',
    dashboard: 'Tableau de bord',
    widget: 'Widget',
    shiftRunner: 'Chef de quart',
    insights: 'Analyses',
    due: 'À échéance',
    expired: 'Expiré',
    upcoming: 'À venir',
    completed: 'Terminé',
    learnMore: 'En savoir plus',
    pleaseSubscribe: 'Veuillez vous abonner',
    // CreateDashboard
    'create-dashboard': 'Créer un tableau de bord',
    name: 'Nom',
    roles: 'Rôles',
    'starting-point': 'Point de départ',
    'name-description':
      'Choisissez un nom pour votre tableau de bord. Les utilisateurs verront ce nom dans le sélecteur.',
    'roles-description':
      'Sélectionnez les rôles pour votre tableau de bord. Les utilisateurs à qui ces rôles sont attribués pourront le voir et le choisir.',
    'starting-point-description':
      'Choisissez un point de départ. Vous pouvez partir d’un tableau de bord QSRSoft, d’un autre tableau de bord que vous avez créé ou d’une page vierge.',
    cancel: 'Annuler',
    back: 'Retour',
    next: 'Suivant',
    preview: 'Aperçu',
    'name-required': 'Le nom est obligatoire',
    'name-exists': 'Un tableau de bord portant ce nom existe déjà',
    'roles-required': 'Les rôles sont obligatoires',
    'blank-canvas': 'Page vierge',
    'qsr-presets': 'Préréglages QSR',
    'your-saved-dashboards': 'Vos tableaux de bord enregistrés',
    // ResetDashboard
    'reset-dashboard': 'Réinitialiser le tableau de bord',
    'reset-description':
      'Choisissez le point de départ vers lequel réinitialiser le tableau de bord sélectionné. Vous pouvez choisir un tableau de bord QSRSoft ou une page vierge. Après avoir choisi un point de départ, cliquez sur Enregistrer pour appliquer les modifications.',
    // Settings
    'widget-settings': 'Paramètres du widget',
    'row-settings': 'Paramètres des rangées',
    'column-settings': 'Paramètres des colonnes',
    close: 'Fermer',
    save: 'Enregistrer',
    // DashboardContainerSettingsMulti
    customizeDashboardContainers: 'Personnaliser les conteneurs du tableau de bord',
    unableToSaveSettings: 'Impossible d’enregistrer les paramètres du tableau de bord.',
    unableToResetSettings: 'Impossible de rétablir les paramètres par défaut du tableau de bord.',
    // no_favorites_card
    noShortcuts: 'Vous n’avez aucun raccourci de dossier ou de fichier.',
    add: 'Ajouter',
    // Shared
    moreInfo: 'Plus de renseignements',
    noData: 'Aucune donnée',
    loadError: 'Impossible de charger les données',
    actual: 'Réel',
    current: 'En cours',
    // BudgetWidget
    budget: 'Budget',
    fiscalPeriod: 'Période financière',
    vsBudget: 'C. budget',
    // FoodWidget
    food: 'Aliments',
    week: 'Semaine',
    // TextSettings
    bulletinBoardSettings: 'Paramètres du babillard',
    addText: 'Ajouter du texte',
    isLink: 'est un lien',
    url: 'URL',
    text: 'Texte',
    // BUSalesRankPopUp
    oneYearComp: 'Comparaison 1 an',
    twoYearComp: 'Comparaison 2 ans',
    // VoiceSmiley
    voice: 'VOICE',
    surveys: 'Sondages',
    numSurveys: 'Nb de sondages',
    voiceInfoText:
      'Les données sont reçues 2 jours après SMG et regroupées selon la date de visite du client. SMG utilise par défaut la date du sondage. En raison de ces différences, il ne faut <strong>pas</strong> s’attendre à ce que les deux sources concordent.',
    // SmileySettings
    metric: 'Indicateur',
    all: 'Tous',
    metrics: 'Indicateurs',
    differentThresholds: 'Les indicateurs sélectionnés ont des seuils différents.',
    orSelectFewer: 'ou sélectionnez moins d’indicateurs.',
    groupedMetrics: 'Voici les indicateurs regroupés :',
    group: 'Groupe',
    happyUpper: 'satisfait - borne supérieure',
    happyLower: 'satisfait - borne inférieure',
    neutralLower: 'neutre - borne inférieure',
    // RMHC / Round Up
    roundUp: 'Arrondi pour la cause',
    helpingHands: 'Helping Hands',
    mtdDollar: 'CMJ $',
    mtdCount: 'Nombre CMJ',
    progressGoal: 'Progression / objectif',
    pctToGoal: '% de l’objectif atteint :',
    goalsHit: 'Objectifs atteints :',
    orgSettingsChanging: 'Modification des paramètres de l’organisation',
    orgSettingsConfirm:
      'Vous êtes sur le point de modifier des paramètres au niveau de l’organisation. Voulez-vous continuer?',
    no: 'Non',
    donationDollar: 'Don $',
    donationCount: 'Nombre de dons',
    goal: 'Objectif',
    numOfDonations: 'Nb de dons',
    donationsDollar: 'Dons $',
    donationsCountGoal: 'Objectif de nombre de dons',
    donationsDollarGoal: 'Objectif de dons $',
    pctOfGoal: '% de l’objectif',
    // Voice row labels
    voiceOverall: 'Global',
    beNice: 'Amabilité',
    beFast: 'Rapidité',
    quality: 'Qualité',
    clean: 'Propreté',
    accuracy: 'Exactitude',
    // VoiceContainer
    customerFeedbackAndDonations: 'Commentaires des clients et dons',
    // BigArch / Incentives
    bigArch: 'Big Arch',
    'hot-honey': 'Hot Honey',
    'snack-wraps': 'Snack Wraps',
    // Shared incentive keys
    'incentive-rank-out-of': 'Classement sur',
    'incentive-restaurants': 'Restaurants',
    'incentive-rank': 'Classement',
    'incentive-rank-compared': 'Classement du restaurant par rapport à l’ensemble de l’unité d’affaires',
    'incentive-units-1k-gc': 'Unités/1 000 NC',
    'incentive-units-1k-rod-gc': 'Unités/1 000 NC ROD',
    // BigArchWidget
    'big-arch-units': 'Unités Big Arch',
    'big-arch-sold-related':
      'Nombre d’articles du menu liés à Big Arch vendus pendant le reste de la journée (ROD) par millier d’unités.',
    'big-arch-menu-items':
      'Les articles du menu associés sont les 25442, 25443 et 25444',
    // HotHoneyWidget
    'hot-honey-units': 'Unités Hot Honey',
    'hot-honey-sold-related':
      'Nombre d’articles du menu liés à Hot Honey vendus pendant le reste de la journée (ROD) par millier d’unités.',
    // SnackWrapsWidget
    'wrap-units': 'Unités Wrap',
    'snack-wraps-message':
      'Les Snack Wraps sont désormais déclarés ici comme des articles individuels',
    'snack-wraps-sold-related':
      'Nombre d’articles du menu liés aux Wraps vendus pendant le reste de la journée (ROD) par millier d’unités.',
    // IncentiveContainer
    leaderboard: 'Classement',
    'mccrispy-strips': 'McCrispy Strips',
    'round-up-pos': 'Arrondi pour la cause PDV/employé',
    '3d-gc-incentive': 'Programme incitatif achalandage 3D',
    'default-incentives': 'Programmes incitatifs par défaut',
    'new-beverage': 'Nouveaux breuvages',
    // BUGrid
    org: 'Organisation',
    orgVs: 'Organisation c.',
    // BusinessUnitContainer
    comp: 'Comparaison',
    sales: 'Ventes',
    service: 'Service',
    labor: 'Main-d’œuvre',
    'digital-app': 'Application mobile',
    'addon-subscribed': 'Module complémentaire BU · Abonné',
    'addon-upgrade': 'Module complémentaire BU · Mise à niveau',
    'addon-upgrade-tooltip':
      'Parlez à votre responsable de l’unité d’affaires de l’ajout de l’Abonnement de l’Unité d’Affaires pour obtenir une visibilité sur les vues de Comparaison de l’unité d’affaires',
    'bu-no-visibility':
      'Vous n’avez pas accès à la vue Comparaison de l’unité d’affaires pour une ou plusieurs des raisons suivantes :',
    'bu-app-backgrounded':
      'Sur mobile, l’application est restée trop longtemps en arrière-plan. Si c’est le cas, veuillez quitter et redémarrer l’application.',
    'bu-no-subscription':
      'Votre unité d’affaires n’est pas abonnée au produit BU Data & Analytics',
    'bu-opted-out':
      'Vous avez « refusé » le partage de données de l’unité d’affaires dans l’administration MyQSRSoft.',
    'bu-contact-leadership':
      'Veuillez communiquer avec la direction de votre unité d’affaires pour toute question sur l’abonnement et les vues de rapports associées.',
    // BUCompTypeSelector
    'comp-calendar': 'Calendrier',
    'comp-trading': 'Exercice commercial',
    'comp-same-store': 'Restaurants comparables',
    'comp-all-store': 'Tous les restaurants',
    // BUSales tooltip
    'bu-financial-info':
      'Le mode Financier s’applique au mois en cours ou aux plages de dates qui dépassent les mois complétés. Il exclut les emplacements ouverts depuis moins de 13 mois complets. Par défaut, le mode Financier utilise la comparaison par jour d’exploitation.',
    'bu-analytic-info':
      'Le mode Analytique s’applique aux mois complétés et aux plages de dates qui comprennent des mois complétés. Il applique une règle de 5 jours : si un emplacement n’a aucune vente pendant 5 jours ou plus (année en cours ou année précédente), il est exclu du calcul. Par défaut, le mode Analytique utilise la comparaison par jour civil.',
    'bu-financial-info-rank':
      'Le mode Financier s’applique au mois en cours ou aux plages de dates qui dépassent les mois complétés. Il exclut les emplacements ouverts depuis moins de 13 mois complets. Par défaut, comparaison par jour d’exploitation.',
    'bu-analytic-info-rank':
      'Le mode Analytique s’applique aux mois complétés et aux plages de dates qui comprennent des mois complétés. Il applique une règle de 5 jours : si un emplacement n’a aucune vente pendant 5 jours ou plus (année en cours ou année précédente), il est exclu du calcul. Par défaut, comparaison par jour civil.',
    // BUSales rows
    'bu-row-sales': 'Ventes',
    'bu-row-gcs': 'NC',
    'bu-row-avg-sales': 'Ventes moyennes',
    'bu-row-avg-check': 'Facture moyenne',
    'bu-row-avg-check-diff': 'Facture moyenne +/-',
    'bu-row-avg-check-diff-pct': 'Facture moyenne +/- %',
    'bu-row-bfast-gcrd': 'NC/R/J déjeuner',
    'bu-row-bfast-gcrd-diff': 'NC/R/J déjeuner +/-',
    'bu-row-bfast-pct-sales': '% des ventes du déjeuner',
    'bu-row-mcdelivery-avg-check': 'Facture moyenne McDelivery',
    'bu-row-mcdelivery-gcrd': 'NC/R/J McDelivery',
    'bu-row-mcdelivery-gcrd-diff': 'NC/R/J McDelivery +/-',
    'bu-row-gma-del-avg-check': 'Facture moyenne livraison GMA',
    'bu-row-gma-del-gcrd-diff': 'NC/R/J livraison GMA +/-',
    'bu-row-3po-avg-check': 'Facture moyenne 3PO',
    'bu-row-3po-gcrd-diff': 'NC/R/J 3PO +/-',
    'bu-row-dt-pct-sales': '% des ventes totales au service au volant',
    'bu-row-dt-gcrd': 'NC/R/J service au volant',
    'bu-row-dt-gcrd-diff': 'NC/R/J service au volant +/-',
    // BUPeaksService format info tooltip
    'bu-peaks-timeslice-label': 'Créneau horaire',
    'bu-peaks-show-details': 'Afficher les détails',
    'bu-peaks-comp-short-same': 'Comparables',
    'bu-peaks-comp-short-all': 'Tous',
    'bu-peaks-comp-basis': 'Base de comparaison. Comparables : ne compte que les jours-restaurant présents les deux années. Tous : compte tous les jours-restaurant.',
    'bu-peaks-format-info-diff': "Les valeurs par défaut affichent l'écart relatif par rapport à votre BU",
    'bu-peaks-format-info-detail': 'Activez « Afficher les détails » pour afficher les valeurs brutes BU et Org de chaque indicateur',
    // BUService rows
    'bu-row-oepe-no-park': 'OEPE sans stationnement',
    'bu-row-oepe-no-park-diff': 'OEPE sans stationnement +/-',
    'bu-row-oepe': 'OEPE',
    'bu-row-oepe-diff': 'OEPE +/-',
    'bu-row-r2p': 'R2P',
    'bu-row-r2p-diff': 'R2P +/-',
    'bu-row-avg-ctp': 'CTP moyen',
    'bu-row-avg-ctp-diff': 'CTP moyen +/-',
    'bu-row-kvs-items-gc': 'Articles KVS / NC',
    'bu-row-kvs-items-gc-diff': 'Articles KVS / NC +/-',
    'bu-row-kvs-time-gc': 'Temps KVS / NC',
    'bu-row-kvs-time-gc-diff': 'Temps KVS / NC +/-',
    'bu-row-dt-pulled-fwd': '% devancés au service au volant',
    'bu-row-dt-pulled-fwd-diff': '% devancés au service au volant +/-',
    'bu-row-healthy-use': 'Utilisation saine',
    'bu-row-healthy-use-diff': 'Utilisation saine +/-',
    'bu-row-sales-r-d': 'Ventes/R/J',
    'bu-row-sales-r-d-diff': 'Ventes/R/J +/- %',
    'bu-row-gc-r-d': 'NC/R/J',
    'bu-row-gc-r-d-diff': 'NC/R/J +/- %',
    'bu-row-dt-sales-r-d': 'Ventes/R/J service au volant',
    'bu-row-dt-sales-r-d-diff': 'Ventes/R/J service au volant +/- %',
    'bu-row-fc-sales-r-d': 'Ventes/R/J comptoir',
    'bu-row-fc-sales-r-d-diff': 'Ventes/R/J comptoir +/- %',
    'bu-row-fc-gc-r-d': 'NC/R/J comptoir',
    'bu-row-fc-gc-r-d-diff': 'NC/R/J comptoir +/- %',
    'bu-row-kiosk-sales-r-d': 'Ventes/R/J borne',
    'bu-row-kiosk-sales-r-d-diff': 'Ventes/R/J borne +/- %',
    'bu-row-kiosk-gc-r-d': 'NC/R/J borne',
    'bu-row-kiosk-gc-r-d-diff': 'NC/R/J borne +/- %',
    'bu-row-moa-sales-r-d': 'Ventes/R/J MOA',
    'bu-row-moa-sales-r-d-diff': 'Ventes/R/J MOA +/- %',
    'bu-row-moa-gc-r-d': 'NC/R/J MOA',
    'bu-row-moa-gc-r-d-diff': 'NC/R/J MOA +/- %',
    'bu-row-delivery-sales-r-d': 'Ventes/R/J livraison',
    'bu-row-delivery-sales-r-d-diff': 'Ventes/R/J livraison +/- %',
    'bu-row-delivery-gc-r-d': 'NC/R/J livraison',
    'bu-row-delivery-gc-r-d-diff': 'NC/R/J livraison +/- %',
    'bu-row-dt-avg-check': 'Facture moyenne service au volant',
    'bu-row-dt-avg-check-diff': 'Facture moyenne service au volant +/-',
    'bu-row-fc-avg-check': 'Facture moyenne comptoir',
    'bu-row-fc-avg-check-diff': 'Facture moyenne comptoir +/-',
    'bu-row-kiosk-avg-check': 'Facture moyenne borne',
    'bu-row-kiosk-avg-check-diff': 'Facture moyenne borne +/-',
    'bu-row-moa-avg-check': 'Facture moyenne MOA',
    'bu-row-moa-avg-check-diff': 'Facture moyenne MOA +/-',
    'bu-row-delivery-avg-check': 'Facture moyenne livraison',
    'bu-row-delivery-avg-check-diff': 'Facture moyenne livraison +/-',
    'bu-digital-customer-count': 'Nombre de clients numériques',
    'bu-row-dt-gcrd-diff-pct': 'NC/R/J service au volant +/- %',
    'bu-row-avg-check-short': 'Facture moyenne',
    'bu-row-avg-check-short-diff': 'Facture moyenne +/-',
    // BULabor rows
    'bu-row-crew-labor': '% main-d’œuvre équipiers',
    'bu-row-actual-labor': '% main-d’œuvre réelle',
    'bu-row-avg-rate': 'Taux moyen',
    'bu-row-tpph': 'TPPH',
    'bu-row-total-labor': '% main-d’œuvre totale',
    // BUFood rows
    'bu-row-base-food': '% aliments de base',
    'bu-row-comp-waste': '% pertes produits finis',
    'bu-row-condiments': '% condiments',
    'bu-row-discount': '% rabais',
    'bu-row-emp-meals': '% repas employés',
    'bu-row-fob': '% FOB',
    'bu-row-raw-waste': '% pertes brutes',
    'bu-row-stat-var': '% écart statistique',
    'bu-row-unexplained': '% inexpliqué',
    'bu-row-pnl-food-cost': '% coût des aliments (profits et pertes)',
    'bu-row-pnl-paper-cost': '% coût du papier (profits et pertes)',
    // BUDigitalApp rows
    'bu-row-digital-sales': '% ventes numériques',
    'bu-row-digital-gc': '% NC numérique',
    'bu-row-digital-avg-check': 'Facture moyenne numérique',
    'bu-row-digital-grd': 'G/R/J numérique',
    'bu-row-scanned-offer-sales': 'Ventes offres numérisées',
    'bu-row-scanned-offer-gcs': 'NC offres numérisées',
    'bu-row-scanned-offer-avg-check': 'Facture moyenne offres numérisées',
    'bu-row-scanned-offer-grd': 'G/R/J offres numérisées',
    'bu-row-gma-delivery-sales': 'Ventes livraison GMA',
    'bu-row-gma-delivery-gcs': 'NC livraison GMA',
    'bu-row-gma-delivery-avg-check': 'Facture moyenne livraison GMA',
    'bu-row-gma-delivery-grd': 'G/R/J livraison GMA',
    'bu-row-loyalty-sales': 'Ventes auto-identification fidélité',
    'bu-row-loyalty-gcs': 'NC auto-identification fidélité',
    'bu-row-loyalty-avg-check': 'Facture moyenne auto-identification fidélité',
    'bu-row-loyalty-grd': 'G/R/J auto-identification fidélité',
    'bu-row-mop-offer-sales': 'Ventes MOP avec offre',
    'bu-row-mop-offer-gcs': 'NC MOP avec offre',
    'bu-row-mop-offer-avg-check': 'Facture moyenne MOP avec offre',
    'bu-row-mop-offer-grd': 'G/R/J MOP avec offre',
    'bu-row-mop-no-offer-sales': 'Ventes MOP sans offre',
    'bu-row-mop-no-offer-gcs': 'NC MOP sans offre',
    'bu-row-mop-no-offer-avg-check': 'Facture moyenne MOP sans offre',
    'bu-row-mop-no-offer-grd': 'G/R/J MOP sans offre',
    'bu-row-mop-curb-gcs': '% NC MOP ramassage en bordure',
    'bu-row-mop-fc-gcs': '% NC MOP comptoir',
    'bu-row-mop-table-gcs': '% NC MOP à la table',
    'bu-row-mop-dt-gcs': '% NC MOP service au volant',
    // BUVoice rows
    'bu-row-overall': '% global',
    'bu-row-friendliness': '% amabilité',
    'bu-row-fast': '% rapidité',
    'bu-row-quality': '% qualité',
    'bu-row-cleanliness': '% propreté',
    'bu-row-accuracy': '% exactitude',
    'bu-row-dt-overall': '% global service au volant',
    'bu-row-dt-friendliness': '% amabilité service au volant',
    'bu-row-dt-fast': '% rapidité service au volant',
    'bu-row-dt-quality': '% qualité service au volant',
    'bu-row-dt-cleanliness': '% propreté service au volant',
    'bu-row-dt-accuracy': '% exactitude service au volant',
    'bu-row-fc-overall': '% global comptoir',
    'bu-row-fc-friendliness': '% amabilité comptoir',
    'bu-row-fc-fast': '% rapidité comptoir',
    'bu-row-fc-quality': '% qualité comptoir',
    'bu-row-fc-cleanliness': '% propreté comptoir',
    'bu-row-fc-accuracy': '% exactitude comptoir',
    // BUTurnover rows
    'bu-row-crew-mth-ann-turnover': 'Roulement mens. ann. équipiers',
    'bu-row-crew-3mo-turnover': 'Roulement équipiers sur 3 mois',
    'bu-row-crew-term': 'Cessations équipiers',
    'bu-row-avg-crew-hire': 'Embauches moy. équipiers',
    'bu-row-crew-roster': 'Liste des équipiers',
    'bu-row-crew-ttm-turnover': 'Roulement TTM équipiers',
    'bu-row-crew-ytd-turnover': 'Roulement cumulé annuel équipiers',
    'bu-row-shift-mth-ann-turnover': 'Roulement mens. ann. gérants de quart',
    'bu-row-shift-3mo-turnover': 'Roulement gérants de quart sur 3 mois',
    'bu-row-shift-term': 'Cessations gérants de quart',
    'bu-row-avg-shift-hire': 'Embauches moy. gérants de quart',
    'bu-row-shift-roster': 'Liste des gérants de quart',
    'bu-row-shift-ttm-turnover': 'Roulement TTM gérants de quart',
    'bu-row-shift-ytd-turnover': 'Roulement cumulé annuel gérants de quart',
    // BUDigitalOrderPts rows
    'bu-row-dop-digital-gc': '% NC numérique',
    'bu-row-dop-digital-sales': '% ventes numériques',
    'bu-row-dop-digital-grd': 'G/R/J numérique',
    'bu-row-dop-mop-gcs': '% NC MOP',
    'bu-row-dop-mop-sales': '% ventes MOP',
    'bu-row-dop-mop-gcrd': 'NC/R/J MOP',
    'bu-row-dop-gma-del-gc': '% NC livraison GMA',
    'bu-row-dop-gma-del-sales': '% ventes livraison GMA',
    'bu-row-dop-gma-del-grd': 'G/R/J livraison GMA',
    'bu-row-dop-kiosk-gc': '% NC borne',
    'bu-row-dop-kiosk-sales': '% ventes borne',
    'bu-row-dop-kiosk-grd': 'G/R/J borne',
    'bu-row-dop-delivery-gc': '% NC livraison',
    'bu-row-dop-delivery-sales': '% ventes livraison',
    'bu-row-dop-delivery-grd': 'G/R/J livraison',
    // BUDateRange
    'start-date': 'Date de début',
    'end-date': 'Date de fin',
    // BUSalesRankPopUp
    'bu-sales': 'Ventes de l’unité d’affaires',
    rankings: 'Classements',
    'custom-date-range-bu': 'Plage de dates personnalisée',
    thru: 'Au',
    // BUDigitalApp
    'fo-disclaimer':
      'Les résultats de ventes FO sont affichés après la publication trimestrielle des ventes de McDonald’s.',
    // BUVoice
    'voice-rankings': 'Classements Voice',
    'bu-comp-type-disclaimer':
      'Ce widget n’est offert que pour les types de comparaison Unité d’affaires et Bureau régional.',
    'voice-data-behind':
      'Les données Voice accusent habituellement 2 jours de retard. Veuillez sélectionner une plage de dates antérieure',
    // BUTurnover
    people: 'Ressources humaines',
    'people-metrics-full-months':
      'Les indicateurs RH sont calculés à partir de mois complets.',
    'people-multiple-months':
      'Si plusieurs mois sont sélectionnés, le mois complet le plus récent est utilisé.',
    'people-partial-month':
      'Si un mois passé est partiellement sélectionné, le mois complet est utilisé.',
    'people-detailed-breakdown':
      'Pour une ventilation détaillée, consultez le rapport BU Rank.',
    'people-requires-full-month': 'Les données RH exigent une plage de dates couvrant un mois complet',
    // BUDigitalOrderPts
    'digital-order-pts': 'Points de commande numériques',
    // BUAppTrends
    'bu-loyalty-trend': 'Tendance des membres fidélité actifs sur 90 jours de l’unité d’affaires',
    'bu-loyalty-tooltip':
      'Nombre de clients uniques ayant enregistré au moins un NC par l’application mobile durant la période de 90 jours. Comme un client peut fréquenter plus d’un restaurant d’une même organisation, ce nombre ne peut pas être additionné d’un restaurant à l’autre.',
    // Consulting
    qsrsoftConsultingServices: 'Services-conseils QSRSoft',
    consultingHelpsCapture:
      'Les services-conseils QSRSoft aident à saisir les occasions liées aux flux de trésorerie',
    cashflowOpportunity: 'Occasion liée aux flux de trésorerie',
    total: 'Total',
    laborPotentialCF: 'Flux de trésorerie potentiel - main-d’œuvre',
    fobPotentialCF: 'Flux de trésorerie potentiel - FOB',
    buGCGapPotentialCF: 'Flux de trésorerie potentiel - écart de NC de l’unité d’affaires',
    // File Manager
    resourceLibrary: 'Bibliothèque de ressources',
    // Calendar
    calendar: 'Calendrier',
    all_roles: 'Tous les rôles',
    'cal-role-crew': 'Équipiers',
    'cal-role-shift-manager': 'Gérant de quart',
    'cal-role-department-manager': 'Gérant de département',
    'cal-role-general-manager': 'Directeur général',
    'cal-role-mid-manager': 'Cadre intermédiaire',
    'cal-role-owner-operator': 'Propriétaire exploitant',
    'cal-role-system-administrators': 'Administrateurs système',
    organization_calendar: 'Calendrier de l’organisation',
    'cal-days': 'Jours',
    'cal-pick-a-day': 'Choisir un jour',
    'cal-new-event': 'Nouvel événement',
    'cal-open-calendar': 'Ouvrir le calendrier',
    'cal-open-day': 'Ouvrir le jour',
    'mc-open-report': 'Ouvrir le rapport',
    'mc-updated-at': 'Mis à jour {time}',
    'mc-refresh': 'Actualiser',
    'mc-goals-hit': '{hit} objectifs sur {total}',
    'mc-goals-short': '{hit} / {total}',
    'mc-actual': 'Réel',
    'mc-goal': 'Objectif',
    'mc-diff': 'Écart',
    'mc-dayparts': 'Plages horaires',
    'mc-peaks': 'Pics',
    'mc-custom-range': 'Plage de dates personnalisée',
    'mc-previous-period': 'Période précédente',
    'mc-next-period': 'Période suivante',
    'mc-rank-stores': 'Classer les restaurants',
    'mc-new-scorecard': 'Nouvelle fiche de résultats',
    'mc-trend': 'Tendance',
    'mc-metric': 'Mesure',
    'mc-item': 'Article',
    'cal-options': 'Options du calendrier',
    'cal-shared-links': 'Liens de calendrier partagés',
    'cal-yesterday': 'Hier',
    'cal-today': 'Aujourd’hui',
    'cal-tomorrow': 'Demain',
    'cal-all-day': 'Toute la journée',
    'cal-upcoming': 'À venir',
    'cal-events': 'Événements',
    'cal-earlier': 'Plus tôt',
    'cal-nothing-scheduled': 'Rien de prévu',
    'cal-add-event': 'Ajouter un événement',
    'cal-no-events': 'Aucun événement',
    'cal-one-event': '1 événement',
    'cal-n-events': '{n} événements',
    'cal-n-timed': '{n} avec heure',
    'cal-n-all-day': '{n} toute la journée',
    'cal-n-celebrations': '{n} célébrations',
    'cal-across-days': 'sur ces jours',
    'cal-dur-minutes': '{n} min',
    'cal-dur-hours': '{n} h',
    'cal-dur-hours-minutes': '{h} h {m} min',
    'cal-dur-days': '{n} jours',
    'cal-error-loading': 'Erreur de chargement des événements',
    'cal-share-premium-header': 'Le partage de calendriers est une fonctionnalité premium',
    'cal-share-premium-description': 'Pour partager des calendriers, vous devez être un utilisateur premium.',
    'cal-create-premium-header': 'La création d’événements est une fonctionnalité premium',
    'cal-create-premium-description': 'Pour créer ou modifier des événements, vous devez être un utilisateur premium.',
    shared_calendar: 'Partagé',
    birthdays: 'Anniversaires',
    work_anniversaries: 'Anniversaires d’embauche',
    // ScoreCard
    scorecards: 'Fiches de rendement',
    'please-contact-org-admin':
      'Veuillez communiquer avec l’administrateur de votre organisation pour créer une fiche de rendement.',
    mtd: 'CMJ',
    'last-month': 'Mois dernier',
    ytd: 'CAJ',
    color: 'Couleur',
    'scorecard-setting': 'Paramètres de la fiche de rendement',
    settings: 'Paramètres',
    delete: 'Supprimer',
    'delete-scorecard': 'Supprimer la fiche de rendement',
    'are-you-sure':
      'Voulez-vous vraiment supprimer cette fiche de rendement? Cette action est irréversible.',
    'avg-goal': 'Objectif moyen',
    diff: 'Écart',
    // TH Dashboard - Insights
    'did-you-know': 'Le saviez-vous?',
    'employee-requests': 'Demandes des employés',
    waste: 'Pertes',
    'closing-hours': 'Heures de fermeture',
    // WasteInsight template
    'waste-insight-text':
      '{dateText}, vous avez {count} {storeWord} pour lesquels il manque au moins {threshold} {dayWord} de pertes enregistrées',
    'store-singular': 'restaurant',
    'store-plural': 'restaurants',
    'day-singular': 'jour',
    'day-plural': 'jours',
    // ClosingHourInsight template
    'closing-hour-insight-text':
      '{dateText}, vous avez {lobbyCount} salles à manger et {dtCount} services au volant où la dernière transaction précède l’heure de fermeture de {threshold} minutes ou plus',
    // TH Dashboard - Today
    today: 'Aujourd’hui',
    'current-day-sales': 'Ventes du jour',
    'current-day-service': 'Service du jour',
    'current-day-updates-around': 'Les données du jour sont mises à jour vers {time}',
    // TH Dashboard - Snapshot
    snapshot: 'Aperçu instantané',
    'dayparts-sales': 'Ventes par période de la journée',
    'dayparts-service': 'Service par période de la journée',
    'open-11am': 'Ouverture - 11 h',
    '11am-close': '11 h - fermeture',
    'service-times': 'Temps de service',
    // TH CurrentDaySales / SalesWidget rows
    'th-row-net-sales': 'Ventes nettes',
    'th-row-transactions': 'Transactions',
    'th-row-refund-transactions': 'Transactions remboursées',
    'th-row-eat-in-trans': 'Trans sur place',
    'th-row-eat-in-refund-trans': 'Trans remboursées sur place',
    'th-row-take-out-trans': 'Trans pour emporter',
    'th-row-take-out-refund-trans': 'Trans remboursées pour emporter',
    'th-row-drive-thru-trans': 'Trans service au volant',
    'th-row-drive-thru-refund-trans': 'Trans remboursées service au volant',
    'th-row-delivery-trans': 'Trans livraison',
    'th-row-delivery-refund-trans': 'Trans remboursées livraison',
    'th-row-kiosk-trans': 'Trans borne',
    'th-row-kiosk-refund-trans': 'Trans remboursées borne',
    'th-row-mobile-take-out-trans': 'Trans pour emporter mobile',
    'th-row-mobile-take-out-refund-trans': 'Trans remboursées pour emporter mobile',
    'th-row-mobile-drive-thru-trans': 'Trans service au volant mobile',
    'th-row-mobile-drive-thru-refund-trans': 'Trans remboursées service au volant mobile',
    'th-row-refund-sales': 'Ventes remboursées',
    'th-row-avg-check': 'Facture moyenne',
    'th-row-eat-in-net-sales': 'Ventes nettes sur place',
    'th-row-eat-in-refund-sales': 'Ventes remboursées sur place',
    'th-row-eat-in-avg-check': 'Facture moyenne sur place',
    'th-row-take-out-net-sales': 'Ventes nettes pour emporter',
    'th-row-take-out-refund-sales': 'Ventes remboursées pour emporter',
    'th-row-take-out-avg-check': 'Facture moyenne pour emporter',
    'th-row-drive-thru-net-sales': 'Ventes nettes service au volant',
    'th-row-drive-thru-refund-sales': 'Ventes remboursées service au volant',
    'th-row-drive-thru-avg-check': 'Facture moyenne service au volant',
    'th-row-delivery-net-sales': 'Ventes nettes livraison',
    'th-row-delivery-refund-sales': 'Ventes remboursées livraison',
    'th-row-delivery-avg-check': 'Facture moyenne livraison',
    'th-row-kiosk-net-sales': 'Ventes nettes borne',
    'th-row-kiosk-refund-sales': 'Ventes remboursées borne',
    'th-row-kiosk-avg-check': 'Facture moyenne borne',
    'th-row-mobile-take-out-net-sales': 'Ventes nettes pour emporter mobile',
    'th-row-mobile-take-out-refund-sales': 'Ventes remboursées pour emporter mobile',
    'th-row-mobile-take-out-avg-check': 'Facture moyenne pour emporter mobile',
    'th-row-mobile-delivery-net-sales': 'Ventes nettes livraison mobile',
    'th-row-mobile-delivery-refund-sales': 'Ventes remboursées livraison mobile',
    'th-row-mobile-delivery-avg-check': 'Facture moyenne livraison mobile',
    // TH Service rows
    'th-row-greet-time': 'Temps d’accueil',
    'th-row-order-time': 'Temps de commande',
    'th-row-queue-time': 'Temps d’attente en file',
    'th-row-window-time': 'Temps au guichet',
    'th-row-total-time': 'Temps total',
    // TH SalesWidget (Snapshot) rows
    'th-row-manager-void-amt': 'Mnt annulations gérant',
    'th-row-cash-over-short': 'Excédent/manque de caisse',
    'th-row-canceled-item-amt': 'Mnt articles annulés',
    'th-row-canceled-item-cnt': 'Nb articles annulés',
    'th-row-canceled-order-amt': 'Mnt commandes annulées',
    'th-row-canceled-order-cnt': 'Nb commandes annulées',
    'th-row-manager-void-cnt': 'Nb annulations gérant',
    'th-row-overring-amt': 'Mnt surenregistrements',
    // TH Labor rows
    'th-row-hourly-labor-pct': '% main-d’œuvre horaire',
    'th-row-hourly-labor-hours': 'Heures de main-d’œuvre horaire',
    'th-row-management-labor-pct': '% main-d’œuvre gestion',
    'th-row-hourly-labor-dollar': 'Main-d’œuvre horaire $',
    'th-row-salaried-labor-hours': 'Heures de main-d’œuvre salariée',
    'th-row-total-labor-pct': '% main-d’œuvre totale',
    'th-row-proj-labor-guide': 'Guide de main-d’œuvre prévu',
    'th-row-total-labor-hours': 'Heures totales de main-d’œuvre',
    'th-row-training-hours': 'Heures de formation',
    'th-row-labor-cost': 'Coût de la main-d’œuvre',
    'th-row-trans-per-labor-hour': 'Trans / heure de main-d’œuvre',
    'th-row-act-labor-guide-hours': 'Heures guides de main-d’œuvre réelles',
    'th-row-adj-proj-hours': 'Heures prév. ajust. +/-',
    'th-row-avg-hourly-rate': 'Taux horaire moyen',
    // TH Shared headers
    'plus-minus': '+/-',
    // TH Main section titles
    controls: 'Contrôles',
    'shared-links': 'Liens partagés',
    'file-manager': 'Gestionnaire de fichiers',
    'assumed-role': 'Rôle assumé',
    forms: 'Formulaires',
    // MT dashboard Forms section (components/multiClient/dashboard/forms)
    // MT dashboard Equipment section (components/multiClient/dashboard/equipment)
    'equip-tickets': 'Tickets',
    'equip-reported': 'Signalés',
    'equip-accepted': 'Acceptés',
    'equip-in-progress': 'En cours',
    'equip-assigned': 'Assignés',
    'equip-on-hold': 'En attente',
    'equip-unassigned': 'Non assignées',
    'equip-scheduled': 'Planifiées',
    'equip-past-due': 'En retard',
    'equip-resolution': 'Résolution',
    'equip-completion': 'Achèvement',
    'equip-next-due': 'Prochaine tâche due le {date}',
    'equip-no-tasks-due': 'Aucune tâche à venir',
    'equip-time-left-hint': '{time} restant',
    'equip-error-loading': 'Erreur de chargement des données d’équipement',
    'equip-new-ticket': 'Nouveau ticket',
    'equip-refresh': 'Actualiser',
    'equip-all-tickets': 'Tous les tickets',
    'equip-my-tickets-link': 'Mes tickets',
    'equip-maintenance-link': 'Maintenance',
    'equip-my-tasks-link': 'Mes tâches',
    'equip-selected-locations': 'Emplacements sélectionnés',
    'equip-you': 'Vous',
    'equip-my-tickets-maintenance': 'Mes tickets et maintenance',
    'equip-all-tickets-maintenance': 'Tous les tickets et maintenance',
    'equip-everyone': 'Tous',
    'equip-maintenance': 'Maintenance',
    'equip-open-count': '{n} ouverts',
    'equip-task-count': '{n} tâches',
    'equip-reported-lc': 'signalés',
    'equip-in-progress-lc': 'en cours',
    'equip-unassigned-lc': 'non assignées',
    'equip-past-due-lc': 'en retard',
    // Resource Library (File Manager shortcuts) on the MT home dashboard
    'fm-resources': 'Ressources',
    'fm-folders': 'Dossiers',
    'fm-files': 'Fichiers',
    'fm-open-resource-library': 'Ouvrir la bibliothèque de ressources',
    'fm-refresh': 'Actualiser',
    'fm-download': 'Télécharger',
    'fm-remove-shortcut': 'Retirer le raccourci',
    'fm-scroll-left': 'Défiler vers la gauche',
    'fm-scroll-right': 'Défiler vers la droite',
    'fm-n-items': '{n} éléments',
    'fm-added': 'Ajouté le {date}',
    'fm-n-shortcuts': '{n} raccourcis',
    'fm-no-folders': 'Aucun raccourci de dossier',
    'fm-no-files': 'Aucun raccourci de fichier',
    'fm-empty': 'Aucun raccourci de dossier ou de fichier pour le moment. Marquez des éléments d’une étoile dans le gestionnaire de fichiers et ils apparaîtront ici.',
    'fm-add-shortcuts': 'Ajouter des raccourcis',
    'fm-error': 'Erreur lors du chargement des raccourcis',
    'forms-favorites': 'Favoris',
    'forms-in-progress': 'En cours',
    'forms-error-loading': 'Erreur de chargement des formulaires',
    retry: 'Réessayer',
    'forms-manage-favorites': 'Gérer les favoris',
    'forms-no-favorites-title': 'Aucun favori pour le moment',
    'forms-no-favorites-hint':
      'Appuyez sur l’engrenage pour ajouter les formulaires que vous utilisez le plus.',
    'forms-nothing-in-progress-title': 'Rien en cours. Bravo!',
    'forms-nothing-in-progress-hint':
      'Les formulaires que vous commencez apparaîtront ici pour que vous puissiez les reprendre.',
    'forms-started': 'Commencé {when}',
    'forms-continue': 'Continuer',
    'forms-percent-complete': '{pct} % terminé',
    'forms-open-form': 'Ouvrir {title}',
    equipment: 'Équipement',
    // Standard main section titles
    'snapshot-month': 'Aperçu du mois',
    // Calendar
    'view-calendar': 'Voir le calendrier',
    'calendar-options': 'Options du calendrier',
    // TH Budget rows
    'th-row-total-labor-dollars': 'Total de la main-d’œuvre en dollars',
    'th-row-food-cost': 'Coût des aliments',
    'th-row-food-cost-pct': '% coût des aliments',
    'th-row-annual-salary': 'Salaire annuel',
    'th-row-crew-dollars': 'Équipiers en dollars',
    'th-row-crew-labor-pct': '% main-d’œuvre équipiers',
    'th-row-manager-labor-pct': '% main-d’œuvre gérants',
    // TH Food rows
    'th-row-adj-theo-food-cost-pct': '% coût théorique des aliments ajusté',
    'th-row-food-var-pct': '% écart aliments',
    'th-row-total-waste-pct': '% pertes totales',
    'th-row-total-cost': 'Coût total',
    'th-row-paper-cost': 'Coût du papier',
    'th-row-other-cost': 'Coût autres',
    'th-row-total-var-cost': 'Coût de l’écart total',
    'th-row-food-var-cost': 'Coût de l’écart aliments',
    'th-row-paper-var-cost': 'Coût de l’écart papier',
    'th-row-other-var-cost': 'Coût de l’écart autres',
    'th-row-total-waste-cost': 'Coût des pertes totales',
    'th-row-total-cost-pct': '% coût total',
    'th-row-paper-cost-pct': '% coût du papier',
    'th-row-other-cost-pct': '% coût autres',
    'th-row-total-var-pct': '% écart total',
    'th-row-paper-var-pct': '% écart papier',
    'th-row-other-var-pct': '% écart autres',
    'th-row-theo-food-cost-pct': '% coût théorique des aliments',
    'th-row-gap-variance-pct': '% écart d’intervalle',
    // TH DayPart Sales rows
    'th-row-daypart-sales': 'Ventes',
    'th-row-daypart-avg-chk': 'Facture moy.',
    'th-row-daypart-tcs': 'TC',
    'th-row-daypart-dt-sales': 'Ventes SV',
    'th-row-daypart-dt-avg-chk': 'Facture moy. SV',
    'th-row-daypart-dt-tcs': 'TC SV',
    'th-row-daypart-lobby-sales': 'Ventes salle à manger',
    'th-row-daypart-lobby-avg-chk': 'Facture moy. salle à manger',
    'th-row-daypart-lobby-tcs': 'TC salle à manger',
    // CompTypeSelector
    'trading': 'Exercice commercial',
    // Security / Insights
    'error-loading-data': 'Erreur de chargement des données',
    'security-events': 'Événements',
    'security-locations': 'Emplacements',
    'security-employees': 'Employés',
    'security-drill-down': 'Analyse de sécurité',


    // Insight Settings dialog
    'insight-settings-title': 'Paramètres des analyses',
    'insight-settings-insight': 'Analyse',
    'insight-settings-insights': 'Analyses',
    'insight-settings-for': 'Paramètres – {name}',
    'insight-settings-watch-lists': 'Listes de surveillance',
    'insight-settings-threshold': 'Seuil',
    'insight-settings-minutes-threshold': 'Seuil en minutes',
    'insight-settings-waste-threshold': 'Seuil de gaspillage',
    'insight-settings-days-missed-limit': 'Limite de jours manqués',
    'insight-settings-modified-punches': 'Pointages modifiés',
    'widget-settings-select-card-color': 'Sélectionner la couleur de la carte',

    // Security Drill Down date tabs
    'security-date-today': 'Auj.',
    'security-date-yest': 'Hier',
    'security-date-wtd': 'SEC',
    'security-date-lw': 'SD',
    'security-date-custom-range': 'Plage de dates personnalisée',
    'security-date-exceeds-max-range':
      'Dépasse la plage maximale de {days} jours',

    'top-events': 'Principaux événements',
    'top-locations': 'Principaux emplacements',
    'top-cashiers': 'Principaux caissiers',
    'top-managers': 'Principaux gérants',
    'security-drill-down-title': 'Analyse de sécurité',
    'security-drill-down-event-selection': 'Sélection des événements',
    'security-drill-down-max-events': "Sélectionnez jusqu'à {max} événements",
    'security-drill-down-customize-events': 'Personnaliser les événements',
    'security-drill-down-search-events': 'Événement',
    'security-drill-down-includes': 'Comprend :',
    'security-drill-down-coupon-letter': 'Coupon {letter}',
    'security-drill-down-events-auto': 'Les {max} premiers par $',
    'security-drill-down-events-choose': 'Choisir les événements',
    'security-drill-down-order-value': 'Trier par $',
    'security-drill-down-order-custom': 'Ordre personnalisé',
    // the event names Security Events uses
    'security-drill-down-event-cash_refund': 'Remboursement en espèces',
    'security-drill-down-event-cashless_refund': 'Remboursement sans espèces',
    'security-drill-down-event-pos_overring': 'Sur-enregistrement POS',
    'security-drill-down-event-t_red_before': 'T-Red Avant',
    'security-drill-down-event-t_red_after': 'T-Red Après',
    'security-drill-down-event-total_order_promo': 'Promo de Commande Totale',
    'security-drill-down-event-other_promo': 'Autre Promo',
    'security-drill-down-event-mobile_promo': 'Promo Mobile',
    'security-drill-down-event-delivery_promo': 'Promo de Livraison',
    'security-drill-down-event-all_promo': 'Toutes les Promos',
    'security-drill-down-event-pos_auto_discount': 'Remise Automatique POS',
    'security-drill-down-event-mobile_discount': 'Remise Mobile',
    'security-drill-down-event-other_discount': 'Autre Remise',
    'security-drill-down-event-all_discount': 'Toutes les Remises',
    'security-drill-down-event-coupon': 'Coupons',
    'security-drill-down-event-employee_meal': 'Repas des Employés',
    'security-drill-down-event-manager_meal': 'Repas des Gérants',
    'security-drill-down-event-duplicate_card_swipe': 'Glissement de Carte en Double',
    'security-drill-down-event-high_lock_out': 'Verrouillage pour Montant Élevé',
    'security-drill-down-event-high_lock_out_tender': 'Verrouillage pour Montant Élevé (Paiement)',
    'security-drill-down-event-billable_sales': 'Ventes Facturables',
    'security-drill-down-event-electronic_benefit_transfer': 'Transfert Électronique de Prestations (EBT)',
    'cashiers': 'Caissiers',
    'managers': 'Gérants',
    // SecurityTable
    'transactions': 'TRANSACTIONS',
    'activity-label': 'Activité',
    'date-header': 'Date',
    'time-header': 'Heure',
    'daypart-header': 'Période de la journée',
    'register-header': 'Caisse',
    'crew-header': 'Équipier',
    'manager-header': 'Gérant',
    'mgr-code-header': "Type d'autorisation du gérant",
    'details-header': 'Voir le détail',
    'camera-header': 'Caméra',
    'event-time-header': "Heure de l'événement",
    'amount-header': 'Montant',
    'remaining-amount-header': 'Montant restant',
    'not-applicable-value': 'S.O.',
    'unavailable-value': 'Non disponible',
    'tender-type-header': 'Mode de paiement',
    'loyalty-id-header': 'ID fidélité',
    'event-type-header': 'Type',
    'activity-type-header': 'Type d’activité',
    'promo-type-header': 'Type de promo',
    'discount-type-header': 'Type de rabais',
    'billable-org-header': 'Organisation facturable',
    'lockout-type-header': 'Type de verrouillage',
    'item-count-header': 'Nombre d’articles',
    'coupon-type-header': 'Type de coupon',
    'overring-amount-header': 'Montant du surenregistrement',
    'reduction-amount-header': 'Montant de la réduction',
    'discount-amount-header': 'Montant du rabais',
    'promo-amount-header': 'Montant de la promo',
    'refund-amount-header': 'Montant du remboursement',
    'data-failed-to-load': 'Le chargement des données a échoué. Veuillez réessayer.',
    'tender-cash': 'Comptant',
    'tender-cashless': 'Sans comptant',
    'tender-us$_cashless': 'Sans comptant $ US',
    'tender-gift_card': 'Carte-cadeau',
    'tender-no_tender': 'Aucun paiement',
    'tender-billable_sales': 'Ventes facturables',
    'tender-other': 'Autre',
    'mgr_auth_code': 'code de gérant',
    'mgr_auth_biometrics': 'biométrie',
    // Security event token labels
    'cash_refund': 'Remboursement comptant',
    'cashless_refund': 'Remboursement sans comptant',
    'pos_overring': 'Surenregistrement PDV',
    'other_promo': 'Autre promo',
    'total_order_promo': 'Promo totale',
    'total_promo': 'Promo totale',
    'billable_sales': 'Ventes facturables',
    'drawer_open': 'Ouverture de tiroir',
    'general_drawer_open': 'Ouverture de tiroir générale',
    't_red_before': 'Réduction de transaction avant',
    't_red_after': 'Réduction de transaction après',
    'mobile_discount': 'Rabais mobile',
    'mobile_promo': 'Promo mobile',
    'pos_auto_discount': 'Rabais automatique PDV',
    'other_discount': 'Autre rabais',
    'loyalty_reward_ids': 'Récompense fidélité',
    'employee_meal': 'Repas employé',
    'manager_meal': 'Repas gérant',
    'duplicate_card_swipe': 'Passage de carte en double',
    'coupon': 'Coupon',
    'all_discount': 'Tous les rabais',
    'all_promo': 'Toutes les promos',
    'high_lock_out': 'Verrouillage élevé',
    'high_lock_out_tender': 'Verrouillage élevé – mode de paiement',
    'high_lock_out_amount': 'Verrouillage élevé – montant',
    'high_lock_out_item': 'Verrouillage élevé – article',
    'electronic_benefit_transfer': 'Transfert électronique de prestations (EBT)',
    'delivery_promo': 'Promo livraison',
    'all_events': 'Activités mixtes',
    'event-type-earn': 'Accumulation',
    'event-type-burn': 'Utilisation',
    // SecurityTableSlideUp
    'highlight-info': 'Les rangées surlignées indiquent que le caissier a été modifié dans C&I après le changement de tiroir au PDV lors du décompte du tiroir.',
    // MoreInfo
    'more-info': 'Plus de renseignements',
    'view-insight': 'Voir l’analyse',
    'drawer-open-verbiage': '{cashierName} a eu {eventQuantity} {eventName} le {date} à {location}',
    'general-drawer-open-verbiage': '{managerName} a eu {eventQuantity} {eventName} le {date} à {location}',
    'drawer-open-verbiage-burst': '{cashierName} a eu une série de {eventQuantity} {eventName} le {date} à {location}',
    'other-verbiage': '{cashierName} a eu {eventQuantity} {eventName} totalisant {eventAmount} le {date} à {location}',
    'other-verbiage-burst': '{cashierName} a eu une série de {eventQuantity} {eventName} totalisant {eventAmount} le {date} à {location}',
    'loyalty-reward-ids-verbiage': 'Un identifiant de récompense fidélité a été utilisé {eventQuantity} fois totalisant {eventAmount} le {date} à {location}',
    'extended-over-eight-hours-drawer-open-verbiage-for-cashier': 'Le caissier {cashierName} a enregistré en moyenne {eventQuantity} {eventName}/8 h de PDV au cours des {numOfDays} derniers jours à {location}',
    'extended-over-eight-hours-drawer-open-verbiage-for-cashier-general': 'Le caissier {cashierName} a enregistré en moyenne {eventQuantity} {eventName}/8 h de PDV du {dateRange} à {location}',
    'extended-over-eight-hours-other-verbiage-for-cashier': 'Le caissier {cashierName} a enregistré en moyenne {eventAmount} de {eventName}/8 h de PDV au cours des {numOfDays} derniers jours à {location}',
    'extended-over-eight-hours-other-verbiage-for-cashier-general': 'Le caissier {cashierName} a enregistré en moyenne {eventAmount} de {eventName}/8 h de PDV du {dateRange} à {location}',
    'extended-less-than-eight-hours-drawer-open-verbiage-for-cashier': 'Le caissier {cashierName} a enregistré {eventQuantity} {eventName} en {lessEightHours} h de PDV au cours des {numOfDays} derniers jours à {location} (moins de 8 h)',
    'extended-less-than-eight-hours-drawer-open-verbiage-for-cashier-general': 'Le caissier {cashierName} a enregistré {eventQuantity} {eventName} en {lessEightHours} h de PDV du {dateRange} à {location} (moins de 8 h)',
    'extended-less-than-eight-hours-other-verbiage-for-cashier': 'Le caissier {cashierName} a enregistré {eventAmount} de {eventName} en {lessEightHours} h de PDV au cours des {numOfDays} derniers jours à {location}',
    'extended-less-than-eight-hours-other-verbiage-for-cashier-general': 'Le caissier {cashierName} a enregistré {eventAmount} de {eventName} en {lessEightHours} h de PDV du {dateRange} à {location}',
    'extended-drawer-open-verbiage-for-manager': 'Le gérant {managerName} a approuvé au total {eventQuantity} {eventName} au cours des {numOfDays} derniers jours à {location}',
    'extended-drawer-open-verbiage-for-manager-general': 'Le gérant {managerName} a approuvé au total {eventQuantity} {eventName} du {dateRange} à {location}',
    'extended-other-verbiage-for-manager': 'Le gérant {managerName} a approuvé au total {eventAmount} de {eventName} au cours des {numOfDays} derniers jours à {location}',
    'extended-other-verbiage-for-manager-general': 'Le gérant {managerName} a approuvé au total {eventAmount} de {eventName} du {dateRange} à {location}',
    'data-failed-to-load-support': 'Le chargement des données a échoué. Veuillez réessayer ou communiquer avec le soutien si le problème persiste.',
    // InsightsContainer
    'all-quiet-here': 'Rien à signaler',
    'product-outage': 'Rupture de produit',
    'business-day-close': 'Fermeture de la journée d’exploitation',
    'open-late-close-early': 'Ouverture tardive / fermeture hâtive',
    'minor-exceptions': 'Exceptions - mineurs',
    'product-default': 'Par défaut',
    'product-product-and-inventory': 'Prod/inv',
    'product-people': 'RH',
    'product-shift': 'Quart',
    'product-security': 'Sécurité',
    'employee-request': 'Demandes des employés',
    'suspicious-activity': 'Activité suspecte',
    'rbd': 'RBD',
    'rbd-completed': 'RBD complétés',
    'rbd-activation': 'Activation RBD',
    'rbd-completed-threshold': 'Seuil de RBD complétés',
    'threshold-hint': 'Alerter lorsque des restaurants dépassent ce nombre de RBD complétés en 30 jours (1-10)',
    'potential-ot': 'Temps supp. potentiel',
    'simplethink': 'Premium',
    '30-day-terms': 'Cessations à 30 jours',
    '90-day-terms': 'Cessations à 90 jours',
    'people-terms': 'Cessations RH',
    'last-thirty-days': '30 derniers jours',
    'trailing-365-days': '365 derniers jours',
    'trailing-thirty-days': '30 derniers jours glissants',
    'yesterday': 'Hier',
    'this-week': 'Cette semaine',
    'last-week': 'Semaine dernière',
    'this-month': 'Ce mois-ci',
    'last-seven-days': '7 derniers jours',
    'modified-punches': 'Poinçons modifiés',
    'store-alerts': 'Alertes du restaurant',
    'store-notifications': 'Notifications du restaurant', // TODO translation review
    'product-candi': 'C&I',
    'waste-entry': 'Saisie des pertes',
    'stat-inventory': 'Statistiques d’inventaire',
    // OLCEInsight
    'open-late-message': `<strong>{count}</strong> restaurant pourrait avoir enregistré <strong>{daysThreshold}</strong> ouvertures tardives ou plus au cours des 7 derniers jours. | <strong>{count}</strong> restaurants pourraient avoir enregistré <strong>{daysThreshold}</strong> ouvertures tardives ou plus au cours des 7 derniers jours.`,
    'close-early-message': `<strong>{count}</strong> restaurant pourrait avoir enregistré <strong>{daysThreshold}</strong> fermetures hâtives ou plus au cours des 7 derniers jours. | <strong>{count}</strong> restaurants pourraient avoir enregistré <strong>{daysThreshold}</strong> fermetures hâtives ou plus au cours des 7 derniers jours.`,
    // Shift Runner Scorecard
    'sms-shift-runner-scorecard': 'Fiche de rendement du chef de quart',
    'sms-shift-scorecard': 'Fiche de rendement du quart',
    'sms-no-data': 'Aucune donnée',
    'sms-overall': 'Global',
    'sms-shift-prep': 'Préparation du quart',
    'sms-shift-operational-metrics': 'Métriques d’exploitation du quart - vs objectif',
    'sms-shift-runner': 'Chef de quart',
    'sms-shifts': 'Quarts',
    'sms-score': 'Score',
    'sms-pre-shift-checklist': 'Liste de vérification avant quart',
    'sms-travel-path': 'Parcours',
    'sms-oepe-w-o': 'OEPE sans stationnement',
    'sms-r2p': 'R2P',
    'sms-kvs-time-per-gc': 'Temps KVS par client',
    'sms-kvs-healthy-usage': 'Utilisation saine du KVS',
    'food-safety-completed': 'Complétés',
    'food-safety-passed-failed': '{passed} réussis · {failed} échoués',
    'food-safety-equipment-issues': "Problèmes d'équipement",
    'food-safety-completed-forms': 'Formulaires complétés',
    'food-safety-no-equipment-issues': "Aucun problème d'équipement",
    'food-safety-unknown-equipment': 'Équipement inconnu',
    'food-safety-no-location': 'Aucun emplacement',
    'food-safety-exceptions': 'Exceptions',
    'food-safety-view-report': 'Voir le rapport',
    'food-safety-load-error': 'Erreur lors du chargement des données de salubrité alimentaire',
    'food-safety-no-forms': "Aucun formulaire de salubrité alimentaire n'est configuré pour cette organisation",
    'food-safety-thresholds': 'Seuils de salubrité alimentaire',
    'food-safety-thresholds-description':
      "Définissez le taux de réussite requis pour chaque couleur. Ces seuils s'appliquent à toute votre organisation.",
    'food-safety-green-at': 'Vert à partir de',
    'food-safety-yellow-at': 'Jaune à partir de',
    'food-safety-legend-green': 'Vert : {value} % et plus',
    'food-safety-legend-yellow': 'Jaune : de {low} % à moins de {high} %',
    'food-safety-legend-red': 'Rouge : moins de {value} %',
    'food-safety-percent-rule': 'Entrez une valeur de 0 à 100',
    'food-safety-yellow-rule': 'Doit être inférieur ou égal au seuil vert',
    'food-safety-thresholds-save-error': "Impossible d'enregistrer les seuils. Veuillez réessayer.",
    'food-safety-insight-completed':
      '<strong>{count}</strong> formulaire de salubrité alimentaire complété {period} | <strong>{count}</strong> formulaires de salubrité alimentaire complétés {period}',
    'food-safety-insight-pass-rate': '{rate} réussis',
    'food-safety-insight-equipment':
      "<strong>{count}</strong> problème d'équipement : | <strong>{count}</strong> problèmes d'équipement :",
    'food-safety-and-more': '+{count} de plus',
    'food-safety-equipment': 'Équipement',
    'food-safety-date-time': 'Date/heure',
    'food-safety-store': 'Emplacement',
    'food-safety-form': 'Formulaire',
    'food-safety-completed-at': 'Complété le',
    'food-safety-completed-by': 'Complété par',
    'food-safety-status': 'Statut',
    'food-safety-status-passed': 'Réussi',
    'food-safety-status-failed': 'Échoué',
    'food-safety-type': 'Type',
    'food-safety-type-safety': 'Sécurité',
    'food-safety-type-quality': 'Qualité',
    'food-safety-type-calibration': 'Étalonnage',
    'food-safety-temperature': 'Temp.',
    'food-safety-target': 'Cible',
    'food-safety-product': 'Produit',
    'food-safety-corrective-action': 'Mesure corrective',
  },
};
